// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/outfit/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/outfit/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/outfit/600.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/outfit/700.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/dm-sans/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/dm-sans/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@fontsource/dm-sans/600.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.animate-slide-in {
  animation: slideIn 0.3s ease-out forwards;
}

.animate-slide-in-left {
  animation: slideInLeft 0.3s ease-out forwards;
}

.animate-slide-in-right {
  animation: slideInRight 0.3s ease-out forwards;
}

.animate-slide-up {
  animation: slideUp 0.35s ease-out forwards;
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

.animate-spin {
  animation: spin 0.8s linear infinite;
}

.animate-pulse {
  animation: pulse 2s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.app-shell {
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  background: #f8fafc;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  height: 100dvh;
  width: 260px;
  z-index: 50;
  transform: translateX(-100%);
  transition: transform 0.3s ease, width 0.3s ease;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-right: 1px solid rgba(226, 232, 240, 0.6);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .sidebar {
    scrollbar-width: none;
  }
  .sidebar::-webkit-scrollbar {
    display: none;
  }
}
@media (hover: hover) and (pointer: fine) {
  .sidebar {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  .sidebar::-webkit-scrollbar {
    width: 6px;
  }
  .sidebar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .sidebar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .sidebar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
.sidebar {
  padding-bottom: env(safe-area-inset-bottom);
}
.sidebar.open {
  transform: translateX(0);
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(15, 23, 42, 0.06);
}
@media (min-width: 768px) {
  .sidebar {
    position: sticky;
    transform: translateX(0);
    width: 72px;
    flex-shrink: 0;
    box-shadow: none;
  }
  .sidebar.expanded {
    width: 260px;
  }
  .sidebar .sidebar__label,
  .sidebar .sidebar__section-title {
    opacity: 0;
    pointer-events: none;
    width: 0;
    overflow: hidden;
    white-space: nowrap;
    transition: opacity 0.3s ease, width 0.3s ease;
  }
  .sidebar.expanded .sidebar__label,
  .sidebar.expanded .sidebar__section-title {
    opacity: 1;
    pointer-events: auto;
    width: auto;
  }
}
@media (min-width: 1024px) {
  .sidebar {
    width: 260px;
  }
  .sidebar .sidebar__label,
  .sidebar .sidebar__section-title {
    opacity: 1;
    pointer-events: auto;
    width: auto;
  }
}

.sidebar__nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 1rem;
  border-radius: 1rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  min-height: 44px;
  text-decoration: none;
}
.sidebar__nav-item:hover {
  background: #f8fafc;
  color: #0f172a;
}
.sidebar__nav-item.active {
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
}
.sidebar__nav-item svg {
  flex-shrink: 0;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 40;
  animation: fadeIn 0.2s ease-out;
}
.sidebar-overlay.active {
  display: block;
}
@media (min-width: 768px) {
  .sidebar-overlay {
    display: none !important;
  }
}

.mobile-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 30;
  height: 56px;
  padding: 0 1rem;
  padding-left: max(1rem, env(safe-area-inset-left));
  padding-right: max(1rem, env(safe-area-inset-right));
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid #e2e8f0;
}
@media (min-width: 768px) {
  .mobile-topbar {
    display: none;
  }
}
.mobile-topbar__logo {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: 1.125rem;
  color: #0f172a;
}
.mobile-topbar__hamburger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 0.75rem;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #334155;
  transition: background 0.2s ease;
}
.mobile-topbar__hamburger:hover {
  background: #f1f5f9;
}

.main-content {
  flex: 1 1;
  min-width: 0;
  overflow-x: hidden;
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
}
@media (min-width: 768px) {
  .main-content {
    padding-bottom: 0;
  }
}

.page-wrapper {
  padding: clamp(0.5rem, 2vw, 1rem);
}
@media (min-width: 640px) {
  .page-wrapper {
    padding: clamp(1rem, 3vw, 1.5rem);
  }
}
@media (min-width: 1024px) {
  .page-wrapper {
    padding: clamp(1.5rem, 4vw, 2.5rem);
  }
}

.page-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: clamp(1.5rem, 4vw, 2rem);
}
@media (min-width: 640px) {
  .page-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.page-header__title-group {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1rem);
}
.page-header__icon {
  width: clamp(2.5rem, 6vw, 3.5rem);
  height: clamp(2.5rem, 6vw, 3.5rem);
  border-radius: 1.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-header__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  margin: 0;
}
.page-header__subtitle {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0.125rem 0 0;
}
.page-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 639px) {
  .page-header__actions {
    width: 100%;
  }
  .page-header__actions > * {
    flex: 1 1;
  }
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: calc(60px + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid #e2e8f0;
}
@media (min-width: 768px) {
  .bottom-nav {
    display: none;
  }
}
.bottom-nav__item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-height: 48px;
  font-size: 0.62rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: pointer;
  border: none;
  background: transparent;
  transition: color 0.2s ease;
  text-decoration: none;
}
.bottom-nav__item svg {
  width: 22px;
  height: 22px;
}
.bottom-nav__item.active {
  color: #6366f1;
}

.container-responsive {
  width: 100%;
  padding-left: clamp(1rem, 4vw, 2rem);
  padding-right: clamp(1rem, 4vw, 2rem);
  margin: 0 auto;
  max-width: 1440px;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.btn-primary:active {
  transform: scale(0.97);
}
.btn-primary {
  padding: 0.625rem 1.25rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border-radius: 9999px;
  background: #6366f1;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
}
@media (min-width: 640px) {
  .btn-primary {
    padding: 0.75rem 1.5rem;
    font-size: clamp(0.875rem, 2.5vw, 1rem);
  }
}
@media (hover: hover) and (pointer: fine) {
  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.btn-secondary:active {
  transform: scale(0.97);
}
.btn-secondary {
  padding: 0.625rem 1.25rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border-radius: 9999px;
  background: #ffffff;
  color: #334155;
  border: 1.5px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
}
@media (min-width: 640px) {
  .btn-secondary {
    padding: 0.75rem 1.5rem;
    font-size: clamp(0.875rem, 2.5vw, 1rem);
  }
}
@media (hover: hover) and (pointer: fine) {
  .btn-secondary:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }
}

.btn-gradient {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.btn-gradient:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.btn-gradient:active {
  transform: scale(0.97);
}
.btn-gradient {
  padding: 0.625rem 1.25rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border-radius: 9999px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
}
@media (min-width: 640px) {
  .btn-gradient {
    padding: 0.75rem 1.5rem;
    font-size: clamp(0.875rem, 2.5vw, 1rem);
  }
}
@media (hover: hover) and (pointer: fine) {
  .btn-gradient:hover {
    background: linear-gradient(135deg, #4f46e5, #7c3aed);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }
}

.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.btn-icon:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.btn-icon:active {
  transform: scale(0.97);
}
.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  background: transparent;
  border: none;
  color: #475569;
  transition: background 0.2s ease, color 0.2s ease;
}
.btn-icon:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.btn-full-mobile {
  width: 100%;
}
@media (min-width: 640px) {
  .btn-full-mobile {
    width: auto;
  }
}

.input-primary {
  width: 100%;
  height: 44px;
  padding: 0 1rem;
  border-radius: 1rem;
  border: 1.5px solid transparent;
  background: #f8fafc;
  font-family: "DM Sans", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #334155;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  appearance: none;
}
@media (min-width: 640px) {
  .input-primary {
    height: 48px;
  }
}
.input-primary:focus {
  outline: none;
  background: #ffffff;
  border-color: #6366f1;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}
.input-primary::placeholder {
  color: #94a3b8;
}
.input-primary.is-error {
  border-color: #fca5a5;
}
.input-primary.is-error:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

.input-primary.textarea {
  height: auto;
  min-height: 100px;
  padding: 0.75rem 1rem;
  resize: vertical;
}

.input-password-wrap {
  position: relative;
}
.input-password-wrap input {
  padding-right: 3rem;
}
.input-password-wrap__toggle {
  position: absolute;
  right: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: unset;
}
.input-password-wrap__toggle:hover {
  color: #475569;
}

.badge-connected {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
@media (min-width: 768px) {
  .badge-connected {
    padding: 0.25rem 0.75rem;
  }
}
.badge-connected {
  background: #dcfce7;
  color: #15803d;
}

.badge-draft {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
@media (min-width: 768px) {
  .badge-draft {
    padding: 0.25rem 0.75rem;
  }
}
.badge-draft {
  background: #fef9c3;
  color: #a16207;
}

.badge-published {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
@media (min-width: 768px) {
  .badge-published {
    padding: 0.25rem 0.75rem;
  }
}
.badge-published {
  background: #dbeafe;
  color: #1d4ed8;
}

.badge-scheduled {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
@media (min-width: 768px) {
  .badge-scheduled {
    padding: 0.25rem 0.75rem;
  }
}
.badge-scheduled {
  background: #ede9fe;
  color: #6d28d9;
}

.badge-failed {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
@media (min-width: 768px) {
  .badge-failed {
    padding: 0.25rem 0.75rem;
  }
}
.badge-failed {
  background: #fef2f2;
  color: #dc2626;
}

.stat-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
@media (hover: hover) and (pointer: fine) {
  .stat-card:hover {
    border-color: #e0e7ff;
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1), 0 2px 8px rgba(15, 23, 42, 0.06);
  }
}
.stat-card__label {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #64748b;
  margin: 0 0 0.25rem;
}
.stat-card__value {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
}
.stat-card__change {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.5rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
}
.stat-card__change--positive {
  color: #16a34a;
}
.stat-card__change--negative {
  color: #dc2626;
}
.stat-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}
.stat-card:hover .stat-card__icon {
  transform: scale(1.1);
}

.stat-card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(0.75rem, 2vw, 1.25rem);
}
@media (min-width: 480px) {
  .stat-card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .stat-card-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.platform-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
@media (hover: hover) and (pointer: fine) {
  .platform-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1), 0 2px 8px rgba(15, 23, 42, 0.06);
  }
}
@media (hover: none) and (pointer: coarse) {
  .platform-card:active {
    transform: scale(0.97);
    opacity: 0.9;
  }
}

.platform-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(0.75rem, 2vw, 1rem);
}
@media (min-width: 480px) {
  .platform-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 768px) {
  .platform-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1024px) {
  .platform-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1280px) {
  .platform-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

.platform-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(1.75rem, 5vw, 2.25rem);
  height: clamp(1.75rem, 5vw, 2.25rem);
  border-radius: 9999px;
  flex-shrink: 0;
}

.metric-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  transition: box-shadow 0.2s ease;
}
@media (hover: hover) and (pointer: fine) {
  .metric-card:hover {
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1), 0 2px 8px rgba(15, 23, 42, 0.06);
  }
}
.metric-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: flex-start;
}
.metric-card__label {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #64748b;
  margin: 0 0 0.25rem;
}
.metric-card__value {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
}
.metric-card__change {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.5rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
}
.metric-card__change--up {
  color: #16a34a;
}
.metric-card__change--down {
  color: #dc2626;
}
.metric-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  flex-shrink: 0;
}

.spinner {
  border: 3px solid #f1f5f9;
  border-top: 3px solid #6366f1;
  border-radius: 9999px;
  width: 24px;
  height: 24px;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}
.spinner--sm {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
.spinner--lg {
  width: 36px;
  height: 36px;
}

.skeleton {
  border-radius: 0.5rem;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.toast-container {
  position: fixed;
  z-index: 100;
  bottom: calc(60px + env(safe-area-inset-bottom) + 0.5rem);
  left: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  pointer-events: none;
}
@media (min-width: 768px) {
  .toast-container {
    bottom: 1.5rem;
    right: 1.5rem;
    left: auto;
    max-width: 380px;
  }
}

.toast {
  background: #ffffff;
  border-radius: 1.5rem;
  padding: 0.875rem 1rem;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.12), 0 2px 8px rgba(15, 23, 42, 0.06);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  pointer-events: auto;
  animation: slideIn 0.3s ease-out;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-end;
  animation: fadeIn 0.2s ease-out;
}
@media (min-width: 640px) {
  .modal-overlay {
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }
}

.modal-panel {
  width: 100%;
  max-height: 90dvh;
  border-radius: 1.5rem 1.5rem 0 0;
  overflow-y: auto;
  padding: 1.5rem 1rem;
  padding-bottom: max(1.5rem, env(safe-area-inset-bottom));
  background: #ffffff;
  animation: slideUp 0.35s ease-out;
}
@media (min-width: 640px) {
  .modal-panel {
    width: auto;
    min-width: 480px;
    max-width: 640px;
    max-height: 85dvh;
    border-radius: 1.5rem;
    padding: 2rem;
    animation: slideIn 0.3s ease-out;
  }
}

.filter-tabs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}
.filter-tabs__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.filter-tabs__tab:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.filter-tabs__tab:active {
  transform: scale(0.97);
}
.filter-tabs__tab {
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  background: #f1f5f9;
  color: #475569;
  min-height: 38px;
  border: none;
}
@media (hover: hover) and (pointer: fine) {
  .filter-tabs__tab:hover {
    background: #e2e8f0;
  }
}
.filter-tabs__tab.active {
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
}
.filter-tabs__tab__count {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  opacity: 0.75;
}

.date-range-toggle {
  display: flex;
  background: #f1f5f9;
  border-radius: 1rem;
  padding: 0.25rem;
}
.date-range-toggle__btn {
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border: none;
  background: transparent;
  color: #475569;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  min-height: 38px;
}
.date-range-toggle__btn.active {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  color: #4f46e5;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: clamp(2rem, 6vw, 4rem) clamp(1rem, 4vw, 2rem);
}
.empty-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(4rem, 10vw, 5rem);
  height: clamp(4rem, 10vw, 5rem);
  border-radius: 9999px;
  background: #f1f5f9;
  margin-bottom: 1rem;
}
.empty-state__icon svg {
  color: #94a3b8;
}
.empty-state__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.1rem, 3.5vw, 1.25rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem;
}
.empty-state__desc {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0 0 1.5rem;
  max-width: 28rem;
}

.bg-platform-facebook {
  background-color: #1877F2;
}

.text-platform-facebook {
  color: #1877F2;
}

.border-platform-facebook {
  border-color: #1877F2;
}

.bg-platform-light-facebook {
  background-color: rgba(24, 119, 242, 0.12);
}

.bg-platform-twitter {
  background-color: #1DA1F2;
}

.text-platform-twitter {
  color: #1DA1F2;
}

.border-platform-twitter {
  border-color: #1DA1F2;
}

.bg-platform-light-twitter {
  background-color: rgba(29, 161, 242, 0.12);
}

.bg-platform-instagram {
  background-color: #E4405F;
}

.text-platform-instagram {
  color: #E4405F;
}

.border-platform-instagram {
  border-color: #E4405F;
}

.bg-platform-light-instagram {
  background-color: rgba(228, 64, 95, 0.12);
}

.bg-platform-linkedin {
  background-color: #0A66C2;
}

.text-platform-linkedin {
  color: #0A66C2;
}

.border-platform-linkedin {
  border-color: #0A66C2;
}

.bg-platform-light-linkedin {
  background-color: rgba(10, 102, 194, 0.12);
}

.bg-platform-tiktok {
  background-color: #000000;
}

.text-platform-tiktok {
  color: #000000;
}

.border-platform-tiktok {
  border-color: #000000;
}

.bg-platform-light-tiktok {
  background-color: rgba(0, 0, 0, 0.12);
}

.bg-platform-youtube {
  background-color: #FF0000;
}

.text-platform-youtube {
  color: #FF0000;
}

.border-platform-youtube {
  border-color: #FF0000;
}

.bg-platform-light-youtube {
  background-color: rgba(255, 0, 0, 0.12);
}

.bg-platform-pinterest {
  background-color: #E60023;
}

.text-platform-pinterest {
  color: #E60023;
}

.border-platform-pinterest {
  border-color: #E60023;
}

.bg-platform-light-pinterest {
  background-color: rgba(230, 0, 35, 0.12);
}

.bg-platform-snapchat {
  background-color: #FFFC00;
}

.text-platform-snapchat {
  color: #FFFC00;
}

.border-platform-snapchat {
  border-color: #FFFC00;
}

.bg-platform-light-snapchat {
  background-color: rgba(255, 252, 0, 0.12);
}

.bg-platform-reddit {
  background-color: #FF4500;
}

.text-platform-reddit {
  color: #FF4500;
}

.border-platform-reddit {
  border-color: #FF4500;
}

.bg-platform-light-reddit {
  background-color: rgba(255, 69, 0, 0.12);
}

.bg-platform-tumblr {
  background-color: #36465D;
}

.text-platform-tumblr {
  color: #36465D;
}

.border-platform-tumblr {
  border-color: #36465D;
}

.bg-platform-light-tumblr {
  background-color: rgba(54, 70, 93, 0.12);
}

.bg-platform-telegram {
  background-color: #0088CC;
}

.text-platform-telegram {
  color: #0088CC;
}

.border-platform-telegram {
  border-color: #0088CC;
}

.bg-platform-light-telegram {
  background-color: rgba(0, 136, 204, 0.12);
}

.bg-platform-whatsapp_business {
  background-color: #25D366;
}

.text-platform-whatsapp_business {
  color: #25D366;
}

.border-platform-whatsapp_business {
  border-color: #25D366;
}

.bg-platform-light-whatsapp_business {
  background-color: rgba(37, 211, 102, 0.12);
}

.bg-platform-discord {
  background-color: #5865F2;
}

.text-platform-discord {
  color: #5865F2;
}

.border-platform-discord {
  border-color: #5865F2;
}

.bg-platform-light-discord {
  background-color: rgba(88, 101, 242, 0.12);
}

.bg-platform-twitch {
  background-color: #9146FF;
}

.text-platform-twitch {
  color: #9146FF;
}

.border-platform-twitch {
  border-color: #9146FF;
}

.bg-platform-light-twitch {
  background-color: rgba(145, 70, 255, 0.12);
}

.bg-platform-medium {
  background-color: #000000;
}

.text-platform-medium {
  color: #000000;
}

.border-platform-medium {
  border-color: #000000;
}

.bg-platform-light-medium {
  background-color: rgba(0, 0, 0, 0.12);
}

.bg-platform-quora {
  background-color: #B92B27;
}

.text-platform-quora {
  color: #B92B27;
}

.border-platform-quora {
  border-color: #B92B27;
}

.bg-platform-light-quora {
  background-color: rgba(185, 43, 39, 0.12);
}

.bg-platform-vk {
  background-color: #4C75A3;
}

.text-platform-vk {
  color: #4C75A3;
}

.border-platform-vk {
  border-color: #4C75A3;
}

.bg-platform-light-vk {
  background-color: rgba(76, 117, 163, 0.12);
}

.bg-platform-weibo {
  background-color: #E6162D;
}

.text-platform-weibo {
  color: #E6162D;
}

.border-platform-weibo {
  border-color: #E6162D;
}

.bg-platform-light-weibo {
  background-color: rgba(230, 22, 45, 0.12);
}

.bg-platform-threads {
  background-color: #000000;
}

.text-platform-threads {
  color: #000000;
}

.border-platform-threads {
  border-color: #000000;
}

.bg-platform-light-threads {
  background-color: rgba(0, 0, 0, 0.12);
}

.bg-platform-mastodon {
  background-color: #6364FF;
}

.text-platform-mastodon {
  color: #6364FF;
}

.border-platform-mastodon {
  border-color: #6364FF;
}

.bg-platform-light-mastodon {
  background-color: rgba(99, 100, 255, 0.12);
}

.bg-platform-bluesky {
  background-color: #0085FF;
}

.text-platform-bluesky {
  color: #0085FF;
}

.border-platform-bluesky {
  border-color: #0085FF;
}

.bg-platform-light-bluesky {
  background-color: rgba(0, 133, 255, 0.12);
}

.bg-platform-behance {
  background-color: #1769FF;
}

.text-platform-behance {
  color: #1769FF;
}

.border-platform-behance {
  border-color: #1769FF;
}

.bg-platform-light-behance {
  background-color: rgba(23, 105, 255, 0.12);
}

.bg-platform-dribbble {
  background-color: #EA4C89;
}

.text-platform-dribbble {
  color: #EA4C89;
}

.border-platform-dribbble {
  border-color: #EA4C89;
}

.bg-platform-light-dribbble {
  background-color: rgba(234, 76, 137, 0.12);
}

.bg-platform-github {
  background-color: #181717;
}

.text-platform-github {
  color: #181717;
}

.border-platform-github {
  border-color: #181717;
}

.bg-platform-light-github {
  background-color: rgba(24, 23, 23, 0.12);
}

.bg-platform-producthunt {
  background-color: #DA552F;
}

.text-platform-producthunt {
  color: #DA552F;
}

.border-platform-producthunt {
  border-color: #DA552F;
}

.bg-platform-light-producthunt {
  background-color: rgba(218, 85, 47, 0.12);
}

.auth-page {
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  background: #f8fafc;
}
.auth-page__hero {
  display: none;
  position: relative;
  overflow: hidden;
}
@media (min-width: 1024px) {
  .auth-page__hero {
    display: flex;
    flex-direction: column;
    width: 50%;
    flex-shrink: 0;
  }
}
.auth-page__hero img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.auth-page__hero-overlay {
  position: absolute;
  inset: 0;
}
.auth-page__hero-content {
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: clamp(2rem, 5vw, 3rem);
  height: 100%;
}
.auth-page__hero-title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.75rem;
  line-height: 1.2;
}
.auth-page__hero-subtitle {
  font-size: clamp(1rem, 3vw, 1.125rem);
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  max-width: 36rem;
}
.auth-page__form-panel {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1.5rem, 5vw, 3rem);
  overflow-y: auto;
}
.auth-page__form-inner {
  width: 100%;
  max-width: 26rem;
  animation: slideIn 0.35s ease-out;
}
.auth-page__logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
  text-decoration: none;
}
.auth-page__logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  background: linear-gradient(135deg, #6366f1, #8b5cf6, #ec4899);
  flex-shrink: 0;
}
.auth-page__logo-name {
  font-family: "Outfit", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
}
.auth-page__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.375rem;
}
.auth-page__subtitle {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  color: #64748b;
  margin: 0 0 2rem;
}
.auth-page__form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.auth-page__field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.auth-page__label {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #334155;
}
.auth-page__error-msg {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #dc2626;
}
.auth-page__form-error {
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #dc2626;
}
.auth-page__submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.auth-page__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.auth-page__submit:active {
  transform: scale(0.97);
}
.auth-page__submit {
  width: 100%;
  height: 48px;
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  border-radius: 9999px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
  border: none;
  margin-top: 0.5rem;
}
@media (hover: hover) and (pointer: fine) {
  .auth-page__submit:hover {
    background: linear-gradient(135deg, #4f46e5, #7c3aed);
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }
}
.auth-page__submit__spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 9999px;
  animation: spin 0.8s linear infinite;
}
.auth-page__footer {
  margin-top: 1.5rem;
  text-align: center;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
}
.auth-page__footer a {
  font-weight: 600;
  color: #4f46e5;
  text-decoration: none;
}
.auth-page__footer a:hover {
  color: #4338ca;
  text-decoration: underline;
}

.dashboard-welcome {
  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);
}
.dashboard-welcome__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 2.25rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.375rem;
  line-height: 1.15;
}
.dashboard-welcome__subtitle {
  font-size: clamp(1rem, 3vw, 1.125rem);
  color: #64748b;
  margin: 0;
}

.dashboard-stats {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(0.75rem, 2vw, 1.25rem);
  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);
}
@media (min-width: 480px) {
  .dashboard-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .dashboard-stats {
    grid-template-columns: repeat(4, 1fr);
  }
}

.recent-posts-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  overflow: hidden;
}
.recent-posts-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(1rem, 3vw, 1.5rem);
  border-bottom: 1px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.recent-posts-card__header-left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.recent-posts-card__header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 1.5rem;
  background: #eef2ff;
  flex-shrink: 0;
  color: #4f46e5;
}
.recent-posts-card__header-title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-size: clamp(0.875rem, 2.5vw, 1rem);
}
.recent-posts-card__header-sub {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0.125rem 0 0;
}
.recent-posts-card__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem;
}
.recent-posts-card__loader-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid #e2e8f0;
  border-top-color: #6366f1;
  border-radius: 9999px;
  animation: spin 0.8s linear infinite;
}

.post-row {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1rem);
  padding: clamp(0.75rem, 2vw, 1rem) clamp(1rem, 3vw, 1.5rem);
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s ease;
}
.post-row:last-child {
  border-bottom: none;
}
@media (hover: hover) and (pointer: fine) {
  .post-row:hover {
    background: #f8fafc;
  }
}
.post-row__content {
  flex: 1 1;
  min-width: 0;
}
.post-row__text {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #0f172a;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 0 0.25rem;
}
.post-row__meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.post-row__platforms {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.post-row__date {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #94a3b8;
}
.post-row__more {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #64748b;
  margin-left: 0.25rem;
}
.post-row__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
@media (max-width: 479px) {
  .post-row__actions {
    display: none;
  }
}

.posts-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.post-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
@media (hover: hover) and (pointer: fine) {
  .post-card:hover {
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1), 0 2px 8px rgba(15, 23, 42, 0.06);
    border-color: #e0e7ff;
  }
}
.post-card__body {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
@media (min-width: 640px) {
  .post-card__body {
    flex-direction: row;
    align-items: flex-start;
  }
}
.post-card__content {
  flex: 1 1;
  min-width: 0;
}
.post-card__text {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #334155;
  margin: 0 0 0.625rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.post-card__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.post-card__platforms {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}
.post-card__date {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #94a3b8;
}
.post-card__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  flex-wrap: wrap;
}
@media (max-width: 639px) {
  .post-card__actions {
    width: 100%;
  }
}
.post-card__image {
  width: 100%;
  border-radius: 1rem;
  overflow: hidden;
  aspect-ratio: 16/9;
}
@media (min-width: 640px) {
  .post-card__image {
    width: 6rem;
    flex-shrink: 0;
    aspect-ratio: 1;
  }
}
.post-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.post-form-page__header {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1rem);
  margin-bottom: clamp(1.5rem, 4vw, 2rem);
  flex-wrap: wrap;
  gap: 0.75rem;
}
.post-form-page__title-group {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1rem);
}
.post-form-page__icon {
  width: clamp(2.5rem, 6vw, 3.5rem);
  height: clamp(2.5rem, 6vw, 3.5rem);
  border-radius: 1.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.post-form-page__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.5rem, 5vw, 1.875rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.post-form-page__subtitle {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0.125rem 0 0;
}
.post-form-page__card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  padding: clamp(1.25rem, 4vw, 2rem);
  max-width: 42rem;
  width: 100%;
}

.post-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.post-form__field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.post-form__label {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #334155;
}
.post-form__platforms {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 120px), 1fr));
  gap: 0.625rem;
}
.post-form__platform-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  cursor: pointer;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #475569;
  transition: border-color 0.2s ease, background 0.2s ease;
  min-height: 44px;
}
.post-form__platform-btn.selected {
  border-color: #6366f1;
  background: #eef2ff;
  color: #4f46e5;
}
@media (hover: hover) and (pointer: fine) {
  .post-form__platform-btn:hover:not(.selected) {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
}
.post-form__schedule-row {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
@media (min-width: 640px) {
  .post-form__schedule-row {
    flex-direction: row;
    align-items: center;
  }
}
.post-form__submit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #f1f5f9;
}
.post-form__submit-row-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.post-not-found {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  text-align: center;
  padding: clamp(2rem, 6vw, 3.5rem);
  max-width: 28rem;
  margin: 0 auto;
}
.post-not-found__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.25rem, 4vw, 1.5rem);
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.75rem;
}
.post-not-found__desc {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0 0 1.5rem;
}

.analytics-metrics-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(0.75rem, 2vw, 1.25rem);
  margin-bottom: clamp(1.5rem, 4vw, 2rem);
}
@media (min-width: 480px) {
  .analytics-metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1024px) {
  .analytics-metrics-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.analytics-charts-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(1rem, 3vw, 1.5rem);
  margin-bottom: clamp(1.5rem, 4vw, 2rem);
}
@media (min-width: 1024px) {
  .analytics-charts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.chart-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
}
.chart-card__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1.25rem;
  font-size: clamp(1rem, 3vw, 1.125rem);
}
.chart-card__body {
  width: 100%;
  min-height: 200px;
}
@media (min-width: 640px) {
  .chart-card__body {
    min-height: 240px;
  }
}
@media (min-width: 1024px) {
  .chart-card__body {
    min-height: 300px;
  }
}
.chart-card__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 200px;
  color: #94a3b8;
}
@media (min-width: 640px) {
  .chart-card__empty {
    min-height: 240px;
  }
}
@media (min-width: 1024px) {
  .chart-card__empty {
    min-height: 300px;
  }
}

.platform-breakdown {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  margin-bottom: clamp(1.5rem, 4vw, 2rem);
}
.platform-breakdown__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1.25rem;
  font-size: clamp(1rem, 3vw, 1.125rem);
}
.platform-breakdown__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.platform-breakdown__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(0.75rem, 2vw, 1rem);
  border-radius: 1rem;
  background: #f8fafc;
  transition: background 0.2s ease;
  flex-wrap: wrap;
  gap: 0.75rem;
}
@media (hover: hover) and (pointer: fine) {
  .platform-breakdown__row:hover {
    background: #f1f5f9;
  }
}
.platform-breakdown__row-left {
  display: flex;
  align-items: center;
  gap: clamp(0.75rem, 2vw, 1rem);
}
.platform-breakdown__name {
  font-weight: 600;
  color: #0f172a;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  text-transform: capitalize;
  margin: 0;
}
.platform-breakdown__handle {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #64748b;
  margin: 0.125rem 0 0;
}
.platform-breakdown__stats {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 4vw, 2rem);
  flex-wrap: wrap;
}
.platform-breakdown__stat {
  text-align: right;
  min-width: 4rem;
}
.platform-breakdown__stat-label {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #64748b;
  margin: 0 0 0.125rem;
}
.platform-breakdown__stat-value {
  font-weight: 700;
  color: #0f172a;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  margin: 0;
}

.top-posts-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
}
.top-posts-card__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1.25rem;
  font-size: clamp(1rem, 3vw, 1.125rem);
}
.top-posts-card__table-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 1rem;
  margin: -0.25rem;
  padding: 0.25rem;
}
@media (hover: none) and (pointer: coarse) {
  .top-posts-card__table-wrap {
    scrollbar-width: none;
  }
  .top-posts-card__table-wrap::-webkit-scrollbar {
    display: none;
  }
}
.top-posts-card table {
  min-width: 640px;
  width: 100%;
  border-collapse: collapse;
}
.top-posts-card table th {
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #f1f5f9;
}
.top-posts-card table th:not(:first-child) {
  text-align: right;
}
.top-posts-card table td {
  padding: 0.75rem 1rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.top-posts-card table td:not(:first-child) {
  text-align: right;
}
.top-posts-card table td.content-cell {
  max-width: 200px;
}
@media (min-width: 1024px) {
  .top-posts-card table td.content-cell {
    max-width: 280px;
  }
}
.top-posts-card table td.content-cell p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
}
.top-posts-card table tr:last-child td {
  border-bottom: none;
}
@media (hover: hover) and (pointer: fine) {
  .top-posts-card table tr:hover td {
    background: #f8fafc;
  }
}
.top-posts-card__engagement-badge {
  display: inline-flex;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  background: #dcfce7;
  color: #15803d;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 700;
}
.top-posts-card__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2.5rem;
  color: #94a3b8;
  gap: 0.5rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}

.inbox-layout {
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 2vw, 1rem);
  height: calc(100dvh - 180px);
  min-height: 400px;
}
@media (min-width: 768px) {
  .inbox-layout {
    flex-direction: row;
    height: calc(100dvh - 160px);
  }
}
@media (min-width: 1024px) {
  .inbox-layout {
    height: calc(100dvh - 140px);
  }
}

.inbox-filters {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 1rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .inbox-filters {
    scrollbar-width: none;
  }
  .inbox-filters::-webkit-scrollbar {
    display: none;
  }
}
@media (hover: hover) and (pointer: fine) {
  .inbox-filters {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  .inbox-filters::-webkit-scrollbar {
    width: 6px;
  }
  .inbox-filters::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .inbox-filters::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .inbox-filters::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
.inbox-filters {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 0.5rem;
  padding: 0.75rem;
  height: auto;
}
@media (hover: none) and (pointer: coarse) {
  .inbox-filters {
    scrollbar-width: none;
  }
  .inbox-filters::-webkit-scrollbar {
    display: none;
  }
}
@media (min-width: 768px) {
  .inbox-filters {
    flex-direction: column;
    width: 200px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1rem;
    gap: 1.25rem;
  }
}
@media (min-width: 1024px) {
  .inbox-filters {
    width: 220px;
  }
}
.inbox-filters__section-title {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0 0.5rem;
  white-space: nowrap;
}
@media (max-width: 767px) {
  .inbox-filters__section-title {
    display: none;
  }
}
.inbox-filters__all-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1rem;
  border-radius: 1rem;
  font-weight: 500;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  min-height: 40px;
  white-space: nowrap;
  color: #334155;
}
.inbox-filters__all-btn.active {
  background: #eef2ff;
  color: #4338ca;
}
@media (hover: hover) and (pointer: fine) {
  .inbox-filters__all-btn:not(.active):hover {
    background: #f8fafc;
  }
}
.inbox-filters__filter-btn {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 0.875rem;
  border-radius: 1rem;
  font-weight: 500;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  min-height: 40px;
  white-space: nowrap;
  color: #475569;
}
.inbox-filters__filter-btn.active {
  background: #eef2ff;
  color: #4338ca;
}
@media (hover: hover) and (pointer: fine) {
  .inbox-filters__filter-btn:not(.active):hover {
    background: #f8fafc;
  }
}
.inbox-filters__unread-badge {
  margin-left: auto;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  background: #ef4444;
  color: #ffffff;
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 1.25rem;
  text-align: center;
}
@media (max-width: 767px) {
  .inbox-filters__divider {
    display: none;
  }
}
.inbox-filters__divider {
  border: none;
  border-top: 1px solid #f1f5f9;
  margin: 0;
}

.inbox-list {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1;
  min-height: 300px;
}
@media (min-width: 768px) {
  .inbox-list {
    width: 260px;
    flex: none;
    height: 100%;
  }
}
@media (min-width: 1024px) {
  .inbox-list {
    width: 300px;
  }
}
.inbox-list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}
.inbox-list__header-count {
  font-weight: 600;
  color: #334155;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}
.inbox-list__scroll {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .inbox-list__scroll {
    scrollbar-width: none;
  }
  .inbox-list__scroll::-webkit-scrollbar {
    display: none;
  }
}
@media (hover: hover) and (pointer: fine) {
  .inbox-list__scroll {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  .inbox-list__scroll::-webkit-scrollbar {
    width: 6px;
  }
  .inbox-list__scroll::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .inbox-list__scroll::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .inbox-list__scroll::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
.inbox-list__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  height: 100%;
  min-height: 200px;
  color: #94a3b8;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}

.message-item {
  display: flex;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.15s ease;
  position: relative;
}
.message-item.unread {
  border-left: 3px solid #3b82f6;
  padding-left: calc(1rem - 3px);
}
.message-item.selected {
  background: #eef2ff;
}
@media (hover: hover) and (pointer: fine) {
  .message-item:not(.selected):hover {
    background: #f8fafc;
  }
}
.message-item__avatar-wrap {
  position: relative;
  flex-shrink: 0;
}
.message-item__avatar-wrap img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  object-fit: cover;
}
.message-item__platform-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
}
.message-item__content {
  flex: 1 1;
  min-width: 0;
}
.message-item__header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}
.message-item__sender {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #334155;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.message-item__sender.unread {
  font-weight: 700;
  color: #0f172a;
}
.message-item__time {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #94a3b8;
  white-space: nowrap;
  margin-left: 0.5rem;
}
.message-item__preview {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 0.25rem;
}
.message-item__tags {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}
.message-item__type-tag {
  font-size: 0.65rem;
  padding: 0.1rem 0.4rem;
  border-radius: 9999px;
  background: #f1f5f9;
  color: #64748b;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.inbox-thread {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1;
}
@media (min-width: 768px) {
  .inbox-thread {
    height: 100%;
  }
}
.inbox-thread__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
  min-height: 200px;
  color: #94a3b8;
}
.inbox-thread__empty-title {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  font-weight: 600;
}
.inbox-thread__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(0.875rem, 2vw, 1.25rem);
  border-bottom: 1px solid #f1f5f9;
  gap: 0.75rem;
  flex-shrink: 0;
}
.inbox-thread__sender {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}
.inbox-thread__sender img {
  width: 3rem;
  height: 3rem;
  border-radius: 9999px;
  object-fit: cover;
  flex-shrink: 0;
}
.inbox-thread__name {
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-size: clamp(0.875rem, 2.5vw, 1rem);
}
.inbox-thread__handle {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  margin: 0.125rem 0 0;
}
.inbox-thread__body {
  flex: 1 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .inbox-thread__body {
    scrollbar-width: none;
  }
  .inbox-thread__body::-webkit-scrollbar {
    display: none;
  }
}
@media (hover: hover) and (pointer: fine) {
  .inbox-thread__body {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  .inbox-thread__body::-webkit-scrollbar {
    width: 6px;
  }
  .inbox-thread__body::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .inbox-thread__body::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .inbox-thread__body::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
.inbox-thread__body {
  padding: clamp(1rem, 3vw, 1.5rem);
}
.inbox-thread__post-preview {
  padding: 0.875rem 1rem;
  border-radius: 1rem;
  background: #f1f5f9;
  margin-bottom: 1rem;
}
.inbox-thread__post-preview-label {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #64748b;
  margin: 0 0 0.25rem;
}
.inbox-thread__post-preview-text {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #334155;
  margin: 0;
}
.inbox-thread__message-text {
  color: #334155;
  line-height: 1.65;
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  margin: 0 0 0.75rem;
}
.inbox-thread__time {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #94a3b8;
}
.inbox-thread__reply-sent {
  margin-top: 1.5rem;
  padding: 0.875rem 1rem;
  border-radius: 1rem;
  background: #f0fdf4;
  border: 1px solid #dcfce7;
}
.inbox-thread__reply-sent-label {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #16a34a;
  font-weight: 600;
  margin: 0 0 0.375rem;
}
.inbox-thread__reply-sent-text {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #166534;
  margin: 0;
}
.inbox-thread__composer {
  padding: clamp(0.75rem, 2vw, 1rem);
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
}
.inbox-thread__composer textarea {
  width: 100%;
  height: 44px;
  padding: 0 1rem;
  border-radius: 1rem;
  border: 1.5px solid transparent;
  background: #f8fafc;
  font-family: "DM Sans", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #334155;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  appearance: none;
}
@media (min-width: 640px) {
  .inbox-thread__composer textarea {
    height: 48px;
  }
}
.inbox-thread__composer textarea:focus {
  outline: none;
  background: #ffffff;
  border-color: #6366f1;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}
.inbox-thread__composer textarea::placeholder {
  color: #94a3b8;
}
.inbox-thread__composer textarea {
  height: auto;
  min-height: 80px;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  resize: none;
}
.inbox-thread__composer-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.625rem;
}
.inbox-thread__composer-footer-count {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #94a3b8;
}

.inbox-mobile-tabs {
  display: flex;
  gap: 0;
  background: #f1f5f9;
  border-radius: 1rem;
  padding: 0.25rem;
  margin-bottom: 0.75rem;
}
@media (min-width: 768px) {
  .inbox-mobile-tabs {
    display: none;
  }
}
.inbox-mobile-tabs__tab {
  flex: 1 1;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  border: none;
  background: transparent;
  color: #475569;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s ease, color 0.2s ease;
  min-height: 36px;
}
.inbox-mobile-tabs__tab.active {
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  color: #4f46e5;
}

.scheduler-calendar-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(1rem, 3vw, 1.5rem);
}
@media (min-width: 1024px) {
  .scheduler-calendar-grid {
    grid-template-columns: 2fr 1fr;
  }
}

.calendar-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  overflow: hidden;
}
.calendar-card .react-calendar {
  font-family: "DM Sans", sans-serif;
  border: none;
  width: 100%;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}
.calendar-card .react-calendar__navigation button {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  font-weight: 600;
  color: #334155;
  border-radius: 0.75rem;
  min-height: 44px;
}
@media (hover: hover) and (pointer: fine) {
  .calendar-card .react-calendar__navigation button:hover {
    background: #f1f5f9;
  }
}
.calendar-card .react-calendar__month-view__weekdays__weekday {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-decoration: none;
}
.calendar-card .react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
}
.calendar-card .react-calendar__tile {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  border-radius: 1rem;
  min-height: 44px;
  padding: 0.5rem 0.25rem;
  transition: background 0.2s ease;
  position: relative;
}
@media (hover: hover) and (pointer: fine) {
  .calendar-card .react-calendar__tile:not(.react-calendar__tile--active):not(.react-calendar__tile--now):hover {
    background: #f1f5f9;
  }
}
.calendar-card .react-calendar__tile--now {
  background: #eef2ff;
  color: #4338ca;
  font-weight: 700;
}
.calendar-card .react-calendar__tile--active {
  background: #6366f1 !important;
  color: #ffffff !important;
  border-radius: 1rem;
}

.calendar-tile-dots {
  display: flex;
  justify-content: center;
  gap: 2px;
  margin-top: 3px;
}
.calendar-tile-dots__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
}
.calendar-tile-dots__dot--published {
  background: #22c55e;
}
.calendar-tile-dots__dot--scheduled {
  background: #3b82f6;
}
.calendar-tile-dots__dot--draft {
  background: #f59e0b;
}
.calendar-tile-dots__more {
  font-size: 0.55rem;
  color: #64748b;
  line-height: 1;
  align-self: center;
}

.selected-date-panel {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .selected-date-panel {
    scrollbar-width: none;
  }
  .selected-date-panel::-webkit-scrollbar {
    display: none;
  }
}
@media (hover: hover) and (pointer: fine) {
  .selected-date-panel {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 #f1f5f9;
  }
  .selected-date-panel::-webkit-scrollbar {
    width: 6px;
  }
  .selected-date-panel::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .selected-date-panel::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .selected-date-panel::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
.selected-date-panel {
  max-height: 600px;
}
@media (min-width: 1024px) {
  .selected-date-panel {
    max-height: none;
  }
}
.selected-date-panel__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 1rem;
  font-size: clamp(1rem, 3vw, 1.125rem);
}
.selected-date-panel__empty {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #64748b;
  text-align: center;
  padding: 1.5rem 0;
}
.selected-date-panel__posts {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.scheduled-post-item {
  padding: clamp(0.75rem, 2vw, 1rem);
  border-radius: 1rem;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  transition: border-color 0.2s ease;
}
@media (hover: hover) and (pointer: fine) {
  .scheduled-post-item:hover {
    border-color: #e0e7ff;
  }
}
.scheduled-post-item__content {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #334155;
  margin: 0 0 0.625rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.scheduled-post-item__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.scheduled-post-item__platforms {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}
.scheduled-post-item__actions {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.scheduler-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.scheduler-list__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.scheduler-list__filters button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.scheduler-list__filters button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.scheduler-list__filters button:active {
  transform: scale(0.97);
}
.scheduler-list__filters button {
  padding: 0.4rem 0.875rem;
  border-radius: 9999px;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  background: #f1f5f9;
  color: #475569;
  border: none;
  min-height: 36px;
}
.scheduler-list__filters button.active {
  background: #eef2ff;
  color: #4f46e5;
}
@media (hover: hover) and (pointer: fine) {
  .scheduler-list__filters button:not(.active):hover {
    background: #e2e8f0;
  }
}

.scheduler-table-wrap {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  overflow: hidden;
}
.scheduler-table-wrap__scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (hover: none) and (pointer: coarse) {
  .scheduler-table-wrap__scroll {
    scrollbar-width: none;
  }
  .scheduler-table-wrap__scroll::-webkit-scrollbar {
    display: none;
  }
}
.scheduler-table-wrap table {
  min-width: 600px;
  width: 100%;
  border-collapse: collapse;
}
.scheduler-table-wrap table thead {
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}
.scheduler-table-wrap table thead th {
  text-align: left;
  padding: 1rem 1.25rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}
.scheduler-table-wrap table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s ease;
}
.scheduler-table-wrap table tbody tr:last-child {
  border-bottom: none;
}
@media (hover: hover) and (pointer: fine) {
  .scheduler-table-wrap table tbody tr:hover {
    background: #f8fafc;
  }
}
.scheduler-table-wrap table tbody tr td {
  padding: 0.875rem 1.25rem;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #334155;
  vertical-align: middle;
}
.scheduler-table-wrap table .content-cell {
  max-width: 220px;
}
@media (min-width: 1280px) {
  .scheduler-table-wrap table .content-cell {
    max-width: 320px;
  }
}
.scheduler-table-wrap table .content-cell p {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
}
.scheduler-table-wrap table .platforms-cell {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}
.scheduler-table-wrap table .actions-cell {
  display: flex;
  gap: 0.375rem;
  align-items: center;
  flex-wrap: wrap;
}

.scheduler-empty {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  padding: clamp(2rem, 6vw, 4rem);
  color: #94a3b8;
  text-align: center;
}
.scheduler-empty svg {
  opacity: 0.5;
}
.scheduler-empty p {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  margin: 0;
}

.accounts-counter {
  padding: 0.375rem 1rem;
  border-radius: 9999px;
  background: #eef2ff;
  border: 1px solid #e0e7ff;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #4f46e5;
  white-space: nowrap;
  flex-shrink: 0;
}

.accounts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(0.75rem, 2vw, 1rem);
}
@media (min-width: 480px) {
  .accounts-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 640px) {
  .accounts-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 768px) {
  .accounts-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 1024px) {
  .accounts-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1280px) {
  .accounts-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.platform-connect-card {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: clamp(1rem, 3vw, 1.25rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: pointer;
}
@media (hover: hover) and (pointer: fine) {
  .platform-connect-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(15, 23, 42, 0.1), 0 2px 8px rgba(15, 23, 42, 0.06);
  }
}
@media (hover: none) and (pointer: coarse) {
  .platform-connect-card:active {
    transform: scale(0.97);
  }
}
.platform-connect-card.connected {
  border-color: #dcfce7;
  background: linear-gradient(135deg, #ffffff 60%, #f0fdf4);
}
.platform-connect-card__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(3rem, 8vw, 3.5rem);
  height: clamp(3rem, 8vw, 3.5rem);
  border-radius: 1.5rem;
}
.platform-connect-card__name {
  font-weight: 600;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #0f172a;
  text-transform: capitalize;
  margin: 0;
}
.platform-connect-card__account {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  color: #64748b;
  margin: -0.375rem 0 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.platform-connect-card__status {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
}
.platform-connect-card__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}
.platform-connect-card__action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.platform-connect-card__action:active {
  transform: scale(0.97);
}
.platform-connect-card__action {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  min-height: 38px;
}
.platform-connect-card__action--connect {
  background: #6366f1;
  color: #ffffff;
}
@media (hover: hover) and (pointer: fine) {
  .platform-connect-card__action--connect:hover {
    background: #4f46e5;
  }
}
.platform-connect-card__action--disconnect {
  background: #f1f5f9;
  color: #475569;
  border: none;
}
@media (hover: hover) and (pointer: fine) {
  .platform-connect-card__action--disconnect:hover {
    background: #fef2f2;
    color: #dc2626;
  }
}

.connected-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #22c55e;
  display: inline-block;
  flex-shrink: 0;
}
.connected-dot--disconnected {
  background: #cbd5e1;
}

.memat-media-app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #0a0a0a;
  color: #f4f4f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.memat-media-app .btn-primary, .memat-media-app .btn-secondary {
  padding: 12px 28px;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;
}
.memat-media-app .btn-primary {
  background-color: #f4f4f5;
  color: #0a0a0a;
  border: 2px solid #f4f4f5;
}
.memat-media-app .btn-primary:hover {
  background-color: #ff3366;
  border-color: #ff3366;
  color: #fff;
}
.memat-media-app .btn-secondary {
  background-color: transparent;
  color: #f4f4f5;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.memat-media-app .btn-secondary:hover {
  border-color: #f4f4f5;
  background-color: rgba(255, 255, 255, 0.05);
}
.memat-media-app .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 5%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
}
.memat-media-app .header__logo {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.memat-media-app .header__nav {
  display: flex;
  gap: 40px;
  align-items: center;
}
.memat-media-app .header__nav a {
  color: #f4f4f5;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}
.memat-media-app .header__nav a:not(.btn-primary):hover {
  color: #ff3366;
}
@media (max-width: 768px) {
  .memat-media-app .header__nav {
    display: none;
  }
}
.memat-media-app .main-content {
  flex: 1 1;
}
.memat-media-app .hero {
  padding: 140px 5%;
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}
.memat-media-app .hero__title {
  font-size: clamp(3rem, 8vw, 6rem);
  font-weight: 900;
  line-height: 1.05;
  margin-bottom: 24px;
  text-transform: uppercase;
  letter-spacing: -1px;
}
.memat-media-app .hero__title .text-highlight {
  color: #ff3366;
  font-style: italic;
  display: inline-block;
}
.memat-media-app .hero__subtitle {
  font-size: 1.25rem;
  color: #a1a1aa;
  margin-bottom: 48px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}
.memat-media-app .hero__actions {
  display: flex;
  gap: 20px;
  justify-content: center;
}
@media (max-width: 480px) {
  .memat-media-app .hero__actions {
    flex-direction: column;
  }
}
.memat-media-app .featured-brands {
  padding: 100px 5%;
  background-color: #111;
}
.memat-media-app .featured-brands .section-title {
  font-size: 2rem;
  margin-bottom: 56px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
}
.memat-media-app .featured-brands .brand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
}
.memat-media-app .featured-brands .brand-card {
  background-color: #0a0a0a;
  padding: 48px 40px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  transition: transform 0.3s ease, border-color 0.3s ease;
}
.memat-media-app .featured-brands .brand-card h3 {
  font-size: 1.75rem;
  margin-bottom: 16px;
  color: #ff3366;
  font-weight: 700;
}
.memat-media-app .featured-brands .brand-card p {
  color: #a1a1aa;
  line-height: 1.7;
  font-size: 1rem;
}
.memat-media-app .featured-brands .brand-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255, 255, 255, 0.2);
}
.memat-media-app .footer {
  padding: 80px 5% 40px;
  background-color: #050505;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.memat-media-app .footer__content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 64px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.memat-media-app .footer__brand h2 {
  font-size: 1.75rem;
  font-weight: 800;
  margin-bottom: 16px;
  letter-spacing: 1px;
}
.memat-media-app .footer__brand p {
  color: #a1a1aa;
}
.memat-media-app .footer__links {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.memat-media-app .footer__links a {
  color: #a1a1aa;
  text-decoration: none;
  transition: color 0.2s ease;
  font-weight: 500;
}
.memat-media-app .footer__links a:hover {
  color: #f4f4f5;
}
.memat-media-app .footer__bottom {
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.875rem;
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  max-width: 1200px;
  margin: 0 auto;
}

.legal-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: clamp(2.5rem, 6vw, 5rem) 0 clamp(4rem, 8vw, 6rem);
}
.legal-page__container {
  max-width: 46rem;
  margin: 0 auto;
  padding: 0 clamp(1.25rem, 4vw, 2rem);
}
.legal-page__header {
  margin-bottom: clamp(2rem, 5vw, 3rem);
}
.legal-page__eyebrow {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #4f46e5;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}
.legal-page__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 6vw, 2.75rem);
  font-weight: 700;
  color: #0f172a;
  line-height: 1.15;
  margin: 0 0 1rem;
}
.legal-page__intro {
  font-size: clamp(1rem, 3vw, 1.125rem);
  line-height: 1.65;
  color: #64748b;
  margin: 0;
}

.legal-toc {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  margin-bottom: clamp(2rem, 5vw, 3rem);
}
.legal-toc__label {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}
.legal-toc__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}
@media (min-width: 480px) {
  .legal-toc__list {
    grid-template-columns: repeat(2, 1fr);
  }
}
.legal-toc__list a {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #0f172a;
  text-decoration: none;
  transition: color 0.15s ease;
}
@media (hover: hover) and (pointer: fine) {
  .legal-toc__list a:hover {
    color: #4f46e5;
    text-decoration: underline;
  }
}

.legal-sections {
  display: flex;
  flex-direction: column;
  gap: clamp(1.5rem, 4vw, 2rem);
}

.legal-section {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  padding: clamp(1.5rem, 4vw, 2.25rem);
  scroll-margin-top: 2rem;
}
.legal-section__head {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  margin-bottom: 0.875rem;
}
.legal-section__index {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 1.5rem;
  background: #eef2ff;
  color: #4f46e5;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}
.legal-section__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: clamp(1.05rem, 3vw, 1.25rem);
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
}
.legal-section__body {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  line-height: 1.7;
  color: #64748b;
  margin: 0 0 0.5rem;
}
.legal-section__list-label {
  font-weight: 600;
  color: #0f172a;
}
.legal-section__list, .legal-section__bullets, .legal-section__contact {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.legal-section__list li, .legal-section__bullets li, .legal-section__contact li {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  line-height: 1.7;
  color: #64748b;
  padding-left: 1.25rem;
  position: relative;
}
.legal-section__list li::before, .legal-section__bullets li::before, .legal-section__contact li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.7em;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 9999px;
  background: #6366f1;
}
.legal-section__list li a, .legal-section__bullets li a, .legal-section__contact li a {
  color: #4f46e5;
  font-weight: 500;
  text-decoration: none;
}
@media (hover: hover) and (pointer: fine) {
  .legal-section__list li a:hover, .legal-section__bullets li a:hover, .legal-section__contact li a:hover {
    text-decoration: underline;
  }
}
.legal-section__contact li::before {
  background: #94a3b8;
}

.legal-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: clamp(2.5rem, 6vw, 5rem) 0 clamp(4rem, 8vw, 6rem);
}
.legal-page__container {
  max-width: 46rem;
  margin: 0 auto;
  padding: 0 clamp(1.25rem, 4vw, 2rem);
}
.legal-page__header {
  margin-bottom: clamp(2rem, 5vw, 3rem);
}
.legal-page__eyebrow {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 600;
  color: #4f46e5;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}
.legal-page__title {
  font-family: "Outfit", sans-serif;
  font-size: clamp(1.75rem, 6vw, 2.75rem);
  font-weight: 700;
  color: #0f172a;
  line-height: 1.15;
  margin: 0 0 1rem;
}
.legal-page__intro {
  font-size: clamp(1rem, 3vw, 1.125rem);
  line-height: 1.65;
  color: #64748b;
  margin: 0;
}

.legal-toc {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  margin-bottom: clamp(2rem, 5vw, 3rem);
}
.legal-toc__label {
  font-size: clamp(0.65rem, 1.5vw, 0.75rem);
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 0.75rem;
}
.legal-toc__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}
@media (min-width: 480px) {
  .legal-toc__list {
    grid-template-columns: repeat(2, 1fr);
  }
}
.legal-toc__list a {
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  font-weight: 500;
  color: #0f172a;
  text-decoration: none;
  transition: color 0.15s ease;
}
@media (hover: hover) and (pointer: fine) {
  .legal-toc__list a:hover {
    color: #4f46e5;
    text-decoration: underline;
  }
}

.legal-sections {
  display: flex;
  flex-direction: column;
  gap: clamp(1.5rem, 4vw, 2rem);
}

.legal-section {
  background: #ffffff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.06), 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 0;
  padding: clamp(1.5rem, 4vw, 2.25rem);
  scroll-margin-top: 2rem;
}
.legal-section__head {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  margin-bottom: 0.875rem;
}
.legal-section__index {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 1.5rem;
  background: #eef2ff;
  color: #4f46e5;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
}
.legal-section__title {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  font-size: clamp(1.05rem, 3vw, 1.25rem);
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
}
.legal-section__body {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  line-height: 1.7;
  color: #64748b;
  margin: 0 0 0.5rem;
}
.legal-section__list-label {
  font-weight: 600;
  color: #0f172a;
}
.legal-section__list, .legal-section__bullets, .legal-section__contact {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.legal-section__list li, .legal-section__bullets li, .legal-section__contact li {
  font-size: clamp(0.875rem, 2.5vw, 1rem);
  line-height: 1.7;
  color: #64748b;
  padding-left: 1.25rem;
  position: relative;
}
.legal-section__list li::before, .legal-section__bullets li::before, .legal-section__contact li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.7em;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 9999px;
  background: #6366f1;
}
.legal-section__list li a, .legal-section__bullets li a, .legal-section__contact li a {
  color: #4f46e5;
  font-weight: 500;
  text-decoration: none;
}
@media (hover: hover) and (pointer: fine) {
  .legal-section__list li a:hover, .legal-section__bullets li a:hover, .legal-section__contact li a:hover {
    text-decoration: underline;
  }
}
.legal-section__contact li::before {
  background: #94a3b8;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
    --background: 210 40% 98%;
    --foreground: 222.2 84% 4.9%;
    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;
    --primary: 239 84% 67%;
    --primary-foreground: 0 0% 100%;
    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;
    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;
    --accent: 330 81% 60%;
    --accent-foreground: 0 0% 100%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 0 0% 100%;
    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 239 84% 67%;
    --radius: 1rem;
    --success: 160 84% 39%;
    --warning: 38 92% 50%;
    --info: 217 91% 60%;
    --sidebar-width: 260px;
    --sidebar-collapsed-width: 72px;
  }

*,
  *::before,
  *::after {
    box-sizing: border-box;
    border-color: hsl(var(--border));
    -webkit-tap-highlight-color: transparent;
  }

html {
    text-size-adjust: 100%;
    scroll-behavior: smooth;
  }

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    font-family: "DM Sans", sans-serif;
    font-size: 1rem;
    overflow-x: hidden;
    min-height: 100vh;
    min-height: 100dvh;
}

h1, h2, h3, h4, h5, h6 {
    font-family: "Outfit", sans-serif;
    font-weight: 700;
    letter-spacing: -0.025em;
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
    line-height: 1.2;
  }

h1 {
    font-size: clamp(1.75rem, 6vw, 2.25rem);
  }

h2 {
    font-size: clamp(1.5rem, 5vw, 1.875rem);
  }

h3 {
    font-size: clamp(1.25rem, 4vw, 1.5rem);
  }

h4 {
    font-size: clamp(1.1rem, 3.5vw, 1.25rem);
  }

h5 {
    font-size: clamp(1rem, 3vw, 1.125rem);
  }

h6 {
    font-size: clamp(0.875rem, 2.5vw, 1rem);
  }

img, video, svg {
    max-width: 100%;
    height: auto;
  }

button, a, [role=button] {
    min-height: 44px;
    min-width: 44px;
  }

::selection {
    background: rgba(99, 102, 241, 0.18);
    color: #4f46e5;
  }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -0.125rem;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-3{
  right: -0.75rem;
}
.-top-12{
  top: -3rem;
}
.-top-2{
  top: -0.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-4{
  top: 1rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-2{
  margin-left: -0.5rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-20{
  margin-left: 5rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-64{
  margin-left: 16rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[calc\\(100dvh-190px\\)\\]{
  height: calc(100dvh - 190px);
}
.h-\\[calc\\(100vh-3rem\\)\\]{
  height: calc(100vh - 3rem);
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-44{
  max-height: 11rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[240px\\]{
  min-height: 240px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[72px\\]{
  min-height: 72px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[1\\.25rem\\]{
  min-width: 1.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-start{
  scroll-snap-align: start;
}
.scroll-mt-6{
  scroll-margin-top: 1.5rem;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-br-md{
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-dashed{
  border-style: dashed;
}
.border-none{
  border-style: none;
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/60{
  border-color: rgb(191 219 254 / 0.6);
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/50{
  border-color: rgb(224 231 255 / 0.5);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-200\\/60{
  border-color: rgb(251 207 232 / 0.6);
}
.border-pink-400{
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-100\\/60{
  border-color: rgb(254 226 226 / 0.6);
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-200\\/60{
  border-color: rgb(254 202 202 / 0.6);
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-l-blue-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-indigo-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30{
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/50{
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/80{
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-50\\/30{
  background-color: rgb(253 242 248 / 0.3);
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/30{
  background-color: rgb(254 242 242 / 0.3);
}
.bg-red-50\\/50{
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/90{
  background-color: rgb(220 38 38 / 0.9);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/80{
  background-color: rgb(241 245 249 / 0.8);
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60{
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-600{
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/50{
  background-color: rgb(15 23 42 / 0.5);
}
.bg-slate-900\\/80{
  background-color: rgb(15 23 42 / 0.8);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/60{
  --tw-gradient-from: rgb(238 242 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/80{
  --tw-gradient-from: rgb(238 242 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600\\/30{
  --tw-gradient-from: rgb(79 70 229 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50\\/80{
  --tw-gradient-from: rgb(255 247 237 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50{
  --tw-gradient-from: #fdf2f8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600\\/30{
  --tw-gradient-from: rgb(147 51 234 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-50\\/50{
  --tw-gradient-from: rgb(254 242 242 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900\\/60{
  --tw-gradient-from: rgb(15 23 42 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400{
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-pink-50\\/50{
  --tw-gradient-to: rgb(253 242 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(253 242 248 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50\\/50{
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(250 245 255 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-600\\/30{
  --tw-gradient-to: rgb(79 70 229 / 0.3) var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-pink-400{
  --tw-gradient-to: #f472b6 var(--tw-gradient-to-position);
}
.to-pink-50\\/40{
  --tw-gradient-to: rgb(253 242 248 / 0.4) var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-pink-600\\/30{
  --tw-gradient-to: rgb(219 39 119 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-50{
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/40{
  --tw-gradient-to: rgb(250 245 255 / 0.4) var(--tw-gradient-to-position);
}
.to-purple-50\\/50{
  --tw-gradient-to: rgb(250 245 255 / 0.5) var(--tw-gradient-to-position);
}
.to-purple-500{
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-rose-500{
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.fill-white{
  fill: #fff;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1\\.5px\\]{
  padding: 1.5px;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-11{
  padding-left: 2.75rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[calc\\(0\\.75rem-3px\\)\\]{
  padding-left: calc(0.75rem - 3px);
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-body{
  font-family: DM Sans, sans-serif;
}
.font-heading{
  font-family: Outfit, sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-600\\/80{
  color: rgb(79 70 229 / 0.8);
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-800{
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-300{
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.text-pink-400{
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-950{
  --tw-text-opacity: 1;
  color: rgb(69 10 10 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-indigo-500{
  accent-color: #6366f1;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.accent-red-500{
  accent-color: #ef4444;
}
.opacity-0{
  opacity: 0;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-button{
  --tw-shadow: 0 4px 14px 0 rgba(99,102,241,0.39);
  --tw-shadow-colored: 0 4px 14px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0 2px 8px rgba(0,0,0,0.04), 0 12px 24px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color), 0 12px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-500\\/5{
  --tw-shadow-color: rgb(59 130 246 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-card{
  --tw-shadow-color: hsl(var(--card));
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/5{
  --tw-shadow-color: rgb(236 72 153 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-100{
  --tw-shadow-color: #fee2e2;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20{
  --tw-shadow-color: rgb(239 68 68 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/5{
  --tw-shadow-color: rgb(239 68 68 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-900\\/20{
  --tw-shadow-color: rgb(15 23 42 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-blue-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-pink-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 114 182 / var(--tw-ring-opacity, 1));
}
.ring-red-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{
  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{
  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.font-heading {
  font-family: "Outfit", sans-serif;
}

.font-body {
  font-family: "DM Sans", sans-serif;
}

@media (hover: hover) and (pointer: fine) {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
}
@media (hover: none) and (pointer: coarse) {
  ::-webkit-scrollbar {
    display: none;
  }
  * {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
.mobile-only {
  display: block;
}
@media (min-width: 640px) {
  .mobile-only {
    display: none;
  }
}

.tablet-only {
  display: none;
}
@media (min-width: 640px) {
  .tablet-only {
    display: block;
  }
}
@media (min-width: 1024px) {
  .tablet-only {
    display: none;
  }
}

.desktop-only {
  display: none;
}
@media (min-width: 1024px) {
  .desktop-only {
    display: block;
  }
}

.safe-top {
  padding-top: env(safe-area-inset-top);
}

.safe-bottom {
  padding-bottom: env(safe-area-inset-bottom);
}

.safe-left {
  padding-left: env(safe-area-inset-left);
}

.safe-right {
  padding-right: env(safe-area-inset-right);
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}

.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}

.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}

.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}

.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.empty\\:hidden:empty{
  display: none;
}

.focus-within\\:relative:focus-within{
  position: relative;
}

.focus-within\\:z-20:focus-within{
  z-index: 20;
}

.focus-within\\:bg-white:focus-within{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-indigo-500:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-indigo-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-orange-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}

.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50\\/40:hover{
  background-color: rgb(238 242 255 / 0.4);
}

.hover\\:bg-indigo-50\\/50:hover{
  background-color: rgb(238 242 255 / 0.5);
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}

.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}

.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}

.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50\\/30:hover{
  background-color: rgb(254 242 242 / 0.3);
}

.hover\\:bg-red-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8);
}

.hover\\:from-indigo-600:hover{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-orange-50:hover{
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-pink-600:hover{
  --tw-gradient-from: #db2777 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 39 119 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-purple-600:hover{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}

.hover\\:to-rose-600:hover{
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}

.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}

.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}

.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}

.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:shadow-card-hover:hover{
  --tw-shadow: 0 8px 30px rgba(99,102,241,0.15);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-indigo-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}

.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}

.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}

.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}

.focus\\:opacity-100:focus{
  opacity: 1;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-50\\/50:focus{
  --tw-ring-color: rgb(238 242 255 / 0.5);
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500\\/10:focus{
  --tw-ring-color: rgb(99 102 241 / 0.1);
}

.focus\\:ring-pink-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500\\/10:focus{
  --tw-ring-color: rgb(239 68 68 / 0.1);
}

.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-indigo-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-slate-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.active\\:bg-slate-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}

.group:hover .group-hover\\:text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}

.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}

.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}

.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}

.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}

.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}

.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}

.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}

.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}

.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}

.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}

.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}

.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}

.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up{
  from{
    height: var(--radix-accordion-content-height);
  }
  to{
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down{
  from{
    height: 0;
  }
  to{
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}

.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}

.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-indigo-600[data-state="checked"]{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}

.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}

.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}

.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}

.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}

.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}

.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}

.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}

.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}

.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}

.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}

.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}

.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}

@media (min-width: 640px){
  .sm\\:bottom-0{
    bottom: 0px;
  }
  .sm\\:right-0{
    right: 0px;
  }
  .sm\\:top-auto{
    top: auto;
  }
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:ml-1{
    margin-left: 0.25rem;
  }
  .sm\\:mr-2{
    margin-right: 0.5rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-1{
    margin-top: 0.25rem;
  }
  .sm\\:inline{
    display: inline;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-11{
    height: 2.75rem;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-4{
    height: 1rem;
  }
  .sm\\:h-5{
    height: 1.25rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-9{
    height: 2.25rem;
  }
  .sm\\:h-\\[calc\\(100dvh-200px\\)\\]{
    height: calc(100dvh - 200px);
  }
  .sm\\:min-h-\\[80px\\]{
    min-height: 80px;
  }
  .sm\\:w-10{
    width: 2.5rem;
  }
  .sm\\:w-11{
    width: 2.75rem;
  }
  .sm\\:w-12{
    width: 3rem;
  }
  .sm\\:w-4{
    width: 1rem;
  }
  .sm\\:w-5{
    width: 1.25rem;
  }
  .sm\\:w-6{
    width: 1.5rem;
  }
  .sm\\:w-9{
    width: 2.25rem;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:max-w-sm{
    max-width: 24rem;
  }
  .sm\\:flex-none{
    flex: none;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-8{
    gap: 2rem;
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }
  .sm\\:self-auto{
    align-self: auto;
  }
  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }
  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }
  .sm\\:border-none{
    border-style: none;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:pb-0{
    padding-bottom: 0px;
  }
  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .sm\\:pl-\\[calc\\(1rem-3px\\)\\]{
    padding-left: calc(1rem - 3px);
  }
  .sm\\:pt-0{
    padding-top: 0px;
  }
  .sm\\:pt-6{
    padding-top: 1.5rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-right{
    text-align: right;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px){
  .md\\:absolute{
    position: absolute;
  }
  .md\\:block{
    display: block;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-48{
    height: 12rem;
  }
  .md\\:h-\\[calc\\(100vh-5rem\\)\\]{
    height: calc(100vh - 5rem);
  }
  .md\\:w-56{
    width: 14rem;
  }
  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }
  .md\\:max-w-xs{
    max-width: 20rem;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:p-10{
    padding: 2.5rem;
  }
  .md\\:p-5{
    padding: 1.25rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1024px){
  .lg\\:static{
    position: static;
  }
  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .lg\\:\\!flex{
    display: flex !important;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-\\[calc\\(100dvh-180px\\)\\]{
    height: calc(100dvh - 180px);
  }
  .lg\\:w-1\\/2{
    width: 50%;
  }
  .lg\\:w-72{
    width: 18rem;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 1280px){
  .xl\\:w-60{
    width: 15rem;
  }
  .xl\\:w-80{
    width: 20rem;
  }
  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1536px){
  .\\32xl\\:w-44{
    width: 11rem;
  }
  .\\32xl\\:flex-none{
    flex: none;
  }
  .\\32xl\\:flex-row{
    flex-direction: row;
  }
  .\\32xl\\:items-center{
    align-items: center;
  }
  .\\32xl\\:justify-end{
    justify-content: flex-end;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}

.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}

.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}

.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}

.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}

.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}

.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}

.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}

.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}

.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}

.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_animations.scss","webpack://./src/assets/scss/main.scss","webpack://./src/assets/scss/_layout.scss","webpack://./src/assets/scss/_variables.scss","webpack://./src/assets/scss/_mixins.scss","webpack://./src/assets/scss/_components.scss","webpack://./src/assets/scss/_platform-colors.scss","webpack://./src/assets/scss/_auth.scss","webpack://./src/assets/scss/_dashboard.scss","webpack://./src/assets/scss/_posts.scss","webpack://./src/assets/scss/_analytics.scss","webpack://./src/assets/scss/_inbox.scss","webpack://./src/assets/scss/_scheduler.scss","webpack://./src/assets/scss/_accounts.scss","webpack://./src/assets/scss/home.scss","webpack://./src/assets/scss/_termsCondition.scss","webpack://./src/assets/scss/_privacyPolicy.scss"],"names":[],"mappings":"AAIA;EACE;IAAO,uBAAA;ECKP;EDJA;IAAO,yBAAA;ECOP;AACF;ADLA;EACE;IAAO,6BAAA;ECQP;EDPA;IAAO,4BAAA;ECUP;AACF;ADRA;EACE;IAAO,UAAA;IAAY,2BAAA;ECYnB;EDXA;IAAO,UAAA;IAAY,wBAAA;ECenB;AACF;ADbA;EACE;IAAO,UAAA;IAAY,4BAAA;ECiBnB;EDhBA;IAAO,UAAA;IAAY,wBAAA;ECoBnB;AACF;ADlBA;EACE;IAAO,UAAA;IAAY,2BAAA;ECsBnB;EDrBA;IAAO,UAAA;IAAY,wBAAA;ECyBnB;AACF;ADvBA;EACE;IAAO,UAAA;IAAY,2BAAA;EC2BnB;ED1BA;IAAO,UAAA;IAAY,wBAAA;EC8BnB;AACF;AD5BA;EACE;IAAO,UAAA;EC+BP;ED9BA;IAAO,UAAA;ECiCP;AACF;AD/BA;EACE;IAAW,UAAA;ECkCX;EDjCA;IAAY,YAAA;ECoCZ;AACF;ADjCA;EAA0B,yCAAA;ACoC1B;;ADnCA;EAA0B,6CAAA;ACuC1B;;ADtCA;EAA0B,8CAAA;AC0C1B;;ADzCA;EAA0B,0CAAA;AC6C1B;;AD5CA;EAA0B,wCAAA;ACgD1B;;AD/CA;EAA0B,oCAAA;ACmD1B;;ADlDA;EAA0B,wCAAA;ACsD1B;;ADnDA;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;ECsDF;AACF;AC1GA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AD4GF;;ACxGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;EACA,YCgHwB;ED/GxB,WC2IY;ED1IZ,4BAAA;EACA,gDAAA;EE8GA,qCAAA;EACA,2BAAA;EACA,mCAAA;EF9GA,gDAAA;EEmHA,gBAAA;EACA,iCAAA;AHLF;AE9GsB;EDZtB;IEmII,qBAAA;EHLF;EGME;IAAuB,aAAA;EHHzB;AACF;AEvHsB;EDXtB;IEwII,qBAAA;IACA,gCAAA;EHFF;EGIE;IAAuB,UAAA;EHDzB;EGEE;IAA6B,mBD1HpB;IC0H4C,kBAAA;EHEvD;EGDE;IAA6B,mBDzHpB;ICyH4C,kBAAA;EHKvD;EGJE;IAAmC,mBDzH1B;EFgIX;AACF;ACtJA;EE8KqB,2CAAA;AHrBrB;AC1IE;EACE,wBAAA;EACA,gFCsHgB;AFsBpB;AE9Jc;EDCd;IAsBI,gBAAA;IACA,wBAAA;IACA,WC+FsB;ID9FtB,cAAA;IACA,gBAAA;ED2IF;ECzIE;IAAa,YC0FS;EFkDxB;EC1IE;;IAEE,UAAA;IACA,oBAAA;IACA,QAAA;IACA,gBAAA;IACA,mBAAA;IACA,8CAAA;ED4IJ;ECxII;;IAEE,UAAA;IACA,oBAAA;IACA,WAAA;ED0IN;AACF;AExLc;EDAd;IAoDI,YCkEsB;EFsExB;ECtIE;;IAEE,UAAA;IACA,oBAAA;IACA,WAAA;EDwIJ;AACF;;ACnIA;EE7DE,aAAA;EACA,mBAAA;EACgB,YF4DI;EACpB,sBAAA;EACA,mBC0DW;EDzDX,uCCkCU;EDjCV,gBAAA;EACA,cC/CW;EDgDX,eAAA;EACA,iDAAA;EACA,gBAAA;EACA,qBAAA;ADwIF;ACtIE;EAAU,mBC3DC;ED2DsB,cClDtB;AF4Lb;ACxIE;EACE,mBClDS;EDmDT,cChDS;EDiDT,gBAAA;AD0IJ;ACvIE;EAAM,cAAA;AD0IR;;ACtIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iCAAA;EACA,0BAAA;EACA,kCAAA;EACA,WCkDY;EDjDZ,+BAAA;ADyIF;ACvIE;EAAW,cAAA;AD0Ib;AE7Oc;EDyFd;IAYgB,wBAAA;ED4Id;AACF;;ACzIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,MAAA;EACA,WCkCY;EDjCZ,YAAA;EACA,eAAA;EEgEmB,kDAAA;EACA,oDAAA;EA1DnB,oCAAA;EACA,2BAAA;EACA,mCAAA;EFLA,gCAAA;AD8IF;AEnQc;EDyGd;IAcgB,aAAA;EDgJd;AACF;AC/IE;EErHA,aAAA;EACA,mBAAA;EACgB,aFoHM;EACpB,iCCzBW;ED0BX,gBAAA;EACA,mBAAA;EACA,cCnGS;AFsPb;AChJE;EEzIA,aAAA;EACA,mBAAA;EACA,uBAAA;EFyIE,WAAA;EACA,YAAA;EACA,sBCRS;EDST,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cChHS;EDiHT,gCAAA;ADoJJ;AClJI;EAAU,mBCzHD;AF8Qb;;AChJA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,wDAAA;ADmJF;AExSc;EDiJd;IAMgB,iBAAA;EDqJd;AACF;;AClJA;EACE,iCC3CU;AFgMZ;AElTc;ED4Jd;IAGiB,iCC5CL;EFmMV;AACF;AErTc;ED0Jd;IAIiB,mCC5CL;EFuMV;AACF;;ACxJA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uCAAA;AD2JF;AEnUc;EDoKd;IAOI,mBAAA;IACA,mBAAA;IACA,8BAAA;ED4JF;AACF;AC1JE;EE3KA,aAAA;EACA,mBAAA;EACgB,8BF0KM;AD8JxB;AC3JE;EEvIA,iCAAA;EACA,kCAAA;EACA,qBDiFW;EChFX,cAAA;EAvDA,aAAA;EACA,mBAAA;EACA,uBAAA;AH6VF;AChKE;EACE,iCCtFW;EDuFX,uCC7EQ;ED8ER,gBAAA;EACA,cChKS;EDiKT,gBAAA;EACA,SAAA;ADkKJ;AC/JE;EACE,uCC1FQ;ED2FR,cC3KS;ED4KT,oBAAA;ADiKJ;AC9JE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;ADgKJ;AEnWiB;ED+Lf;IAMoB,WAAA;EDkKpB;EClKiC;IAAM,SAAA;EDqKvC;AACF;;ACjKA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WCpEY;EDqEZ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gDAAA;EACA,2CAAA;EEnGA,qCAAA;EACA,2BAAA;EACA,mCAAA;EFmGA,6BAAA;ADsKF;AEnYc;EDiNd;IAcgB,aAAA;EDwKd;AACF;ACvKE;EEzOA,aAAA;EACA,mBAAA;EACA,uBAAA;EFyOE,sBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cCnNS;EDoNT,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;AD2KJ;ACzKI;EAAM,WAAA;EAAa,YAAA;AD6KvB;AC3KI;EAAW,cCpNF;AFkYb;;ACzKA;EACE,WAAA;EACA,oCAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;AD4KF;;AIlbA;ED6DE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AHyXF;AGvXE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AHyXJ;AGtXE;EAAW,sBAAA;AHyXb;AIzcA;EAEE,yBAAA;EACA,uCF4GU;EE3GV,qBFqIY;EEpIZ,mBFmCW;EElCX,cFmBW;EElBX,+CFwIkB;AFkUpB;AE1cc;EEPd;IAUI,uBAAA;IACA,uCFqGQ;EFsWV;AACF;AEncsB;EELlB;IACE,2BAAA;IACA,+CAAA;EJ2cJ;AACF;;AIvcA;EDuCE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AHoaF;AGlaE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AHoaJ;AGjaE;EAAW,sBAAA;AHoab;AI9dA;EAEE,yBAAA;EACA,uCFsFU;EErFV,qBF+GY;EE9GZ,mBFFW;EEGX,cFKW;EEJX,2BAAA;EACA,wEF8GkB;AFiXpB;AEtfc;EEed;IAWI,uBAAA;IACA,uCF8EQ;EFkZV;AACF;AE/esB;EEkBlB;IACE,qBFVO;IEWP,0CAAA;IACA,2BAAA;EJgeJ;AACF;;AI5dA;EDeE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AHidF;AG/cE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AHidJ;AG9cE;EAAW,sBAAA;AHidb;AInfA;EAEE,yBAAA;EACA,uCF8DU;EE7DV,qBFuFY;EEtFZ,qDAAA;EACA,cF3BW;EE4BX,+CF0FkB;AF0ZpB;AEliBc;EEuCd;IAUI,uBAAA;IACA,uCFuDQ;EF8bV;AACF;AE3hBsB;EEyClB;IACE,qDAAA;IACA,2BAAA;IACA,+CAAA;EJqfJ;AACF;;AIjfA;EDRE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AH6fF;AG3fE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AH6fJ;AG1fE;EAAW,sBAAA;AH6fb;AIxgBA;EDrEE,aAAA;EACA,mBAAA;EACA,uBAAA;ECsEA,WAAA;EACA,YAAA;EACA,qBF+DY;EE9DZ,uBAAA;EACA,YAAA;EACA,cF7CW;EE8CX,iDAAA;AJ2gBF;AIzgBE;EAAU,mBFrDC;EEqDuB,cF7CvB;AF0jBb;;AIzgBA;EACE,WAAA;AJ4gBF;AE1lBc;EE6Ed;IAEgB,WAAA;EJ+gBd;AACF;;AI5gBA;EDLE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBD8CW;EC7CX,+BAAA;EACA,mBDhEW;ECiEX,kCDgBa;ECfb,eAAA;EACA,gBAAA;EACA,cD7DW;EC8DX,oFAAA;EAEA,gBAAA;AHqhBF;AE/mBc;EEmFd;IDSgB,YAAA;EHuhBd;AACF;AGthBE;EACE,aAAA;EACA,mBD9ES;EC+ET,qBDhES;ECiET,6CAAA;AHwhBJ;AGrhBE;EAAiB,cD9EN;AFsmBb;AIviBE;EACE,qBFxBS;AFikBb;AIxiBI;EAAU,4CAAA;AJ2iBd;;AIviBA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AJ0iBF;;AItiBA;EACE,kBAAA;AJyiBF;AIviBE;EAAQ,mBAAA;AJ0iBV;AIxiBE;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cF1FS;EE2FT,UAAA;EDzHF,aAAA;EACA,mBAAA;EACA,uBAAA;ECyHE,iBAAA;AJ4iBJ;AI1iBI;EAAU,cF7FD;AF0oBb;;AIxiBA;EDjBE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBDoBY;ECnBZ,yCDRU;ECSV,gBAAA;EACA,yBAAA;EACA,sBAAA;AH6jBF;AE9qBc;EE0Hd;IDPgB,wBAAA;EH+jBd;AACF;AIzjBA;EAEE,mBF3EW;EE4EX,cFzEW;AFmoBb;;AIvjBA;EDvBE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBDoBY;ECnBZ,yCDRU;ECSV,gBAAA;EACA,yBAAA;EACA,sBAAA;AHklBF;AEnsBc;EEgId;IDbgB,wBAAA;EHolBd;AACF;AIxkBA;EAEE,mBF5EW;EE6EX,cF3EW;AFopBb;;AItkBA;ED7BE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBDoBY;ECnBZ,yCDRU;ECSV,gBAAA;EACA,yBAAA;EACA,sBAAA;AHumBF;AExtBc;EEsId;IDnBgB,wBAAA;EHymBd;AACF;AIvlBA;EAEE,mBAAA;EACA,cAAA;AJwlBF;;AIrlBA;EDnCE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBDoBY;ECnBZ,yCDRU;ECSV,gBAAA;EACA,yBAAA;EACA,sBAAA;AH4nBF;AE7uBc;EE4Id;IDzBgB,wBAAA;EH8nBd;AACF;AItmBA;EAEE,mBAAA;EACA,cAAA;AJumBF;;AIpmBA;EDzCE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBDoBY;ECnBZ,yCDRU;ECSV,gBAAA;EACA,yBAAA;EACA,sBAAA;AHipBF;AElwBc;EEkJd;ID/BgB,wBAAA;EHmpBd;AACF;AIrnBA;EAEE,mBFxFW;EEyFX,cFrFW;AF2sBb;;AIlnBA;EDhIE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EEyCV,6EAAA;AJynBF;AExwBsB;EEkJlB;IACE,qBFhIO;IEiIP,8EF1Bc;EFmpBlB;AACF;AItnBE;EACE,uCF9DQ;EE+DR,gBAAA;EACA,cFhJS;EEiJT,mBAAA;AJwnBJ;AIrnBE;EACE,iCF1EW;EE2EX,uCFjEQ;EEkER,gBAAA;EACA,cFpJS;EEqJT,gBAAA;AJunBJ;AIpnBE;ED/KA,aAAA;EACA,mBAAA;EACgB,YC8KM;EACpB,kBAAA;EACA,uCF/EQ;EEgFR,gBAAA;AJwnBJ;AItnBI;EAAc,cFtIL;AF+vBb;AIxnBI;EAAc,cF1HL;AFqvBb;AIxnBE;EDrMA,aAAA;EACA,mBAAA;EACA,uBAAA;ECqME,WAAA;EACA,YAAA;EACA,qBFlES;EEmET,cAAA;EACA,+BAAA;AJ4nBJ;AI1nBI;EAAqB,qBAAA;AJ6nBzB;;AIxnBA;EACE,aAAA;EACA,0BAAA;EACA,iCAAA;AJ2nBF;AE10Bc;EE4Md;IAKiB,qCAAA;EJ6nBf;AACF;AE50Bc;EEyMd;IAMiB,qCAAA;EJioBf;AACF;;AI9nBA;ED3LE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EEoGV,eAAA;EACA,6EAAA;AJqoBF;AEh1BsB;EE8MlB;IAAU,2BAAA;IAA6B,8EFpFvB;EF2tBlB;AACF;AEr1BsB;EEiNlB;IAAW,sBAAA;IAAwB,YAAA;EJyoBrC;AACF;;AItoBA;EACE,aAAA;EACA,qCAAA;EACA,8BAAA;AJyoBF;AEh3Bc;EEoOd;IAKiB,qCAAA;EJ2oBf;AACF;AEn3Bc;EEkOd;IAMiB,qCAAA;EJ+oBf;AACF;AEv3Bc;EEiOd;IAOiB,qCAAA;EJmpBf;AACF;AE33Bc;EEgOd;IAQiB,qCAAA;EJupBf;AACF;;AIppBA;EDtPE,aAAA;EACA,mBAAA;EACA,uBAAA;ECsPA,mCAAA;EACA,oCAAA;EACA,qBFjHY;EEkHZ,cAAA;AJypBF;;AIrpBA;ED9NE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EEuIV,gCAAA;AJ4pBF;AEz4BsB;EEgPlB;IAAU,8EFtHM;EFmxBlB;AACF;AI3pBE;EDjQA,aAAA;EACA,mBAAA;EACA,8BAAA;EC+PmC,uBAAA;AJiqBrC;AI/pBE;EACE,uCF3JQ;EE4JR,gBAAA;EACA,cF7OS;EE8OT,mBAAA;AJiqBJ;AI9pBE;EACE,iCFvKW;EEwKX,uCF9JQ;EE+JR,gBAAA;EACA,cFjPS;AFi5Bb;AI7pBE;ED3QA,aAAA;EACA,mBAAA;EACgB,YC0QM;EACpB,kBAAA;EACA,uCF3KQ;EE4KR,gBAAA;AJiqBJ;AI/pBI;EAAU,cFlOD;AFo4Bb;AIjqBI;EAAU,cFtND;AF03Bb;AIjqBE;EDjSA,aAAA;EACA,mBAAA;EACA,uBAAA;ECiSE,WAAA;EACA,YAAA;EACA,qBF9JS;EE+JT,cAAA;AJqqBJ;;AIhqBA;EACE,yBAAA;EACA,6BAAA;EACA,qBFrKY;EEsKZ,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AJmqBF;AIjqBE;EAAQ,WAAA;EAAa,YAAA;EAAc,iBAAA;AJsqBrC;AIrqBE;EAAQ,WAAA;EAAa,YAAA;AJyqBvB;;AIrqBA;EDzIE,qBD5CW;EC6CX,yEAAA;EACA,2BAAA;EACA,uCAAA;AHkzBF;;AIzqBA;EACE,eAAA;EACA,YFjKY;EEkKZ,yDAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;AJ4qBF;AEz+Bc;EEoTd;IAYI,cAAA;IACA,aAAA;IACA,UAAA;IACA,gBAAA;EJ6qBF;AACF;;AI1qBA;EACE,mBFvTW;EEwTX,qBF1MW;EE2MX,sBAAA;EACA,gFFnMkB;EEoMlB,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;AJ6qBF;;AIzqBA;EACE,eAAA;EACA,QAAA;EACA,WFpMY;EEqMZ,iCAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,qBAAA;EACA,+BAAA;AJ4qBF;AE3gCc;EEsVd;IAWgB,mBAAA;IAAqB,uBAAA;IAAyB,aAAA;EJgrB5D;AACF;;AI9qBA;EACE,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,oBAAA;EACA,wDAAA;EACA,mBFzVW;EE0VX,iCAAA;AJirBF;AE7hCc;EEoWd;IAWI,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBFnPS;IEoPT,aAAA;IACA,gCAAA;EJkrBF;AACF;;AI9qBA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AJirBF;AI/qBE;ED1UA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AH4/BF;AG1/BE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AH4/BJ;AGz/BE;EAAW,sBAAA;AH4/Bb;AIrsBE;EAEE,oBAAA;EACA,qBFjQU;EEkQV,uCF5RQ;EE6RR,gBAAA;EACA,mBFlXS;EEmXT,cF9WS;EE+WT,gBAAA;EACA,YAAA;AJssBJ;AElkCsB;EE+XhB;IAAU,mBFvXH;EF8jCX;AACF;AIrsBI;EACE,mBFjXO;EEkXP,cF/WO;EEgXP,gBAAA;AJusBN;AIpsBI;EACE,yCF/SM;EEgTN,aAAA;AJssBN;;AIhsBA;EACE,aAAA;EACA,mBF3YW;EE4YX,mBFjSW;EEkSX,gBAAA;AJmsBF;AIjsBE;EACE,oBAAA;EACA,sBFvSS;EEwST,gBAAA;EACA,uCF/TQ;EEgUR,YAAA;EACA,uBAAA;EACA,cFjZS;EEkZT,eAAA;EACA,uEAAA;EACA,gBAAA;AJmsBJ;AIjsBI;EACE,mBF9ZO;EE+ZP,wEF5Sc;EE6Sd,cFhZO;AFmlCb;;AI7rBA;ED/bE,aAAA;EACA,mBAAA;EACA,uBAAA;EC+bA,sBAAA;EACA,kBAAA;EACA,sDAAA;AJksBF;AIhsBE;EDrcA,aAAA;EACA,mBAAA;EACA,uBAAA;ECqcE,8BAAA;EACA,+BAAA;EACA,qBFhUU;EEiUV,mBF/aS;EEgbT,mBAAA;AJosBJ;AIlsBI;EAAM,cF/aG;AFonCb;AIlsBE;EACE,iCFvWW;EEwWX,wCFhWQ;EEiWR,gBAAA;EACA,cFjbS;EEkbT,kBAAA;AJosBJ;AIjsBE;EACE,uCF1WQ;EE2WR,cF3bS;EE4bT,kBAAA;EACA,gBAAA;AJmsBJ;;AK/pCE;EAA4B,yBH6ElB;AFslCZ;;AKlqCE;EAA4B,cH4ElB;AF0lCZ;;AKrqCE;EAA4B,qBH2ElB;AF8lCZ;;AKtqCE;EACE,0CAAA;ALyqCJ;;AK/qCE;EAA4B,yBH6ElB;AFsmCZ;;AKlrCE;EAA4B,cH4ElB;AF0mCZ;;AKrrCE;EAA4B,qBH2ElB;AF8mCZ;;AKtrCE;EACE,0CAAA;ALyrCJ;;AK/rCE;EAA4B,yBH6ElB;AFsnCZ;;AKlsCE;EAA4B,cH4ElB;AF0nCZ;;AKrsCE;EAA4B,qBH2ElB;AF8nCZ;;AKtsCE;EACE,yCAAA;ALysCJ;;AK/sCE;EAA4B,yBH6ElB;AFsoCZ;;AKltCE;EAA4B,cH4ElB;AF0oCZ;;AKrtCE;EAA4B,qBH2ElB;AF8oCZ;;AKttCE;EACE,0CAAA;ALytCJ;;AK/tCE;EAA4B,yBH6ElB;AFspCZ;;AKluCE;EAA4B,cH4ElB;AF0pCZ;;AKruCE;EAA4B,qBH2ElB;AF8pCZ;;AKtuCE;EACE,qCAAA;ALyuCJ;;AK/uCE;EAA4B,yBH6ElB;AFsqCZ;;AKlvCE;EAA4B,cH4ElB;AF0qCZ;;AKrvCE;EAA4B,qBH2ElB;AF8qCZ;;AKtvCE;EACE,uCAAA;ALyvCJ;;AK/vCE;EAA4B,yBH6ElB;AFsrCZ;;AKlwCE;EAA4B,cH4ElB;AF0rCZ;;AKrwCE;EAA4B,qBH2ElB;AF8rCZ;;AKtwCE;EACE,wCAAA;ALywCJ;;AK/wCE;EAA4B,yBH6ElB;AFssCZ;;AKlxCE;EAA4B,cH4ElB;AF0sCZ;;AKrxCE;EAA4B,qBH2ElB;AF8sCZ;;AKtxCE;EACE,yCAAA;ALyxCJ;;AK/xCE;EAA4B,yBH6ElB;AFstCZ;;AKlyCE;EAA4B,cH4ElB;AF0tCZ;;AKryCE;EAA4B,qBH2ElB;AF8tCZ;;AKtyCE;EACE,wCAAA;ALyyCJ;;AK/yCE;EAA4B,yBH6ElB;AFsuCZ;;AKlzCE;EAA4B,cH4ElB;AF0uCZ;;AKrzCE;EAA4B,qBH2ElB;AF8uCZ;;AKtzCE;EACE,wCAAA;ALyzCJ;;AK/zCE;EAA4B,yBH6ElB;AFsvCZ;;AKl0CE;EAA4B,cH4ElB;AF0vCZ;;AKr0CE;EAA4B,qBH2ElB;AF8vCZ;;AKt0CE;EACE,yCAAA;ALy0CJ;;AK/0CE;EAA4B,yBH6ElB;AFswCZ;;AKl1CE;EAA4B,cH4ElB;AF0wCZ;;AKr1CE;EAA4B,qBH2ElB;AF8wCZ;;AKt1CE;EACE,0CAAA;ALy1CJ;;AK/1CE;EAA4B,yBH6ElB;AFsxCZ;;AKl2CE;EAA4B,cH4ElB;AF0xCZ;;AKr2CE;EAA4B,qBH2ElB;AF8xCZ;;AKt2CE;EACE,0CAAA;ALy2CJ;;AK/2CE;EAA4B,yBH6ElB;AFsyCZ;;AKl3CE;EAA4B,cH4ElB;AF0yCZ;;AKr3CE;EAA4B,qBH2ElB;AF8yCZ;;AKt3CE;EACE,0CAAA;ALy3CJ;;AK/3CE;EAA4B,yBH6ElB;AFszCZ;;AKl4CE;EAA4B,cH4ElB;AF0zCZ;;AKr4CE;EAA4B,qBH2ElB;AF8zCZ;;AKt4CE;EACE,qCAAA;ALy4CJ;;AK/4CE;EAA4B,yBH6ElB;AFs0CZ;;AKl5CE;EAA4B,cH4ElB;AF00CZ;;AKr5CE;EAA4B,qBH2ElB;AF80CZ;;AKt5CE;EACE,yCAAA;ALy5CJ;;AK/5CE;EAA4B,yBH6ElB;AFs1CZ;;AKl6CE;EAA4B,cH4ElB;AF01CZ;;AKr6CE;EAA4B,qBH2ElB;AF81CZ;;AKt6CE;EACE,0CAAA;ALy6CJ;;AK/6CE;EAA4B,yBH6ElB;AFs2CZ;;AKl7CE;EAA4B,cH4ElB;AF02CZ;;AKr7CE;EAA4B,qBH2ElB;AF82CZ;;AKt7CE;EACE,yCAAA;ALy7CJ;;AK/7CE;EAA4B,yBH6ElB;AFs3CZ;;AKl8CE;EAA4B,cH4ElB;AF03CZ;;AKr8CE;EAA4B,qBH2ElB;AF83CZ;;AKt8CE;EACE,qCAAA;ALy8CJ;;AK/8CE;EAA4B,yBH6ElB;AFs4CZ;;AKl9CE;EAA4B,cH4ElB;AF04CZ;;AKr9CE;EAA4B,qBH2ElB;AF84CZ;;AKt9CE;EACE,0CAAA;ALy9CJ;;AK/9CE;EAA4B,yBH6ElB;AFs5CZ;;AKl+CE;EAA4B,cH4ElB;AF05CZ;;AKr+CE;EAA4B,qBH2ElB;AF85CZ;;AKt+CE;EACE,yCAAA;ALy+CJ;;AK/+CE;EAA4B,yBH6ElB;AFs6CZ;;AKl/CE;EAA4B,cH4ElB;AF06CZ;;AKr/CE;EAA4B,qBH2ElB;AF86CZ;;AKt/CE;EACE,0CAAA;ALy/CJ;;AK//CE;EAA4B,yBH6ElB;AFs7CZ;;AKlgDE;EAA4B,cH4ElB;AF07CZ;;AKrgDE;EAA4B,qBH2ElB;AF87CZ;;AKtgDE;EACE,0CAAA;ALygDJ;;AK/gDE;EAA4B,yBH6ElB;AFs8CZ;;AKlhDE;EAA4B,cH4ElB;AF08CZ;;AKrhDE;EAA4B,qBH2ElB;AF88CZ;;AKthDE;EACE,wCAAA;ALyhDJ;;AK/hDE;EAA4B,yBH6ElB;AFs9CZ;;AKliDE;EAA4B,cH4ElB;AF09CZ;;AKriDE;EAA4B,qBH2ElB;AF89CZ;;AKtiDE;EACE,yCAAA;ALyiDJ;;AM/iDA;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBJsBW;AF4hDb;AM/iDE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;ANijDJ;AEljDc;EIFZ;IAMI,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;ENkjDJ;AACF;AMhjDI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ANkjDN;AM/iDI;EACE,kBAAA;EACA,QAAA;ANijDN;AM9iDI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,YAAA;ANgjDN;AM7iDI;EACE,iCJ+DS;EI9DT,wCAAA;EACA,gBAAA;EACA,cJrBO;EIsBP,mBAAA;EACA,gBAAA;AN+iDN;AM5iDI;EACE,qCJ6DM;EI5DN,+BAAA;EACA,SAAA;EACA,gBAAA;AN8iDN;AMziDE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,gBAAA;AN2iDJ;AMxiDE;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;AN0iDJ;AMtiDE;EHhEA,aAAA;EACA,mBAAA;EACgB,YG+DM;EACpB,mBAAA;EACA,qBAAA;AN0iDJ;AMxiDI;EHjFF,aAAA;EACA,mBAAA;EACA,uBAAA;EGiFI,WAAA;EACA,YAAA;EACA,qBJkDO;EIjDP,8DAAA;EACA,cAAA;AN4iDN;AMziDI;EACE,iCJeS;EIdT,iBAAA;EACA,gBAAA;EACA,cJ3DO;AFsmDb;AMtiDE;EACE,iCJMW;EILX,uCJeQ;EIdR,gBAAA;EACA,cJpES;EIqET,oBAAA;ANwiDJ;AMriDE;EACE,uCJIQ;EIHR,cJ9ES;EI+ET,gBAAA;ANuiDJ;AMniDE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ANqiDJ;AMliDE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ANoiDJ;AMjiDE;EACE,uCJhBQ;EIiBR,gBAAA;EACA,cJhGS;AFmoDb;AMhiDE;EACE,yCJvBQ;EIwBR,cJ9DS;AFgmDb;AM/hDE;EACE,qBAAA;EACA,mBJLS;EIMT,mBJxES;EIyET,yBAAA;EACA,uCJ/BQ;EIgCR,cJvES;AFwmDb;AM7hDE;EHtFA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AHsnDF;AGpnDE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AHsnDJ;AGnnDE;EAAW,sBAAA;AHsnDb;AMnjDE;EAEE,WAAA;EACA,YAAA;EACA,uCJvCQ;EIwCR,qBJfU;EIgBV,qDAAA;EACA,cJjIS;EIkIT,+CJZgB;EIahB,YAAA;EACA,kBAAA;ANojDJ;AE7rDsB;EI4IhB;IACE,qDAAA;IACA,2BAAA;IACA,+CAAA;ENojDN;AACF;AMjjDI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,yBJlJO;EImJP,qBJnCQ;EIoCR,oCAAA;ANmjDN;AM9iDE;EACE,kBAAA;EACA,kBAAA;EACA,uCJtEQ;EIuER,cJvJS;AFusDb;AM9iDI;EACE,gBAAA;EACA,cJjJO;EIkJP,qBAAA;ANgjDN;AM9iDM;EAAU,cJnJH;EImJuB,0BAAA;ANkjDpC;;AO/uDA;EACE,yCAAA;APkvDF;AOhvDE;EACE,iCLsGW;EKrGX,sCAAA;EACA,gBAAA;EACA,cL4BS;EK3BT,oBAAA;EACA,iBAAA;APkvDJ;AO/uDE;EACE,qCLoGQ;EKnGR,cLiBS;EKhBT,SAAA;APivDJ;;AO5uDA;EACE,aAAA;EACA,0BAAA;EACA,iCAAA;EACA,yCAAA;AP+uDF;AEjwDc;EKcd;IAMiB,qCAAA;EPivDf;AACF;AEnwDc;EKWd;IAOiB,qCAAA;EPqvDf;AACF;;AOlvDA;EJEE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UILc;EACd,gBAAA;APyvDF;AOvvDE;EJ7BA,aAAA;EACA,mBAAA;EACA,8BAAA;EI6BE,iCAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;AP2vDJ;AOxvDE;EJ/BA,aAAA;EACA,mBAAA;EACgB,YI8BM;AP4vDxB;AOzvDE;EJ/CA,aAAA;EACA,mBAAA;EACA,uBAAA;EI+CE,aAAA;EACA,cAAA;EACA,qBLoFS;EKnFT,mBLdS;EKeT,cAAA;EACA,cLbS;AF0wDb;AO1vDE;EACE,iCLgDW;EK/CX,gBAAA;EACA,cLzBS;EK0BT,SAAA;EACA,uCLkDQ;AF0sDZ;AOzvDE;EACE,uCL6CQ;EK5CR,cLpCS;EKqCT,oBAAA;AP2vDJ;AOvvDE;EJxEA,aAAA;EACA,mBAAA;EACA,uBAAA;EIwEE,eAAA;AP2vDJ;AOzvDI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBLxCO;EKyCP,qBLwDQ;EKvDR,oCAAA;AP2vDN;;AOrvDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2DAAA;EACA,gCAAA;EACA,iCAAA;APwvDF;AOtvDE;EAAe,mBAAA;APyvDjB;AEr0DsB;EK+ElB;IAAU,mBLzED;EFm0DX;AACF;AOxvDE;EACE,SAAA;EACA,YAAA;AP0vDJ;AOvvDE;EACE,uCLGQ;EKFR,gBAAA;EACA,cL3ES;EChBX,gBAAA;EACA,mBAAA;EACA,uBAAA;EI2FE,mBAAA;AP2vDJ;AOxvDE;EJvGA,aAAA;EACA,mBAAA;EACgB,YIsGM;EACpB,eAAA;AP4vDJ;AOzvDE;EJ5GA,aAAA;EACA,mBAAA;EACgB,YI2GM;AP6vDxB;AO1vDE;EACE,yCLfQ;EKgBR,cLhGS;AF41Db;AOzvDE;EACE,yCLpBQ;EKqBR,cLpGS;EKqGT,oBAAA;AP2vDJ;AOxvDE;EJ3HA,aAAA;EACA,mBAAA;EACgB,WI0HM;EACpB,cAAA;AP4vDJ;AEv3DiB;EKyHf;IAMI,aAAA;EP4vDJ;AACF;;AQ14DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AR64DF;;AQz4DA;EL0BE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EMjHV,wDAAA;ARg5DF;AEr4DsB;EMRlB;IACE,8ENiIc;IMhId,qBNyBO;EFu3DX;AACF;AQ74DE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AR+4DJ;AE75Dc;EMWZ;IAMI,mBAAA;IACA,uBAAA;ERg5DJ;AACF;AQ74DE;EACE,SAAA;EACA,YAAA;AR+4DJ;AQ54DE;EACE,uCN4EQ;EM3ER,cNHS;EMIT,oBAAA;ELZF,oBAAA;EACA,qBKYsB;ELXtB,4BAAA;EACA,gBAAA;AH25DF;AQ94DE;EL7BA,aAAA;EACA,mBAAA;EK8BE,eAAA;EACA,WAAA;ARk5DJ;AQ/4DE;ELnCA,aAAA;EACA,mBAAA;EACgB,YKkCM;EACpB,eAAA;ARm5DJ;AQh5DE;EACE,yCNyDQ;EMxDR,cNxBS;AF06Db;AQ/4DE;EL7CA,aAAA;EACA,mBAAA;EACgB,WK4CM;EACpB,cAAA;EACA,eAAA;ARm5DJ;AEh8DiB;EM0Cf;IAKoB,WAAA;ERq5DpB;AACF;AQl5DE;EACE,WAAA;EACA,mBNkES;EMjET,gBAAA;EACA,kBAAA;ARo5DJ;AEn9Dc;EM2DZ;IAOI,WAAA;IACA,cAAA;IACA,eAAA;ERq5DJ;AACF;AQn5DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ARq5DN;;AQ74DE;EL7EA,aAAA;EACA,mBAAA;EACgB,8BK4EM;EACpB,uCAAA;EACA,eAAA;EACA,YAAA;ARk5DJ;AQ/4DE;ELpFA,aAAA;EACA,mBAAA;EACgB,8BKmFM;ARm5DxB;AQh5DE;ELhDA,iCAAA;EACA,kCAAA;EACA,qBDiFW;EChFX,cAAA;EAvDA,aAAA;EACA,mBAAA;EACA,uBAAA;AH2/DF;AQr5DE;EACE,iCNCW;EMAX,uCNUQ;EMTR,gBAAA;EACA,cNzES;EM0ET,SAAA;ARu5DJ;AQp5DE;EACE,uCNFQ;EMGR,cNnFS;EMoFT,oBAAA;ARs5DJ;AQl5DE;ELtFA,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EMDR,kCAAA;EACA,gBAAA;EACA,WAAA;ARw5DJ;;AQn5DA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ARs5DF;AQp5DE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ARs5DJ;AQn5DE;EACE,uCN7BQ;EM8BR,gBAAA;EACA,cN7GS;AFkgEb;AQj5DE;EACE,aAAA;EACA,uEAAA;EACA,aAAA;ARm5DJ;AQh5DE;EL5IA,aAAA;EACA,mBAAA;EACgB,WK2IM;EACpB,uBAAA;EACA,mBNrBS;EMsBT,2BAAA;EACA,mBNpIS;EMqIT,eAAA;EACA,uCNhDQ;EMiDR,gBAAA;EACA,cNjIS;EMkIT,wDAAA;EACA,gBAAA;ARo5DJ;AQl5DI;EACE,qBN9HO;EM+HP,mBNjIO;EMkIP,cN/HO;AFmhEb;AExiEsB;EMwJhB;IAAyB,mBNlJlB;IMkJyC,qBN/IzC;EFoiEX;AACF;AQj5DE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ARm5DJ;AEhkEc;EM0KZ;IAMI,mBAAA;IACA,mBAAA;ERo5DJ;AACF;AQj5DE;ELtLA,aAAA;EACA,mBAAA;EACA,8BAAA;EKsLE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;ARq5DJ;AQn5DI;ELvLF,aAAA;EACA,mBAAA;EACgB,YKsLQ;EACpB,eAAA;ARu5DN;;AQj5DA;EL1KE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EMmFV,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,cAAA;ARw5DF;AQt5DE;EACE,iCNzGW;EM0GX,sCNjGQ;EMkGR,gBAAA;EACA,cNnLS;EMoLT,mBAAA;ARw5DJ;AQr5DE;EACE,uCN5GQ;EM6GR,cN7LS;EM8LT,kBAAA;ARu5DJ;;ASpnEA;EACE,aAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;ATunEF;AErnEc;EONd;IAMiB,qCAAA;ETynEf;AACF;AEvnEc;EOTd;IAOiB,qCAAA;ET6nEf;AACF;;AS1nEA;EACE,aAAA;EACA,0BAAA;EACA,6BAAA;EACA,uCAAA;AT6nEF;AEnoEc;EOEd;IAMgB,qCAAA;ET+nEd;AACF;;AS5nEA;ENYE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;AF+hEZ;ASjoEE;EACE,iCPiFW;EOhFX,gBAAA;EACA,cPQS;EOPT,mBAAA;EACA,qCPoFQ;AF+iEZ;AShoEE;EACE,WAAA;EACA,iBAAA;ATkoEJ;AE7pEc;EOyBZ;IAIiB,iBAAA;ETooEjB;AACF;AEhqEc;EOuBZ;IAKiB,iBAAA;ETwoEjB;AACF;AStoEE;ENxCA,aAAA;EACA,mBAAA;EACA,uBAAA;EMwCE,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cPfS;AFypEb;AEhrEc;EOiCZ;IAOiB,iBAAA;ET4oEjB;AACF;AEnrEc;EO+BZ;IAQiB,iBAAA;ETgpEjB;AACF;;AS5oEA;ENpBE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EOnEV,uCAAA;ATmpEF;ASjpEE;EACE,iCPgDW;EO/CX,gBAAA;EACA,cPzBS;EO0BT,mBAAA;EACA,qCPmDQ;AFgmEZ;AShpEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ATkpEJ;AS/oEE;ENjEA,aAAA;EACA,mBAAA;EACA,8BAAA;EMiEE,kCAAA;EACA,mBP4DS;EO3DT,mBPjDS;EOkDT,gCAAA;EACA,eAAA;EACA,YAAA;ATmpEJ;AE7sEsB;EO6DhB;IAAU,mBPtDH;EF0sEX;AACF;ASjpEE;ENzEA,aAAA;EACA,mBAAA;EACgB,8BMwEM;ATqpExB;ASlpEE;EACE,gBAAA;EACA,cPxDS;EOyDT,uCPmBQ;EOlBR,0BAAA;EACA,SAAA;ATopEJ;ASjpEE;EACE,yCPYQ;EOXR,cPpES;EOqET,oBAAA;ATmpEJ;AShpEE;EN3FA,aAAA;EACA,mBAAA;EACgB,2BM0FM;EACpB,eAAA;ATopEJ;ASjpEE;EACE,iBAAA;EACA,eAAA;ATmpEJ;ASjpEI;EACE,yCPHM;EOIN,cPnFO;EOoFP,oBAAA;ATmpEN;AShpEI;EACE,gBAAA;EACA,cPrFO;EOsFP,uCPVM;EOWN,SAAA;ATkpEN;;AS5oEA;EN/FE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;AF0pEZ;ASjpEE;EACE,iCP1BW;EO2BX,gBAAA;EACA,cPnGS;EOoGT,mBAAA;EACA,qCPvBQ;AF0qEZ;AS/oEE;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBPVS;EOWT,gBAAA;EACA,gBAAA;ATipEJ;AE9wEsB;EOuHpB;IASI,qBAAA;ETkpEJ;ESjpEI;IAAuB,aAAA;ETopE3B;AACF;ASjpEE;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;ATmpEJ;ASjpEI;EACE,gBAAA;EACA,qBAAA;EACA,yCPpDM;EOqDN,gBAAA;EACA,cPrIO;EOsIP,yBAAA;EACA,sBAAA;EACA,gCAAA;ATmpEN;ASjpEM;EAAsB,iBAAA;ATopE5B;ASjpEI;EACE,qBAAA;EACA,uCP/DM;EOgEN,cP9IO;EO+IP,gCAAA;EACA,sBAAA;ATmpEN;ASjpEM;EAAsB,iBAAA;ATopE5B;ASlpEM;EACE,gBAAA;ATopER;AEj0Ec;EO4KR;IAGgB,gBAAA;ETspEpB;AACF;ASrpEQ;ENvKN,gBAAA;EACA,mBAAA;EACA,uBAAA;EMqK6B,SAAA;AT2pE/B;ASvpEI;EAAmB,mBAAA;AT0pEvB;AEp0EsB;EO6KhB;IAAc,mBPvKP;EFk0EX;AACF;ASxpEE;EACE,oBAAA;EACA,sBAAA;EACA,qBP/DU;EOgEV,mBPhJS;EOiJT,cP9IS;EO+IT,yCP7FQ;EO8FR,gBAAA;AT0pEJ;ASvpEE;EN/MA,aAAA;EACA,mBAAA;EACA,uBAAA;EM+ME,sBAAA;EACA,eAAA;EACA,cPrLS;EOsLT,WAAA;EACA,uCPtGQ;AFiwEZ;;AU72EA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,iBAAA;AVg3EF;AEh3Ec;EQLd;IAQI,mBAAA;IACA,4BAAA;EVi3EF;AACF;AEr3Ec;EQNd;IAaI,4BAAA;EVk3EF;AACF;;AU92EA;EPYE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,aOfc;EPiHd,gBAAA;EACA,iCAAA;AHqwEF;AEx3EsB;EQAtB;IPuHI,qBAAA;EHqwEF;EGpwEE;IAAuB,aAAA;EHuwEzB;AACF;AEj4EsB;EQCtB;IP4HI,qBAAA;IACA,gCAAA;EHwwEF;EGtwEE;IAAuB,UAAA;EHywEzB;EGxwEE;IAA6B,mBD1HpB;IC0H4C,kBAAA;EH4wEvD;EG3wEE;IAA6B,mBDzHpB;ICyH4C,kBAAA;EH+wEvD;EG9wEE;IAAmC,mBDzH1B;EF04EX;AACF;AUp5EA;EAGE,cAAA;EAGA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AVk5EF;AE/5EsB;EQAtB;IAgBI,qBAAA;EVm5EF;EUl5EE;IAAuB,aAAA;EVq5EzB;AACF;AEp7Ec;EQad;IAqBI,sBAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,YAAA;EVs5EF;AACF;AE97Ec;EQYd;IA+BI,YAAA;EVu5EF;AACF;AUr5EE;EACE,yCRsDQ;EQrDR,gBAAA;EACA,cR5BS;EQ6BT,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AVu5EJ;AEr8EiB;EQuCf;IAUoB,aAAA;EVw5EpB;AACF;AUt5EE;EP9DA,aAAA;EACA,mBAAA;EACA,8BAAA;EO8DE,sBAAA;EACA,mBR+DS;EQ9DT,gBAAA;EACA,uCRsCQ;EQrCR,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;EACA,gBAAA;EACA,mBAAA;EACA,cR/CS;AFy8Eb;AUx5EI;EACE,mBR7CO;EQ8CP,cR1CO;AFo8Eb;AE19EsB;EQoEhB;IAAuB,mBR9DhB;EFw9EX;AACF;AUv5EE;EPhFA,aAAA;EACA,mBAAA;EACgB,aO+EM;EACpB,wBAAA;EACA,mBRuCS;EQtCT,gBAAA;EACA,uCRcQ;EQbR,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;EACA,gBAAA;EACA,mBAAA;EACA,cRxES;AFm+Eb;AUz5EI;EACE,mBRrEO;EQsEP,cRlEO;AF69Eb;AEn/EsB;EQ4FhB;IAAuB,mBRtFhB;EFi/EX;AACF;AUx5EE;EACE,iBAAA;EACA,wBAAA;EACA,qBRkBU;EQjBV,mBRjDS;EQkDT,cRhGS;EQiGT,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AV05EJ;AEvgFiB;EQgHf;IACoB,aAAA;EV05EpB;AACF;AU55EE;EAEE,YAAA;EACA,6BAAA;EACA,SAAA;AV65EJ;;AUx5EA;EPxGE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UOqGc;EACd,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AV+5EF;AEtiFc;EQiId;IASI,YAAA;IACA,UAAA;IACA,YAAA;EVg6EF;AACF;AE5iFc;EQgId;IAcgB,YAAA;EVk6Ed;AACF;AUj6EE;EPnJA,aAAA;EACA,mBAAA;EACA,8BAAA;EOmJE,sBAAA;EACA,gCAAA;EACA,cAAA;AVq6EJ;AUn6EI;EACE,gBAAA;EACA,cRhIO;EQiIP,uCRnDM;AFw9EZ;AUj6EE;EACE,SAAA;EPhCF,gBAAA;EACA,iCAAA;AHo8EF;AEvjFsB;EQiJpB;IP1BE,qBAAA;EHo8EF;EGn8EE;IAAuB,aAAA;EHs8EzB;AACF;AEhkFsB;EQkJpB;IPrBE,qBAAA;IACA,gCAAA;EHu8EF;EGr8EE;IAAuB,UAAA;EHw8EzB;EGv8EE;IAA6B,mBD1HpB;IC0H4C,kBAAA;EH28EvD;EG18EE;IAA6B,mBDzHpB;ICyH4C,kBAAA;EH88EvD;EG78EE;IAAmC,mBDzH1B;EFykFX;AACF;AU77EE;EP3KA,aAAA;EACA,mBAAA;EACA,uBAAA;EO2KE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cRnJS;EQoJT,uCRnEQ;AFogFZ;;AU57EA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AV+7EF;AU77EE;EACE,8BAAA;EACA,8BAAA;AV+7EJ;AU57EE;EAAa,mBR/JF;AF8lFb;AEhnFsB;EQoLlB;IAAyB,mBR9KhB;EF8mFX;AACF;AU97EE;EACE,kBAAA;EACA,cAAA;AVg8EJ;AU97EI;EACE,aAAA;EACA,cAAA;EACA,qBRzEQ;EQ0ER,iBAAA;AVg8EN;AU57EE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AV87EJ;AU37EE;EACE,SAAA;EACA,YAAA;AV67EJ;AU17EE;EP5NA,aAAA;EACA,mBAAA;EACA,8BAAA;EO4NE,qBAAA;AV87EJ;AU37EE;EACE,uCRzHQ;EQ0HR,gBAAA;EACA,cRzMS;ECdX,gBAAA;EACA,mBAAA;EACA,uBAAA;AHqpFF;AU77EI;EACE,gBAAA;EACA,cR5MO;AF2oFb;AU37EE;EACE,yCRtIQ;EQuIR,cRvNS;EQwNT,mBAAA;EACA,mBAAA;AV67EJ;AU17EE;EACE,uCR5IQ;EQ6IR,cR7NS;ECZX,gBAAA;EACA,mBAAA;EACA,uBAAA;EOyOE,sBAAA;AV87EJ;AU37EE;EPrPA,aAAA;EACA,mBAAA;EACgB,aOoPM;AV+7ExB;AU57EE;EACE,kBAAA;EACA,sBAAA;EACA,qBR/HU;EQgIV,mBR9OS;EQ+OT,cR3OS;EQ4OT,yBAAA;EACA,gBAAA;EACA,sBAAA;AV87EJ;;AUz7EA;EPjPE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UO8Oc;EACd,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AVg8EF;AE/sFc;EQ0Qd;IAOgB,YAAA;EVk8Ed;AACF;AUh8EE;EP5RA,aAAA;EACA,mBAAA;EACA,uBAAA;EO4RE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,cRpQS;AFwsFb;AUl8EI;EACE,uCRrLM;EQsLN,gBAAA;AVo8EN;AUh8EE;EPpSA,aAAA;EACA,mBAAA;EACA,8BAAA;EOoSE,sCAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;AVo8EJ;AUj8EE;EPtSA,aAAA;EACA,mBAAA;EACgB,aOqSM;AVq8ExB;AUn8EI;EACE,WAAA;EACA,YAAA;EACA,qBR/KQ;EQgLR,iBAAA;EACA,cAAA;AVq8EN;AUj8EE;EACE,gBAAA;EACA,cR7RS;EQ8RT,SAAA;EACA,uCRlNQ;AFqpFZ;AUh8EE;EACE,uCRvNQ;EQwNR,cRxSS;EQyST,oBAAA;AVk8EJ;AU/7EE;EACE,SAAA;EPrMF,gBAAA;EACA,iCAAA;AHuoFF;AE1vFsB;EQsTpB;IP/LE,qBAAA;EHuoFF;EGtoFE;IAAuB,aAAA;EHyoFzB;AACF;AEnwFsB;EQuTpB;IP1LE,qBAAA;IACA,gCAAA;EH0oFF;EGxoFE;IAAuB,UAAA;EH2oFzB;EG1oFE;IAA6B,mBD1HpB;IC0H4C,kBAAA;EH8oFvD;EG7oFE;IAA6B,mBDzHpB;ICyH4C,kBAAA;EHipFvD;EGhpFE;IAAmC,mBDzH1B;EF4wFX;AACF;AUh+EE;EAGE,iCAAA;AVg+EJ;AU79EE;EACE,sBAAA;EACA,mBR7MS;EQ8MT,mBRzTS;EQ0TT,mBAAA;AV+9EJ;AU79EI;EACE,yCR1OM;EQ2ON,cR1TO;EQ2TP,mBAAA;AV+9EN;AU59EI;EACE,uCR/OM;EQgPN,cR9TO;EQ+TP,SAAA;AV89EN;AU19EE;EACE,cRpUS;EQqUT,iBAAA;EACA,uCRvPQ;EQwPR,mBAAA;AV49EJ;AUz9EE;EACE,uCR7PQ;EQ8PR,cR/US;AF0yFb;AUx9EE;EACE,kBAAA;EACA,sBAAA;EACA,mBR7OS;EQ8OT,mBR5TS;EQ6TT,yBAAA;AV09EJ;AUx9EI;EACE,yCR1QM;EQ2QN,cR9TO;EQ+TP,gBAAA;EACA,oBAAA;AV09EN;AUv9EI;EACE,uCRhRM;EQiRN,cAAA;EACA,SAAA;AVy9EN;AUp9EE;EACE,kCAAA;EACA,6BAAA;EACA,cAAA;AVs9EJ;AUp9EI;EPtTF,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBD8CW;EC7CX,+BAAA;EACA,mBDhEW;ECiEX,kCDgBa;ECfb,eAAA;EACA,gBAAA;EACA,cD7DW;EC8DX,oFAAA;EAEA,gBAAA;AH6wFF;AEv2Fc;EQoYV;IPxSY,YAAA;EH+wFd;AACF;AG9wFE;EACE,aAAA;EACA,mBD9ES;EC+ET,qBDhES;ECiET,6CAAA;AHgxFJ;AG7wFE;EAAiB,cD9EN;AF81Fb;AUj/EI;EAEE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBR1QO;EQ2QP,YAAA;AVk/EN;AU9+EE;EP/YA,aAAA;EACA,mBAAA;EACA,8BAAA;EO+YE,oBAAA;AVk/EJ;AUh/EI;EACE,yCR5SM;EQ6SN,cR7XO;AF+2Fb;;AU5+EA;EACE,aAAA;EACA,MAAA;EACA,mBRzYW;EQ0YX,mBR/RW;EQgSX,gBAAA;EACA,sBAAA;AV++EF;AE94Fc;EQyZd;IAQgB,aAAA;EVi/Ed;AACF;AUh/EE;EACE,SAAA;EACA,uBAAA;EACA,sBRzSS;EQ0ST,yCRjUQ;EQkUR,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,cRnZS;EQoZT,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AVk/EJ;AUh/EI;EACE,mBRjaO;EQkaP,wER/Sc;EQgTd,cRnZO;AFq4Fb;;AW96FA;EACE,aAAA;EACA,0BAAA;EACA,6BAAA;AXi7FF;AE36Fc;ESTd;IAKgB,8BAAA;EXm7Fd;AACF;;AWh7FA;ERwBE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;ES/GV,gBAAA;AXu7FF;AWp7FE;EACE,kCT4FW;ES3FX,YAAA;EACA,WAAA;EACA,uCT6FQ;AFy1FZ;AWn7FM;EACE,uCT0FI;ESzFJ,gBAAA;EACA,cTSK;ESRL,sBT4GK;ES3GL,gBAAA;AXq7FR;AE37FsB;ESSZ;IAAU,mBTFP;EFw7FX;AACF;AWl7FI;EACE,yCT2EM;ES1EN,gBAAA;EACA,cTPO;ESQP,yBAAA;EACA,sBAAA;EACA,qBAAA;AXo7FN;AWl7FM;EAAO,qBAAA;AXq7Fb;AWl7FI;EACE,uCTiEM;EShEN,mBTuFO;EStFP,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;AXo7FN;AEn9FsB;ESkCd;IACE,mBT5BG;EFg9FX;AACF;AWj7FM;EACE,mBTtBK;ESuBL,cTnBK;ESoBL,gBAAA;AXm7FR;AWh7FM;EACE,8BAAA;EACA,yBAAA;EACA,mBTkEK;AFg3Fb;;AW36FA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AX86FF;AW56FE;EACE,UAAA;EACA,WAAA;EACA,qBTqDU;AFy3Fd;AW56FI;EAAgB,mBT5BP;AF28Fb;AW96FI;EAAgB,mBTrCP;AFs9Fb;AWh7FI;EAAgB,mBTtBP;AFy8Fb;AWh7FE;EACE,kBAAA;EACA,cT9DS;ES+DT,cAAA;EACA,kBAAA;AXk7FJ;;AW76FA;ERnEE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;ECaV,gBAAA;EACA,iCAAA;AHm5FF;AEtgGsB;ES+EtB;IRwCI,qBAAA;EHm5FF;EGl5FE;IAAuB,aAAA;EHq5FzB;AACF;AE/gGsB;ESgFtB;IR6CI,qBAAA;IACA,gCAAA;EHs5FF;EGp5FE;IAAuB,UAAA;EHu5FzB;EGt5FE;IAA6B,mBD1HpB;IC0H4C,kBAAA;EH05FvD;EGz5FE;IAA6B,mBDzHpB;ICyH4C,kBAAA;EH65FvD;EG55FE;IAAmC,mBDzH1B;EFwhGX;AACF;AWn9FA;EAGE,iBAAA;AXm9FF;AEjjGc;ES2Fd;IAKgB,gBAAA;EXq9Fd;AACF;AWp9FE;EACE,iCTFW;ESGX,gBAAA;EACA,cT3ES;ES4ET,gBAAA;EACA,qCTCQ;AFq9FZ;AWn9FE;EACE,uCTLQ;ESMR,cTtFS;ESuFT,kBAAA;EACA,iBAAA;AXq9FJ;AWl9FE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AXo9FJ;;AW/8FA;EACE,kCAAA;EACA,mBTEW;ESDX,mBT3GW;ES4GX,yBAAA;EACA,kCAAA;AXk9FF;AErkGsB;ESsHlB;IAAU,qBTnGD;EFsjGX;AACF;AWj9FE;EACE,uCT/BQ;ESgCR,cT9GS;ES+GT,oBAAA;ERvHF,oBAAA;EACA,qBQuHsB;ERtHtB,4BAAA;EACA,gBAAA;AH2kGF;AWn9FE;ER9IA,aAAA;EACA,mBAAA;EACA,8BAAA;EQ8IE,eAAA;EACA,WAAA;AXu9FJ;AWp9FE;ER9IA,aAAA;EACA,mBAAA;EACgB,YQ6IM;EACpB,eAAA;AXw9FJ;AWr9FE;ERnJA,aAAA;EACA,mBAAA;EACgB,aQkJM;AXy9FxB;;AWp9FA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AXu9FF;AWr9FE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AXu9FJ;AWr9FI;ERnHF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AH2kGF;AGzkGE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AH2kGJ;AGxkGE;EAAW,sBAAA;AH2kGb;AW3+FI;EAEE,wBAAA;EACA,qBT1CQ;ES2CR,uCTrEM;ESsEN,gBAAA;EACA,mBT3JO;ES4JP,cTvJO;ESwJP,YAAA;EACA,gBAAA;AX4+FN;AW1+FM;EACE,mBTtJK;ESuJL,cTpJK;AFgoGb;AErpGsB;ES6Kd;IAAuB,mBTrKlB;EFipGX;AACF;;AWt+FA;ERvKE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UQoKc;EACd,gBAAA;AX6+FF;AW3+FE;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;AX6+FJ;AEvqGsB;ESuLpB;IAMI,qBAAA;EX8+FJ;EW7+FI;IAAuB,aAAA;EXg/F3B;AACF;AW7+FE;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;AX++FJ;AW7+FI;EACE,mBTnMO;ESoMP,gCAAA;AX++FN;AW7+FM;EACE,gBAAA;EACA,qBAAA;EACA,uCTpHI;ESqHJ,gBAAA;EACA,cTrMK;ESsML,mBAAA;AX++FR;AW3+FI;EACE,gCAAA;EACA,iCAAA;AX6+FN;AW3+FM;EAAe,mBAAA;AX8+FrB;AExsGsB;ES6Nd;IAAU,mBTvNL;EFssGX;AACF;AW7+FM;EACE,yBAAA;EACA,uCTvII;ESwIJ,cTtNK;ESuNL,sBAAA;AX++FR;AW3+FI;EACE,gBAAA;AX6+FN;AEhuGc;ESkPV;IAGgB,gBAAA;EX++FlB;AACF;AW9+FM;ER9OJ,gBAAA;EACA,mBAAA;EACA,uBAAA;EQ4O2B,SAAA;AXo/F7B;AWj/FI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AXm/FN;AWh/FI;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AXk/FN;;AW5+FA;ERnPE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,iCDqFU;EC1HV,aAAA;EACA,mBAAA;EACA,uBAAA;EQqRA,sBAAA;EACA,YAAA;EACA,+BAAA;EACA,cT5PW;ES6PX,kBAAA;AXq/FF;AWn/FE;EAAM,YAAA;AXs/FR;AWp/FE;EACE,uCTjLQ;ESkLR,SAAA;AXs/FJ;;AYvxGA;EACE,sBAAA;EACA,qBVuIY;EUtIZ,mBVmCW;EUlCX,yBAAA;EACA,uCV0GU;EUzGV,gBAAA;EACA,cVkCW;EUjCX,mBAAA;EACA,cAAA;AZ0xGF;;AYtxGA;EACE,aAAA;EACA,qCAAA;EACA,8BAAA;AZyxGF;AEnyGc;EUOd;IAKiB,qCAAA;EZ2xGf;AACF;AEvyGc;EUMd;IAMiB,qCAAA;EZ+xGf;AACF;AE3yGc;EUKd;IAOiB,qCAAA;EZmyGf;AACF;AE/yGc;EUId;IAQiB,qCAAA;EZuyGf;AACF;AEnzGc;EUGd;IASiB,qCAAA;EZ2yGf;AACF;;AYxyGA;ETOE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,kCSVc;EACd,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,6EAAA;EACA,eAAA;AZ+yGF;AE7zGsB;EUiBlB;IACE,2BAAA;IACA,8EVuGc;EFwsGlB;AACF;AEl0GsB;EUuBlB;IAAW,sBAAA;EZ+yGb;AACF;AY7yGE;EACE,qBVSS;EURT,yDAAA;AZ+yGJ;AY5yGE;ETpDA,aAAA;EACA,mBAAA;EACA,uBAAA;ESoDE,+BAAA;EACA,gCAAA;EACA,qBV+ES;AFiuGb;AY7yGE;EACE,gBAAA;EACA,uCVkDQ;EUjDR,cV3BS;EU4BT,0BAAA;EACA,SAAA;AZ+yGJ;AY5yGE;EACE,yCV0CQ;EUzCR,cVtCS;EUuCT,qBAAA;ETnDF,gBAAA;EACA,mBAAA;EACA,uBAAA;ESmDE,eAAA;AZgzGJ;AY7yGE;EACE,yCVkCQ;AF6wGZ;AY5yGE;ETlBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFAAA;EACA,wCAAA;AHi0GF;AG/zGE;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AHi0GJ;AG9zGE;EAAW,sBAAA;AHi0Gb;AYl0GE;EAEE,WAAA;EACA,uBAAA;EACA,mBVmDS;EUlDT,yCV0BQ;EUzBR,gBAAA;EACA,gBAAA;AZm0GJ;AYj0GI;EACE,mBVjDO;EUkDP,cVjEO;AFo4Gb;AEz4GsB;EUyEd;IAAU,mBVpDL;EFw3GX;AACF;AYj0GI;EACE,mBVvEO;EUwEP,cVnEO;EUoEP,YAAA;AZm0GN;AEn5GsB;EUmFd;IAAU,mBVnCL;IUmC0B,cV/B1B;EFo2GX;AACF;;AY/zGA;EACE,UAAA;EACA,WAAA;EACA,qBVwBY;EUvBZ,mBVxDW;EUyDX,qBAAA;EACA,cAAA;AZk0GF;AYh0GE;EAAkB,mBVzFP;AF45Gb;;Aaz7GA;EACE,uFAHW;EAIX,yBARS;EAST,cARa;EASb,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;Ab47GF;Aaz7GE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;Ab27GJ;Aax7GE;EACE,yBA7BW;EA8BX,cA/BO;EAgCP,yBAAA;Ab07GJ;Aax7GI;EACE,yBAhCY;EAiCZ,qBAjCY;EAkCZ,WAAA;Ab07GN;Aat7GE;EACE,6BAAA;EACA,cA1CW;EA2CX,0CAAA;Abw7GJ;Aat7GI;EACE,qBA9CS;EA+CT,2CAAA;Abw7GN;Aan7GE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,2BAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;Abq7GJ;Aan7GI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;Abq7GN;Aal7GI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;Abo7GN;Aal7GM;EACE,cA5EO;EA6EP,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;Abo7GR;Aal7GQ;EACE,cAjFQ;AbqgHlB;Aah7GM;EAjBF;IAkBI,aAAA;Ebm7GN;AACF;Aa96GE;EACE,SAAA;Abg7GJ;Aa76GE;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;Ab+6GJ;Aa76GI;EACE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;Ab+6GN;Aa76GM;EACE,cA/GU;EAgHV,kBAAA;EACA,qBAAA;Ab+6GR;Aa36GI;EACE,kBAAA;EACA,cAxHW;EAyHX,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;Ab66GN;Aa16GI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;Ab46GN;Aa16GM;EALF;IAMI,sBAAA;Eb66GN;AACF;Aaz6GE;EACE,iBAAA;EACA,sBAAA;Ab26GJ;Aaz6GI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;Ab26GN;Aax6GI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;Ab06GN;Aav6GI;EACE,yBAnKK;EAoKL,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,uDAAA;Aby6GN;Aav6GM;EACE,kBAAA;EACA,mBAAA;EACA,cAzKU;EA0KV,gBAAA;Aby6GR;Aat6GM;EACE,cA/KS;EAgLT,gBAAA;EACA,eAAA;Abw6GR;Aar6GM;EACE,2BAAA;EACA,sCAAA;Abu6GR;Aaj6GE;EACE,qBAAA;EACA,yBAAA;EACA,+CAAA;Abm6GJ;Aaj6GI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;Abm6GN;Aa/5GM;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;Abi6GR;Aa/5GM;EACE,cApNS;AbqnHjB;Aa75GI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;Ab+5GN;Aa75GM;EACE,cA9NS;EA+NT,qBAAA;EACA,2BAAA;EACA,gBAAA;Ab+5GR;Aa75GQ;EACE,cArOK;AbooHf;Aa15GI;EACE,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,+CAAA;EACA,iBAAA;EACA,cAAA;Ab45GN;;AcvoHA;EACE,mBZwBW;EYvBX,iBAAA;EACA,0DAAA;Ad0oHF;AcxoHE;EACE,gBAAA;EACA,cAAA;EACA,oCAAA;Ad0oHJ;ActoHE;EACE,qCAAA;AdwoHJ;AcroHE;EACE,uCZ6FQ;EY5FR,gBAAA;EACA,cZqBS;EYpBT,sBAAA;EACA,yBAAA;EACA,mBAAA;AduoHJ;AcpoHE;EACE,iCZ+EW;EY9EX,uCAAA;EACA,gBAAA;EACA,cZKS;EYJT,iBAAA;EACA,gBAAA;AdsoHJ;AcnoHE;EACE,qCZ6EQ;EY5ER,iBAAA;EACA,cZPS;EYQT,SAAA;AdqoHJ;;AchoHA;EXXE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UWQc;EACd,qCAAA;EACA,qCAAA;AduoHF;AcroHE;EACE,yCZ4DQ;EY3DR,gBAAA;EACA,cZtBS;EYuBT,sBAAA;EACA,yBAAA;EACA,mBAAA;AduoHJ;AcpoHE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AdsoHJ;AEhsHc;EYoDZ;IASI,qCAAA;EduoHJ;AACF;AcroHI;EACE,uCZwCM;EYvCN,gBAAA;EACA,cZtCO;EYuCP,qBAAA;EACA,4BAAA;AduoHN;AE9rHsB;EY0Dd;IACE,cZtCG;IYuCH,0BAAA;EduoHR;AACF;;AchoHA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;AdmoHF;;AchoHA;EX7DE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UW0Dc;EACd,oCAAA;EACA,uBAAA;AduoHF;AcroHE;EXvFA,aAAA;EACA,mBAAA;EACgB,aWsFM;EACpB,uBAAA;AdyoHJ;ActoHE;EXxGA,aAAA;EACA,mBAAA;EACA,uBAAA;EWwGE,cAAA;EACA,cAAA;EACA,eAAA;EACA,qBZ0BS;EYzBT,mBZxES;EYyET,cZtES;EYuET,iCZNW;EYOX,gBAAA;EACA,uCZHQ;AF6oHZ;AcvoHE;EACE,iCZZW;EYaX,gBAAA;EACA,uCAAA;EACA,cZtFS;EYuFT,SAAA;EACA,gBAAA;AdyoHJ;ActoHE;EACE,uCZfQ;EYgBR,gBAAA;EACA,cZlGS;EYmGT,kBAAA;AdwoHJ;AcroHE;EACE,gBAAA;EACA,cZpGS;AF2uHb;AcpoHE;EAGE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AdooHJ;AcloHI;EACE,uCZrCM;EYsCN,gBAAA;EACA,cZxHO;EYyHP,qBAAA;EACA,kBAAA;AdooHN;AcloHM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBZzBM;EY0BN,mBZ3HK;AF+vHb;AcjoHM;EACE,cZ9HK;EY+HL,gBAAA;EACA,qBAAA;AdmoHR;AExxHsB;EYwJZ;IACE,0BAAA;EdmoHV;AACF;Ac7nHE;EACE,mBZvJS;AFsxHb;;AepzHA;EACE,mBbyBW;EaxBX,iBAAA;EACA,0DAAA;AfuzHF;AerzHE;EACE,gBAAA;EACA,cAAA;EACA,oCAAA;AfuzHJ;AenzHE;EACE,qCAAA;AfqzHJ;AelzHE;EACE,uCb8FQ;Ea7FR,gBAAA;EACA,cbsBS;EarBT,sBAAA;EACA,yBAAA;EACA,mBAAA;AfozHJ;AejzHE;EACE,iCbgFW;Ea/EX,uCAAA;EACA,gBAAA;EACA,cbMS;EaLT,iBAAA;EACA,gBAAA;AfmzHJ;AehzHE;EACE,qCb8EQ;Ea7ER,iBAAA;EACA,cbNS;EaOT,SAAA;AfkzHJ;;Ae7yHA;EZVE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UYOc;EACd,qCAAA;EACA,qCAAA;AfozHF;AelzHE;EACE,yCb6DQ;Ea5DR,gBAAA;EACA,cbrBS;EasBT,sBAAA;EACA,yBAAA;EACA,mBAAA;AfozHJ;AejzHE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AfmzHJ;AE52Hc;EamDZ;IASI,qCAAA;EfozHJ;AACF;AelzHI;EACE,uCbyCM;EaxCN,gBAAA;EACA,cbrCO;EasCP,qBAAA;EACA,4BAAA;AfozHN;AE12HsB;EayDd;IACE,cbrCG;IasCH,0BAAA;EfozHR;AACF;;Ae7yHA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;AfgzHF;;Ae7yHA;EZ5DE,mBDRW;ECSX,mBDsGW;ECrGX,yBAAA;EACA,+EDyGkB;ECxGlB,UYyDc;EACd,oCAAA;EACA,uBAAA;AfozHF;AelzHE;EZtFA,aAAA;EACA,mBAAA;EACgB,aYqFM;EACpB,uBAAA;AfszHJ;AenzHE;EZvGA,aAAA;EACA,mBAAA;EACA,uBAAA;EYuGE,cAAA;EACA,cAAA;EACA,eAAA;EACA,qBb2BS;Ea1BT,mBbvES;EawET,cbrES;EasET,iCbLW;EaMX,gBAAA;EACA,uCbFQ;AFyzHZ;AepzHE;EACE,iCbXW;EaYX,gBAAA;EACA,uCAAA;EACA,cbrFS;EasFT,SAAA;EACA,gBAAA;AfszHJ;AenzHE;EACE,uCbdQ;EaeR,gBAAA;EACA,cbjGS;EakGT,kBAAA;AfqzHJ;AelzHE;EACE,gBAAA;EACA,cbnGS;AFu5Hb;AehzHE;EAGE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AfgzHJ;Ae9yHI;EACE,uCbrCM;EasCN,gBAAA;EACA,cbxHO;EayHP,qBAAA;EACA,kBAAA;AfgzHN;Ae7yHM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,qBb1BM;Ea2BN,mBb5HK;AF26Hb;Ae5yHM;EACE,cb/HK;EagIL,gBAAA;EACA,qBAAA;Af8yHR;AEp8HsB;EayJZ;IACE,0BAAA;Ef8yHV;AACF;AevyHE;EACE,mBbzJS;AFk8Hb;;AA37HA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;;CAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;IAAA,yBAAA;IAAA,4BAAA;IAAA,iBAAA;IAAA,iCAAA;IAAA,oBAAA;IAAA,oCAAA;IAAA,sBAAA;IAAA,+BAAA;IAAA,0BAAA;IAAA,yCAAA;IAAA,sBAAA;IAAA,qCAAA;IAAA,qBAAA;IAAA,8BAAA;IAAA,4BAAA;IAAA,mCAAA;IAAA,2BAAA;IAAA,0BAAA;IAAA,mBAAA;IAAA,cAAA;IAAA,sBAAA;IAAA,qBAAA;IAAA,mBAAA;IAAA,sBAAA;IAAA,+BAAA;EAAA;;AAAA;;;IAAA,sBAAA;IAAA,gCAAA;IAAA,wCAAA;EAAA;;AAAA;IAAA,sBAAA;IAAA,uBAAA;EAAA;;AAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,mCAAA;EAAA,kCAAA;IAAA,kCAAA;IAAA,eAAA;IAAA,kBAAA;IAAA,iBAAA;IAAA;AAAA;;AAAA;IAAA,iCAAA;IAAA,gBAAA;IAAA,wBAAA;IAAA,oBAAA;IAAA,gDAAA;IAAA,gBAAA;EAAA;;AAAA;IAAA,uCAAA;EAAA;;AAAA;IAAA,uCAAA;EAAA;;AAAA;IAAA,sCAAA;EAAA;;AAAA;IAAA,wCAAA;EAAA;;AAAA;IAAA,qCAAA;EAAA;;AAAA;IAAA,uCAAA;EAAA;;AAAA;IAAA,eAAA;IAAA,YAAA;EAAA;;AAAA;IAAA,gBAAA;IAAA,eAAA;EAAA;;AAAA;IAAA,oCAAA;IAAA,cAAA;EAAA;AAEA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,gEAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,gEAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,yEAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,2EAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,wEAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,gEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA,yFAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,mCAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA,kCAAA;IAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAmGA;EAAgB,iCEhCD;AFi9Hf;;AAh7HA;EAAgB,kCEhCD;AFo9Hf;;AE3iIsB;EF2HpB;IAA4B,UAAA;IAAY,WAAA;EAs7HxC;EAr7HA;IAA4B,mBErHjB;IFqHyC,kBAAA;EAy7HpD;EAx7HA;IAA4B,mBEpHjB;IFoHyC,kBAAA;EA47HpD;EA37HA;IAAkC,mBEpHvB;EFkjIX;AACF;AE5jIsB;EFiIpB;IAAsB,aAAA;EA+7HtB;EA97HA;IAAI,wBAAA;IAA0B,qBAAA;EAk8H9B;AACF;AA/7HA;EAAgB,cAAA;AAk8HhB;AEtlIc;EFoJd;IAA8C,aAAA;EAs8H5C;AACF;;AAt8HA;EAAgB,aAAA;AA08HhB;AE/lIc;EFqJd;IAA8C,cAAA;EA88H5C;AACF;AElmIc;EFmJd;IAA8E,aAAA;EAm9H5E;AACF;;AAn9HA;EAAgB,aAAA;AAu9HhB;AE3mIc;EFoJd;IAA8C,cAAA;EA29H5C;AACF;;AAz9HA;EAAe,qCAAA;AA69Hf;;AA59HA;EAAe,2CAAA;AAg+Hf;;AA/9HA;EAAe,uCAAA;AAm+Hf;;AAl+HA;EAAe,yCAAA;AAs+Hf;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,mBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ,QA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,iDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,iBA+lIR;EA/lIQ,iBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,4DA+lIR;EA/lIQ,mEA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,4DA+lIR;EA/lIQ,qEA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,4DA+lIR;EA/lIQ,oEA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,6CA+lIR;EA/lIQ,sDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,+EA+lIR;EA/lIQ,mGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,6EA+lIR;EA/lIQ,iGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,2GA+lIR;EA/lIQ,yGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,iBA+lIR;EA/lIQ,iBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,iBA+lIR;EA/lIQ,iBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,+EA+lIR;EA/lIQ,mGA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,yBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,yBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,gDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,iDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;AAAA;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;AAAA;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,0EA+lIR;EA/lIQ,8FA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,2BA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,+BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,2BA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,+BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,2BA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,+BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,wBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,wBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,wBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,0BA+lIR;EA/lIQ,wBA+lIR;EA/lIQ,yBA+lIR;EA/lIQ,8BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,0BA+lIR;EA/lIQ,qBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,mBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,sDA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,oDA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,2DA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,8DA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,4DA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,uBA+lIR;IA/lIQ,+DA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA,kBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,qBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,oBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,mBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,iBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA,iBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,eA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,mBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,mBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,kBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA;EA+lIR;AAAA;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA,mBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,kBA+lIR;IA/lIQ;EA+lIR;EA/lIQ;IAAA,mBA+lIR;IA/lIQ;EA+lIR;AAAA;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA,sBA+lIR;IA/lIQ,8BA+lIR;IA/lIQ;EA+lIR;AAAA;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;AAAA;;AA/lIQ;EAAA;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;EA/lIQ;IAAA;EA+lIR;AAAA;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,iDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,iDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kDA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,gBA+lIR;EA/lIQ,oBA+lIR;EA/lIQ,4BA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,sBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,WA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,mBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,qBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,kBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA,oBA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA,WA+lIR;EA/lIQ;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR;;AA/lIQ;EAAA;AA+lIR","sourcesContent":["// ============================================================\n// _animations.scss — Keyframes & Animation Utilities\n// ============================================================\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n@keyframes shimmer {\n  0%   { background-position: -400px 0; }\n  100% { background-position:  400px 0; }\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideInLeft {\n  from { opacity: 0; transform: translateX(-20px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideInRight {\n  from { opacity: 0; transform: translateX(20px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(100%); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.5; }\n}\n\n// ── Animation utility classes ────────────────────────────────\n.animate-slide-in       { animation: slideIn      0.3s  ease-out forwards; }\n.animate-slide-in-left  { animation: slideInLeft  0.3s  ease-out forwards; }\n.animate-slide-in-right { animation: slideInRight 0.3s  ease-out forwards; }\n.animate-slide-up       { animation: slideUp      0.35s ease-out forwards; }\n.animate-fade-in        { animation: fadeIn       0.3s  ease-out forwards; }\n.animate-spin           { animation: spin         0.8s  linear   infinite; }\n.animate-pulse          { animation: pulse        2s    ease-in-out infinite; }\n\n// ── Reduced motion ───────────────────────────────────────────\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration:        0.01ms !important;\n    animation-iteration-count: 1      !important;\n    transition-duration:       0.01ms !important;\n  }\n}\n","// ============================================================\n// main.scss — SocialHub Master SCSS Entry Point\n//\n// Import order matters:\n//  1. Tailwind directives (must come first)\n//  2. Font imports\n//  3. Design tokens (variables)\n//  4. Mixins (depends on variables)\n//  5. Animations (standalone)\n//  6. Base / reset\n//  7. Layout system\n//  8. Shared components\n//  9. Platform utilities\n// 10. Page-specific modules\n// ============================================================\n\n\n// ── Core tokens & helpers ────────────────────────────────────\n@use 'variables'       as *;\n@use 'mixins'          as *;\n\n\n// ── Animations ───────────────────────────────────────────────\n@use 'animations';\n\n\n// ── Modules ──────────────────────────────────────────────────\n@use 'layout';\n@use 'components';\n@use 'platform-colors';\n\n// ── Pages ─────────────────────────────────────────────────────\n@use 'auth';\n@use 'dashboard';\n@use 'posts';\n@use 'analytics';\n@use 'inbox';\n@use 'scheduler';\n@use 'accounts';\n@use 'home.scss';\n@use 'termsCondition.scss';\n@use 'privacyPolicy.scss';\n\n// ── Tailwind ─────────────────────────────────────────────────\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n// ── Fonts ────────────────────────────────────────────────────\n@import '@fontsource/outfit/400.css';\n@import '@fontsource/outfit/500.css';\n@import '@fontsource/outfit/600.css';\n@import '@fontsource/outfit/700.css';\n@import '@fontsource/dm-sans/400.css';\n@import '@fontsource/dm-sans/500.css';\n@import '@fontsource/dm-sans/600.css';\n\n\n// ── Base / global reset ──────────────────────────────────────\n@layer base {\n  :root {\n    // shadcn/ui CSS variables (used by Tailwind config)\n    --background:           210 40% 98%;\n    --foreground:           222.2 84% 4.9%;\n    --card:                 0 0% 100%;\n    --card-foreground:      222.2 84% 4.9%;\n    --popover:              0 0% 100%;\n    --popover-foreground:   222.2 84% 4.9%;\n    --primary:              239 84% 67%;\n    --primary-foreground:   0 0% 100%;\n    --secondary:            210 40% 96.1%;\n    --secondary-foreground: 222.2 47.4% 11.2%;\n    --muted:                210 40% 96.1%;\n    --muted-foreground:     215.4 16.3% 46.9%;\n    --accent:               330 81% 60%;\n    --accent-foreground:    0 0% 100%;\n    --destructive:          0 84.2% 60.2%;\n    --destructive-foreground: 0 0% 100%;\n    --border:               214.3 31.8% 91.4%;\n    --input:                214.3 31.8% 91.4%;\n    --ring:                 239 84% 67%;\n    --radius:               1rem;\n    --success:              160 84% 39%;\n    --warning:              38 92% 50%;\n    --info:                 217 91% 60%;\n\n    // Sidebar dimensions\n    --sidebar-width:           #{$sidebar-width};\n    --sidebar-collapsed-width: #{$sidebar-collapsed-width};\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n    @apply border-border;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  html {\n    -webkit-text-size-adjust: 100%;\n    text-size-adjust: 100%;\n    scroll-behavior: smooth;\n  }\n\n  body {\n    @apply bg-background text-foreground antialiased;\n    font-family: $font-body;\n    font-size: 1rem;\n    overflow-x: hidden;\n    min-height: 100vh;\n    min-height: 100dvh;\n  }\n\n  // Headings\n  h1, h2, h3, h4, h5, h6 {\n    font-family: $font-heading;\n    @apply font-bold tracking-tight text-slate-900;\n    line-height: 1.2;\n  }\n\n  h1 { font-size: $text-4xl; }\n  h2 { font-size: $text-3xl; }\n  h3 { font-size: $text-2xl; }\n  h4 { font-size: $text-xl; }\n  h5 { font-size: $text-lg; }\n  h6 { font-size: $text-base; }\n\n  // Media defaults\n  img, video, svg { max-width: 100%; height: auto; }\n\n  // WCAG tap targets\n  button, a, [role=\"button\"] {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  // Selection\n  ::selection {\n    background: rgba(#6366f1, 0.18);\n    color: #4f46e5;\n  }\n}\n\n// ── Font helpers ─────────────────────────────────────────────\n.font-heading { font-family: $font-heading; }\n.font-body    { font-family: $font-body; }\n\n// ── Scrollbar (desktop only) ─────────────────────────────────\n@include hover-device {\n  ::-webkit-scrollbar       { width: 8px; height: 8px; }\n  ::-webkit-scrollbar-track { background: $slate-100; border-radius: 4px; }\n  ::-webkit-scrollbar-thumb { background: $slate-300; border-radius: 4px; }\n  ::-webkit-scrollbar-thumb:hover { background: $slate-400; }\n}\n\n@include touch-device {\n  ::-webkit-scrollbar { display: none; }\n  * { -ms-overflow-style: none; scrollbar-width: none; }\n}\n\n// ── Visibility helpers ───────────────────────────────────────\n.mobile-only  { display: block; @include sm { display: none; } }\n.tablet-only  { display: none;  @include sm { display: block; } @include lg { display: none; } }\n.desktop-only { display: none;  @include lg { display: block; } }\n\n// ── Safe-area helpers ────────────────────────────────────────\n.safe-top    { padding-top:    env(safe-area-inset-top); }\n.safe-bottom { padding-bottom: env(safe-area-inset-bottom); }\n.safe-left   { padding-left:   env(safe-area-inset-left); }\n.safe-right  { padding-right:  env(safe-area-inset-right); }\n\n","// ============================================================\n// _layout.scss — App Shell, Sidebar, Bottom Nav, Page Header\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── App Shell ────────────────────────────────────────────────\n.app-shell {\n  display: flex;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow-x: hidden;\n  background: #f8fafc;\n}\n\n// ── Sidebar ──────────────────────────────────────────────────\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  height: 100dvh;\n  width: $sidebar-width;\n  z-index: $z-sidebar;\n  transform: translateX(-100%);\n  transition: transform $transition-slow, width $transition-slow;\n  @include glass(0.92);\n  border-right: 1px solid rgba($slate-200, 0.6);\n  @include scrollable;\n  @include safe-bottom;\n\n  &.open {\n    transform: translateX(0);\n    box-shadow: $shadow-dropdown;\n  }\n\n  // ── Tablet: collapsed icon rail ──────────────────────────\n  @include md {\n    position: sticky;\n    transform: translateX(0);\n    width: $sidebar-collapsed-width;\n    flex-shrink: 0;\n    box-shadow: none;\n\n    &.expanded { width: $sidebar-width; }\n\n    .sidebar__label,\n    .sidebar__section-title {\n      opacity: 0;\n      pointer-events: none;\n      width: 0;\n      overflow: hidden;\n      white-space: nowrap;\n      transition: opacity $transition-slow, width $transition-slow;\n    }\n\n    &.expanded {\n      .sidebar__label,\n      .sidebar__section-title {\n        opacity: 1;\n        pointer-events: auto;\n        width: auto;\n      }\n    }\n  }\n\n  // ── Desktop: always full ─────────────────────────────────\n  @include lg {\n    width: $sidebar-width;\n\n    .sidebar__label,\n    .sidebar__section-title {\n      opacity: 1;\n      pointer-events: auto;\n      width: auto;\n    }\n  }\n}\n\n// Sidebar nav items\n.sidebar__nav-item {\n  @include flex-start(0.75rem);\n  padding: 0.625rem 1rem;\n  border-radius: $radius-lg;\n  font-size: $text-sm;\n  font-weight: 500;\n  color: $slate-600;\n  cursor: pointer;\n  transition: background $transition-base, color $transition-base;\n  min-height: 44px;\n  text-decoration: none;\n\n  &:hover { background: $slate-50; color: $slate-900; }\n\n  &.active {\n    background: $indigo-50;\n    color: $indigo-600;\n    font-weight: 600;\n  }\n\n  svg { flex-shrink: 0; }\n}\n\n// Mobile overlay backdrop\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba($slate-900, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: $z-overlay;\n  animation: fadeIn 0.2s ease-out;\n\n  &.active { display: block; }\n\n  @include md { display: none !important; }\n}\n\n// ── Mobile Top Bar ───────────────────────────────────────────\n.mobile-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: $z-sticky;\n  height: 56px;\n  padding: 0 1rem;\n  @include safe-left;\n  @include safe-right;\n  @include glass(0.9);\n  border-bottom: 1px solid $slate-200;\n\n  @include md { display: none; }\n\n  &__logo {\n    @include flex-start(0.625rem);\n    font-family: $font-heading;\n    font-weight: 700;\n    font-size: 1.125rem;\n    color: $slate-900;\n  }\n\n  &__hamburger {\n    @include flex-center;\n    width: 44px;\n    height: 44px;\n    border-radius: $radius-md;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    color: $slate-700;\n    transition: background $transition-base;\n\n    &:hover { background: $slate-100; }\n  }\n}\n\n// ── Main Content ─────────────────────────────────────────────\n.main-content {\n  flex: 1;\n  min-width: 0;\n  overflow-x: hidden;\n  padding-bottom: calc(#{$bottom-nav-height} + env(safe-area-inset-bottom));\n\n  @include md { padding-bottom: 0; }\n}\n\n// ── Page Wrapper ─────────────────────────────────────────────\n.page-wrapper {\n  padding: $space-sm;\n\n  @include sm  { padding: $space-md; }\n  @include lg  { padding: $space-lg; }\n}\n\n// ── Page Header ──────────────────────────────────────────────\n.page-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: clamp(1.5rem, 4vw, 2rem);\n\n  @include sm {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  &__title-group {\n    @include flex-start(clamp(0.75rem, 2vw, 1rem));\n  }\n\n  &__icon {\n    @include page-icon;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-size: $text-3xl;\n    font-weight: 700;\n    color: $slate-900;\n    line-height: 1.2;\n    margin: 0;\n  }\n\n  &__subtitle {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0.125rem 0 0;\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    align-items: center;\n\n    @include max-sm { width: 100%; > * { flex: 1; } }\n  }\n}\n\n// ── Bottom Navigation (mobile only) ─────────────────────────\n.bottom-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: $z-overlay;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  height: calc(#{$bottom-nav-height} + env(safe-area-inset-bottom));\n  padding-bottom: env(safe-area-inset-bottom);\n  @include glass(0.95);\n  border-top: 1px solid $slate-200;\n\n  @include md { display: none; }\n\n  &__item {\n    @include flex-center;\n    flex-direction: column;\n    gap: 3px;\n    flex: 1;\n    min-height: 48px;\n    font-size: 0.62rem;\n    font-weight: 600;\n    color: $slate-400;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    cursor: pointer;\n    border: none;\n    background: transparent;\n    transition: color $transition-base;\n    text-decoration: none;\n\n    svg { width: 22px; height: 22px; }\n\n    &.active { color: $indigo-500; }\n  }\n}\n\n// ── Responsive container ────────────────────────────────────\n.container-responsive {\n  width: 100%;\n  padding-left:  clamp(1rem, 4vw, 2rem);\n  padding-right: clamp(1rem, 4vw, 2rem);\n  margin: 0 auto;\n  max-width: 1440px;\n}\n","// ============================================================\n// _variables.scss — Design Tokens & Breakpoints\n// ============================================================\n\n// ── Breakpoints ─────────────────────────────────────────────\n$bp-xs:  480px;   // small phones\n$bp-sm:  640px;   // large phones\n$bp-md:  768px;   // tablets / landscape phones\n$bp-lg:  1024px;  // laptops / small desktops\n$bp-xl:  1280px;  // large desktops\n$bp-2xl: 1536px;  // extra-large screens\n\n// ── Mixins ───────────────────────────────────────────────────\n@mixin xs   { @media (min-width: #{$bp-xs})  { @content; } }\n@mixin sm   { @media (min-width: #{$bp-sm})  { @content; } }\n@mixin md   { @media (min-width: #{$bp-md})  { @content; } }\n@mixin lg   { @media (min-width: #{$bp-lg})  { @content; } }\n@mixin xl   { @media (min-width: #{$bp-xl})  { @content; } }\n@mixin xxl  { @media (min-width: #{$bp-2xl}) { @content; } }\n\n// Max-width mixins (mobile-first overrides when needed)\n@mixin max-xs  { @media (max-width: #{$bp-xs - 1})  { @content; } }\n@mixin max-sm  { @media (max-width: #{$bp-sm - 1})  { @content; } }\n@mixin max-md  { @media (max-width: #{$bp-md - 1})  { @content; } }\n@mixin max-lg  { @media (max-width: #{$bp-lg - 1})  { @content; } }\n\n// Pointer / hover capability\n@mixin hover-device { @media (hover: hover) and (pointer: fine) { @content; } }\n@mixin touch-device { @media (hover: none) and (pointer: coarse) { @content; } }\n\n// ── Colors ───────────────────────────────────────────────────\n// Base palette\n$white:      #ffffff;\n$slate-50:   #f8fafc;\n$slate-100:  #f1f5f9;\n$slate-200:  #e2e8f0;\n$slate-300:  #cbd5e1;\n$slate-400:  #94a3b8;\n$slate-500:  #64748b;\n$slate-600:  #475569;\n$slate-700:  #334155;\n$slate-800:  #1e293b;\n$slate-900:  #0f172a;\n\n// Brand\n$indigo-50:  #eef2ff;\n$indigo-100: #e0e7ff;\n$indigo-500: #6366f1;\n$indigo-600: #4f46e5;\n$indigo-700: #4338ca;\n\n$purple-500: #8b5cf6;\n$purple-600: #7c3aed;\n\n$pink-500:   #ec4899;\n$rose-500:   #f43f5e;\n\n$blue-500:   #3b82f6;\n$cyan-500:   #06b6d4;\n\n$emerald-500: #10b981;\n$teal-500:    #14b8a6;\n\n$green-50:   #f0fdf4;\n$green-100:  #dcfce7;\n$green-500:  #22c55e;\n$green-600:  #16a34a;\n$green-700:  #15803d;\n\n$yellow-100: #fef9c3;\n$yellow-500: #eab308;\n$yellow-700: #a16207;\n\n$amber-500:  #f59e0b;\n\n$red-50:     #fef2f2;\n$red-200:    #fecaca;\n$red-300:    #fca5a5;\n$red-500:    #ef4444;\n$red-600:    #dc2626;\n\n$orange-500: #f97316;\n\n// ── Platform Colors ──────────────────────────────────────────\n$platforms: (\n  \"facebook\":          #1877F2,\n  \"twitter\":           #1DA1F2,\n  \"instagram\":         #E4405F,\n  \"linkedin\":          #0A66C2,\n  \"tiktok\":            #000000,\n  \"youtube\":           #FF0000,\n  \"pinterest\":         #E60023,\n  \"snapchat\":          #FFFC00,\n  \"reddit\":            #FF4500,\n  \"tumblr\":            #36465D,\n  \"telegram\":          #0088CC,\n  \"whatsapp_business\": #25D366,\n  \"discord\":           #5865F2,\n  \"twitch\":            #9146FF,\n  \"medium\":            #000000,\n  \"quora\":             #B92B27,\n  \"vk\":                #4C75A3,\n  \"weibo\":             #E6162D,\n  \"threads\":           #000000,\n  \"mastodon\":          #6364FF,\n  \"bluesky\":           #0085FF,\n  \"behance\":           #1769FF,\n  \"dribbble\":          #EA4C89,\n  \"github\":            #181717,\n  \"producthunt\":       #DA552F,\n);\n\n// ── Typography ───────────────────────────────────────────────\n$font-heading: 'Outfit', sans-serif;\n$font-body:    'DM Sans', sans-serif;\n\n// Fluid font sizes using clamp()\n$text-xs:   clamp(0.65rem,  1.5vw, 0.75rem);\n$text-sm:   clamp(0.8rem,   2vw,   0.875rem);\n$text-base: clamp(0.875rem, 2.5vw, 1rem);\n$text-lg:   clamp(1rem,     3vw,   1.125rem);\n$text-xl:   clamp(1.1rem,   3.5vw, 1.25rem);\n$text-2xl:  clamp(1.25rem,  4vw,   1.5rem);\n$text-3xl:  clamp(1.5rem,   5vw,   1.875rem);\n$text-4xl:  clamp(1.75rem,  6vw,   2.25rem);\n\n// ── Spacing ──────────────────────────────────────────────────\n$space-xs:  clamp(0.25rem, 1vw,  0.5rem);\n$space-sm:  clamp(0.5rem,  2vw,  1rem);\n$space-md:  clamp(1rem,    3vw,  1.5rem);\n$space-lg:  clamp(1.5rem,  4vw,  2.5rem);\n$space-xl:  clamp(2rem,    6vw,  4rem);\n\n// ── Layout ───────────────────────────────────────────────────\n$sidebar-width:           260px;\n$sidebar-collapsed-width: 72px;\n$bottom-nav-height:       60px;\n\n// ── Border Radius ────────────────────────────────────────────\n$radius-sm:  0.5rem;\n$radius-md:  0.75rem;\n$radius-lg:  1rem;\n$radius-xl:  1.5rem;\n$radius-2xl: 2rem;\n$radius-full: 9999px;\n\n// ── Shadows ──────────────────────────────────────────────────\n$shadow-sm:         0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);\n$shadow-card:       0 2px 16px rgba(15,23,42,0.06), 0 1px 4px rgba(15,23,42,0.04);\n$shadow-card-hover: 0 8px 30px rgba(15,23,42,0.10), 0 2px 8px rgba(15,23,42,0.06);\n$shadow-button:     0 4px 14px rgba(99,102,241,0.35);\n$shadow-dropdown:   0 10px 40px rgba(15,23,42,0.12), 0 2px 8px rgba(15,23,42,0.06);\n\n// ── Transitions ──────────────────────────────────────────────\n$transition-fast:   0.15s ease;\n$transition-base:   0.2s ease;\n$transition-slow:   0.3s ease;\n\n// ── Z-index scale ────────────────────────────────────────────\n$z-dropdown:  20;\n$z-sticky:    30;\n$z-overlay:   40;\n$z-sidebar:   50;\n$z-modal:     60;\n$z-toast:     100;\n","// ============================================================\n// _mixins.scss — Reusable SCSS Mixins\n// ============================================================\n@use 'variables' as *;\n\n// ── Flex helpers ─────────────────────────────────────────────\n@mixin flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@mixin flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@mixin flex-start($gap: 0) {\n  display: flex;\n  align-items: center;\n  @if $gap != 0 { gap: $gap; }\n}\n\n// ── Truncate text ────────────────────────────────────────────\n@mixin truncate {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin line-clamp($lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n// ── Card base ────────────────────────────────────────────────\n@mixin card($padding: $space-md) {\n  background: $white;\n  border-radius: $radius-2xl;\n  border: 1px solid $slate-100;\n  box-shadow: $shadow-card;\n  padding: $padding;\n}\n\n// ── Gradient icon container ──────────────────────────────────\n@mixin icon-box($from, $to, $size: 3.5rem, $radius: $radius-xl) {\n  width: $size;\n  height: $size;\n  border-radius: $radius;\n  background: linear-gradient(135deg, $from, $to);\n  flex-shrink: 0;\n  @include flex-center;\n}\n\n// ── Page header icon — responsive ───────────────────────────\n@mixin page-icon {\n  width: clamp(2.5rem, 6vw, 3.5rem);\n  height: clamp(2.5rem, 6vw, 3.5rem);\n  border-radius: $radius-xl;\n  flex-shrink: 0;\n  @include flex-center;\n}\n\n// ── Button base ──────────────────────────────────────────────\n@mixin btn-base {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  text-decoration: none;\n  white-space: nowrap;\n  min-height: 44px; // WCAG tap target\n  transition: transform $transition-base, box-shadow $transition-base, background-color $transition-base;\n  -webkit-tap-highlight-color: transparent;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n\n  &:active { transform: scale(0.97); }\n}\n\n// ── Input base ───────────────────────────────────────────────\n@mixin input-base {\n  width: 100%;\n  height: 44px;\n  padding: 0 1rem;\n  border-radius: $radius-lg;\n  border: 1.5px solid transparent;\n  background: $slate-50;\n  font-family: $font-body;\n  font-size: 1rem;   // ≥16px prevents iOS auto-zoom\n  font-weight: 500;\n  color: $slate-700;\n  transition: background-color $transition-base, border-color $transition-base, box-shadow $transition-base;\n  -webkit-appearance: none;\n  appearance: none;\n\n  @include sm { height: 48px; }\n\n  &:focus {\n    outline: none;\n    background: $white;\n    border-color: $indigo-500;\n    box-shadow: 0 0 0 4px rgba($indigo-500, 0.1);\n  }\n\n  &::placeholder { color: $slate-400; }\n}\n\n// ── Badge base ───────────────────────────────────────────────\n@mixin badge-base {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: $radius-full;\n  font-size: $text-xs;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n\n  @include md { padding: 0.25rem 0.75rem; }\n}\n\n// ── Glassmorphism ────────────────────────────────────────────\n@mixin glass($opacity: 0.92) {\n  background: rgba($white, $opacity);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n// ── Scrollable panel ─────────────────────────────────────────\n@mixin scrollable {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n\n  // Hide scrollbar on touch devices\n  @include touch-device {\n    scrollbar-width: none;\n    &::-webkit-scrollbar { display: none; }\n  }\n\n  @include hover-device {\n    scrollbar-width: thin;\n    scrollbar-color: $slate-300 $slate-100;\n\n    &::-webkit-scrollbar { width: 6px; }\n    &::-webkit-scrollbar-track { background: $slate-100; border-radius: 4px; }\n    &::-webkit-scrollbar-thumb { background: $slate-300; border-radius: 4px; }\n    &::-webkit-scrollbar-thumb:hover { background: $slate-400; }\n  }\n}\n\n// ── Platform color utility generator ────────────────────────\n@mixin platform-colors {\n  @each $name, $color in $platforms {\n    &-#{$name} { color: $color; }\n  }\n}\n\n@mixin platform-bg-colors {\n  @each $name, $color in $platforms {\n    &-#{$name} { background-color: $color; }\n  }\n}\n\n@mixin platform-border-colors {\n  @each $name, $color in $platforms {\n    &-#{$name} { border-color: $color; }\n  }\n}\n\n// ── Skeleton loader ──────────────────────────────────────────\n@mixin skeleton {\n  border-radius: $radius-sm;\n  background: linear-gradient(90deg, $slate-100 25%, $slate-200 50%, $slate-100 75%);\n  background-size: 800px 100%;\n  animation: shimmer 1.4s infinite linear;\n}\n\n// ── Safe area helpers ────────────────────────────────────────\n@mixin safe-bottom { padding-bottom: env(safe-area-inset-bottom); }\n@mixin safe-top    { padding-top: env(safe-area-inset-top); }\n@mixin safe-left   { padding-left: max(1rem, env(safe-area-inset-left)); }\n@mixin safe-right  { padding-right: max(1rem, env(safe-area-inset-right)); }\n","// ============================================================\n// _components.scss — Buttons, Inputs, Badges, Cards, Misc\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Buttons ──────────────────────────────────────────────────\n.btn-primary {\n  @include btn-base;\n  padding: 0.625rem 1.25rem;\n  font-size: $text-sm;\n  border-radius: $radius-full;\n  background: $indigo-500;\n  color: $white;\n  box-shadow: $shadow-button;\n\n  @include sm {\n    padding: 0.75rem 1.5rem;\n    font-size: $text-base;\n  }\n\n  @include hover-device {\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba($indigo-500, 0.45);\n    }\n  }\n}\n\n.btn-secondary {\n  @include btn-base;\n  padding: 0.625rem 1.25rem;\n  font-size: $text-sm;\n  border-radius: $radius-full;\n  background: $white;\n  color: $slate-700;\n  border: 1.5px solid $slate-200;\n  box-shadow: $shadow-sm;\n\n  @include sm {\n    padding: 0.75rem 1.5rem;\n    font-size: $text-base;\n  }\n\n  @include hover-device {\n    &:hover {\n      border-color: $slate-300;\n      box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n      transform: translateY(-1px);\n    }\n  }\n}\n\n.btn-gradient {\n  @include btn-base;\n  padding: 0.625rem 1.25rem;\n  font-size: $text-sm;\n  border-radius: $radius-full;\n  background: linear-gradient(135deg, $indigo-500, $purple-500);\n  color: $white;\n  box-shadow: $shadow-button;\n\n  @include sm {\n    padding: 0.75rem 1.5rem;\n    font-size: $text-base;\n  }\n\n  @include hover-device {\n    &:hover {\n      background: linear-gradient(135deg, $indigo-600, $purple-600);\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba($indigo-500, 0.45);\n    }\n  }\n}\n\n.btn-icon {\n  @include btn-base;\n  @include flex-center;\n  width: 44px;\n  height: 44px;\n  border-radius: $radius-full;\n  background: transparent;\n  border: none;\n  color: $slate-600;\n  transition: background $transition-base, color $transition-base;\n\n  &:hover { background: $slate-100; color: $slate-900; }\n}\n\n// Full-width on mobile, auto on tablet+\n.btn-full-mobile {\n  width: 100%;\n  @include sm { width: auto; }\n}\n\n// ── Inputs ───────────────────────────────────────────────────\n.input-primary {\n  @include input-base;\n\n  &.is-error {\n    border-color: $red-300;\n    &:focus { box-shadow: 0 0 0 4px rgba($red-500, 0.1); }\n  }\n}\n\n.input-primary.textarea {\n  height: auto;\n  min-height: 100px;\n  padding: 0.75rem 1rem;\n  resize: vertical;\n}\n\n// Password wrapper\n.input-password-wrap {\n  position: relative;\n\n  input { padding-right: 3rem; }\n\n  &__toggle {\n    position: absolute;\n    right: 0.875rem;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: $slate-400;\n    padding: 0;\n    @include flex-center;\n    min-height: unset;\n\n    &:hover { color: $slate-600; }\n  }\n}\n\n// ── Badges ───────────────────────────────────────────────────\n.badge-connected {\n  @include badge-base;\n  background: $green-100;\n  color: $green-700;\n}\n\n.badge-draft {\n  @include badge-base;\n  background: $yellow-100;\n  color: $yellow-700;\n}\n\n.badge-published {\n  @include badge-base;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.badge-scheduled {\n  @include badge-base;\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n.badge-failed {\n  @include badge-base;\n  background: $red-50;\n  color: $red-600;\n}\n\n// ── Stat Card ────────────────────────────────────────────────\n.stat-card {\n  @include card;\n  transition: border-color $transition-base, box-shadow $transition-base, transform $transition-base;\n\n  @include hover-device {\n    &:hover {\n      border-color: $indigo-100;\n      box-shadow: $shadow-card-hover;\n    }\n  }\n\n  &__label {\n    font-size: $text-sm;\n    font-weight: 500;\n    color: $slate-500;\n    margin: 0 0 0.25rem;\n  }\n\n  &__value {\n    font-family: $font-heading;\n    font-size: $text-3xl;\n    font-weight: 700;\n    color: $slate-900;\n    line-height: 1.1;\n  }\n\n  &__change {\n    @include flex-start(0.25rem);\n    margin-top: 0.5rem;\n    font-size: $text-sm;\n    font-weight: 500;\n\n    &--positive { color: $green-600; }\n    &--negative { color: $red-600; }\n  }\n\n  &__icon {\n    @include flex-center;\n    width: 3rem;\n    height: 3rem;\n    border-radius: $radius-xl;\n    flex-shrink: 0;\n    transition: transform $transition-base;\n\n    .stat-card:hover & { transform: scale(1.1); }\n  }\n}\n\n// Stat card responsive grid\n.stat-card-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(0.75rem, 2vw, 1.25rem);\n\n  @include xs  { grid-template-columns: repeat(2, 1fr); }\n  @include lg  { grid-template-columns: repeat(4, 1fr); }\n}\n\n// ── Platform Card ────────────────────────────────────────────\n.platform-card {\n  @include card;\n  cursor: pointer;\n  transition: transform $transition-base, box-shadow $transition-base, border-color $transition-base;\n\n  @include hover-device {\n    &:hover { transform: translateY(-4px); box-shadow: $shadow-card-hover; }\n  }\n\n  @include touch-device {\n    &:active { transform: scale(0.97); opacity: 0.9; }\n  }\n}\n\n.platform-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: clamp(0.75rem, 2vw, 1rem);\n\n  @include xs  { grid-template-columns: repeat(3, 1fr); }\n  @include md  { grid-template-columns: repeat(4, 1fr); }\n  @include lg  { grid-template-columns: repeat(5, 1fr); }\n  @include xl  { grid-template-columns: repeat(6, 1fr); }\n}\n\n// ── Platform Icon ────────────────────────────────────────────\n.platform-icon {\n  @include flex-center;\n  width: clamp(1.75rem, 5vw, 2.25rem);\n  height: clamp(1.75rem, 5vw, 2.25rem);\n  border-radius: $radius-full;\n  flex-shrink: 0;\n}\n\n// ── Metric Card (Analytics) ──────────────────────────────────\n.metric-card {\n  @include card;\n  transition: box-shadow $transition-base;\n\n  @include hover-device {\n    &:hover { box-shadow: $shadow-card-hover; }\n  }\n\n  &__header { @include flex-between; align-items: flex-start; }\n\n  &__label {\n    font-size: $text-sm;\n    font-weight: 500;\n    color: $slate-500;\n    margin: 0 0 0.25rem;\n  }\n\n  &__value {\n    font-family: $font-heading;\n    font-size: $text-3xl;\n    font-weight: 700;\n    color: $slate-900;\n  }\n\n  &__change {\n    @include flex-start(0.25rem);\n    margin-top: 0.5rem;\n    font-size: $text-sm;\n    font-weight: 500;\n\n    &--up   { color: $green-600; }\n    &--down { color: $red-600; }\n  }\n\n  &__icon {\n    @include flex-center;\n    width: 3rem;\n    height: 3rem;\n    border-radius: $radius-xl;\n    flex-shrink: 0;\n  }\n}\n\n// ── Spinner / Loader ─────────────────────────────────────────\n.spinner {\n  border: 3px solid $slate-100;\n  border-top: 3px solid $indigo-500;\n  border-radius: $radius-full;\n  width: 24px;\n  height: 24px;\n  animation: spin 0.8s linear infinite;\n  flex-shrink: 0;\n\n  &--sm { width: 16px; height: 16px; border-width: 2px; }\n  &--lg { width: 36px; height: 36px; }\n}\n\n// ── Skeleton ─────────────────────────────────────────────────\n.skeleton { @include skeleton; }\n\n// ── Toast ────────────────────────────────────────────────────\n.toast-container {\n  position: fixed;\n  z-index: $z-toast;\n  bottom: calc(#{$bottom-nav-height} + env(safe-area-inset-bottom) + 0.5rem);\n  left: 1rem;\n  right: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  pointer-events: none;\n\n  @include md {\n    bottom: 1.5rem;\n    right: 1.5rem;\n    left: auto;\n    max-width: 380px;\n  }\n}\n\n.toast {\n  background: $white;\n  border-radius: $radius-xl;\n  padding: 0.875rem 1rem;\n  box-shadow: $shadow-dropdown;\n  border: 1px solid $slate-200;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  pointer-events: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n// ── Modal ─────────────────────────────────────────────────────\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: $z-modal;\n  background: rgba($slate-900, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: flex-end;\n  animation: fadeIn 0.2s ease-out;\n\n  @include sm { align-items: center; justify-content: center; padding: 1rem; }\n}\n\n.modal-panel {\n  width: 100%;\n  max-height: 90dvh;\n  border-radius: $radius-xl $radius-xl 0 0;\n  overflow-y: auto;\n  padding: 1.5rem 1rem;\n  padding-bottom: max(1.5rem, env(safe-area-inset-bottom));\n  background: $white;\n  animation: slideUp 0.35s ease-out;\n\n  @include sm {\n    width: auto;\n    min-width: 480px;\n    max-width: 640px;\n    max-height: 85dvh;\n    border-radius: $radius-xl;\n    padding: 2rem;\n    animation: slideIn 0.3s ease-out;\n  }\n}\n\n// ── Filter Tabs ──────────────────────────────────────────────\n.filter-tabs {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n\n  &__tab {\n    @include btn-base;\n    padding: 0.5rem 1rem;\n    border-radius: $radius-full;\n    font-size: $text-sm;\n    font-weight: 500;\n    background: $slate-100;\n    color: $slate-600;\n    min-height: 38px;\n    border: none;\n\n    @include hover-device {\n      &:hover { background: $slate-200; }\n    }\n\n    &.active {\n      background: $indigo-50;\n      color: $indigo-600;\n      font-weight: 600;\n    }\n\n    &__count {\n      font-size: $text-xs;\n      opacity: 0.75;\n    }\n  }\n}\n\n// ── Date range toggle (Analytics) ───────────────────────────\n.date-range-toggle {\n  display: flex;\n  background: $slate-100;\n  border-radius: $radius-lg;\n  padding: 0.25rem;\n\n  &__btn {\n    padding: 0.5rem 1rem;\n    border-radius: $radius-md;\n    font-weight: 500;\n    font-size: $text-sm;\n    border: none;\n    background: transparent;\n    color: $slate-600;\n    cursor: pointer;\n    transition: background $transition-base, color $transition-base, box-shadow $transition-base;\n    min-height: 38px;\n\n    &.active {\n      background: $white;\n      box-shadow: $shadow-sm;\n      color: $indigo-600;\n    }\n  }\n}\n\n// ── Empty State ──────────────────────────────────────────────\n.empty-state {\n  @include flex-center;\n  flex-direction: column;\n  text-align: center;\n  padding: clamp(2rem, 6vw, 4rem) clamp(1rem, 4vw, 2rem);\n\n  &__icon {\n    @include flex-center;\n    width: clamp(4rem, 10vw, 5rem);\n    height: clamp(4rem, 10vw, 5rem);\n    border-radius: $radius-full;\n    background: $slate-100;\n    margin-bottom: 1rem;\n\n    svg { color: $slate-400; }\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-size: $text-xl;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 0.5rem;\n  }\n\n  &__desc {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0 0 1.5rem;\n    max-width: 28rem;\n  }\n}\n","// ============================================================\n// _platform-colors.scss — Auto-generated platform utilities\n// ============================================================\n@use 'variables' as *;\n\n// ── Background colors ─────────────────────────────────────────\n@each $name, $color in $platforms {\n  .bg-platform-#{$name}     { background-color: $color; }\n  .text-platform-#{$name}   { color: $color; }\n  .border-platform-#{$name} { border-color: $color; }\n\n  // Light tinted bg (10% opacity) for icon containers\n  .bg-platform-light-#{$name} {\n    background-color: rgba($color, 0.12);\n  }\n}\n","// ============================================================\n// _auth.scss — Login & Register pages\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Auth Layout ──────────────────────────────────────────────\n.auth-page {\n  display: flex;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: $slate-50;\n\n  // ── Left panel (hero image) — desktop only ───────────────\n  &__hero {\n    display: none;\n    position: relative;\n    overflow: hidden;\n\n    @include lg {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      flex-shrink: 0;\n    }\n\n    img {\n      position: absolute;\n      inset: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &-overlay {\n      position: absolute;\n      inset: 0;\n    }\n\n    &-content {\n      position: relative;\n      z-index: 10;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      padding: clamp(2rem, 5vw, 3rem);\n      height: 100%;\n    }\n\n    &-title {\n      font-family: $font-heading;\n      font-size: clamp(1.75rem, 3.5vw, 2.5rem);\n      font-weight: 700;\n      color: $white;\n      margin: 0 0 0.75rem;\n      line-height: 1.2;\n    }\n\n    &-subtitle {\n      font-size: $text-lg;\n      color: rgba($white, 0.8);\n      margin: 0;\n      max-width: 36rem;\n    }\n  }\n\n  // ── Right panel (form) ───────────────────────────────────\n  &__form-panel {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: clamp(1.5rem, 5vw, 3rem);\n    overflow-y: auto;\n  }\n\n  &__form-inner {\n    width: 100%;\n    max-width: 26rem;\n    animation: slideIn 0.35s ease-out;\n  }\n\n  // ── Logo ─────────────────────────────────────────────────\n  &__logo {\n    @include flex-start(0.75rem);\n    margin-bottom: 2rem;\n    text-decoration: none;\n\n    &-icon {\n      @include flex-center;\n      width: 3rem;\n      height: 3rem;\n      border-radius: $radius-xl;\n      background: linear-gradient(135deg, $indigo-500, $purple-500, $pink-500);\n      flex-shrink: 0;\n    }\n\n    &-name {\n      font-family: $font-heading;\n      font-size: 1.5rem;\n      font-weight: 700;\n      color: $slate-900;\n    }\n  }\n\n  // ── Headings ─────────────────────────────────────────────\n  &__title {\n    font-family: $font-heading;\n    font-size: $text-3xl;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 0.375rem;\n  }\n\n  &__subtitle {\n    font-size: $text-base;\n    color: $slate-500;\n    margin: 0 0 2rem;\n  }\n\n  // ── Form ─────────────────────────────────────────────────\n  &__form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.375rem;\n  }\n\n  &__label {\n    font-size: $text-sm;\n    font-weight: 600;\n    color: $slate-700;\n  }\n\n  &__error-msg {\n    font-size: $text-xs;\n    color: $red-600;\n  }\n\n  &__form-error {\n    padding: 0.75rem 1rem;\n    border-radius: $radius-lg;\n    background: $red-50;\n    border: 1px solid $red-200;\n    font-size: $text-sm;\n    color: $red-600;\n  }\n\n  // ── Submit button ────────────────────────────────────────\n  &__submit {\n    @include btn-base;\n    width: 100%;\n    height: 48px;\n    font-size: $text-base;\n    border-radius: $radius-full;\n    background: linear-gradient(135deg, $indigo-500, $purple-500);\n    color: $white;\n    box-shadow: $shadow-button;\n    border: none;\n    margin-top: 0.5rem;\n\n    @include hover-device {\n      &:hover {\n        background: linear-gradient(135deg, $indigo-600, $purple-600);\n        transform: translateY(-1px);\n        box-shadow: 0 6px 20px rgba($indigo-500, 0.45);\n      }\n    }\n\n    &__spinner {\n      width: 20px;\n      height: 20px;\n      border: 2px solid rgba($white, 0.3);\n      border-top-color: $white;\n      border-radius: $radius-full;\n      animation: spin 0.8s linear infinite;\n    }\n  }\n\n  // ── Footer link ──────────────────────────────────────────\n  &__footer {\n    margin-top: 1.5rem;\n    text-align: center;\n    font-size: $text-sm;\n    color: $slate-500;\n\n    a {\n      font-weight: 600;\n      color: $indigo-600;\n      text-decoration: none;\n\n      &:hover { color: $indigo-700; text-decoration: underline; }\n    }\n  }\n}\n","// ============================================================\n// _dashboard.scss — Dashboard page\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Welcome header ───────────────────────────────────────────\n.dashboard-welcome {\n  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);\n\n  &__title {\n    font-family: $font-heading;\n    font-size: clamp(1.5rem, 5vw, 2.25rem);\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 0.375rem;\n    line-height: 1.15;\n  }\n\n  &__subtitle {\n    font-size: $text-lg;\n    color: $slate-500;\n    margin: 0;\n  }\n}\n\n// ── Stats grid ───────────────────────────────────────────────\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(0.75rem, 2vw, 1.25rem);\n  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);\n\n  @include xs  { grid-template-columns: repeat(2, 1fr); }\n  @include lg  { grid-template-columns: repeat(4, 1fr); }\n}\n\n// ── Recent Posts card ────────────────────────────────────────\n.recent-posts-card {\n  @include card(0);\n  overflow: hidden;\n\n  &__header {\n    @include flex-between;\n    padding: clamp(1rem, 3vw, 1.5rem);\n    border-bottom: 1px solid $slate-100;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  &__header-left {\n    @include flex-start(0.75rem);\n  }\n\n  &__header-icon {\n    @include flex-center;\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: $radius-xl;\n    background: $indigo-50;\n    flex-shrink: 0;\n    color: $indigo-600;\n  }\n\n  &__header-title {\n    font-family: $font-heading;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0;\n    font-size: $text-base;\n  }\n\n  &__header-sub {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0.125rem 0 0;\n  }\n\n  // Loading state\n  &__loader {\n    @include flex-center;\n    padding: 2.5rem;\n\n    &-spinner {\n      width: 2rem;\n      height: 2rem;\n      border: 3px solid $slate-200;\n      border-top-color: $indigo-500;\n      border-radius: $radius-full;\n      animation: spin 0.8s linear infinite;\n    }\n  }\n}\n\n// ── Recent post row ──────────────────────────────────────────\n.post-row {\n  display: flex;\n  align-items: center;\n  gap: clamp(0.75rem, 2vw, 1rem);\n  padding: clamp(0.75rem, 2vw, 1rem) clamp(1rem, 3vw, 1.5rem);\n  border-bottom: 1px solid $slate-100;\n  transition: background $transition-fast;\n\n  &:last-child { border-bottom: none; }\n\n  @include hover-device {\n    &:hover { background: $slate-50; }\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__text {\n    font-size: $text-sm;\n    font-weight: 500;\n    color: $slate-900;\n    @include truncate;\n    margin: 0 0 0.25rem;\n  }\n\n  &__meta {\n    @include flex-start(0.75rem);\n    flex-wrap: wrap;\n  }\n\n  &__platforms {\n    @include flex-start(0.25rem);\n  }\n\n  &__date {\n    font-size: $text-xs;\n    color: $slate-400;\n  }\n\n  &__more {\n    font-size: $text-xs;\n    color: $slate-500;\n    margin-left: 0.25rem;\n  }\n\n  &__actions {\n    @include flex-start(0.5rem);\n    flex-shrink: 0;\n\n    // On very small screens, hide edit button\n    @include max-xs {\n      display: none;\n    }\n  }\n}\n","// ============================================================\n// _posts.scss — Posts list, AddPost, EditPost\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Posts list ───────────────────────────────────────────────\n.posts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n// ── Post card ────────────────────────────────────────────────\n.post-card {\n  @include card;\n  transition: box-shadow $transition-base, border-color $transition-base;\n\n  @include hover-device {\n    &:hover {\n      box-shadow: $shadow-card-hover;\n      border-color: $indigo-100;\n    }\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    @include sm {\n      flex-direction: row;\n      align-items: flex-start;\n    }\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__text {\n    font-size: $text-sm;\n    color: $slate-700;\n    margin: 0 0 0.625rem;\n    @include line-clamp(2);\n  }\n\n  &__meta {\n    @include flex-start(0.75rem);\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  &__platforms {\n    @include flex-start(0.25rem);\n    flex-wrap: wrap;\n  }\n\n  &__date {\n    font-size: $text-xs;\n    color: $slate-400;\n  }\n\n  &__actions {\n    @include flex-start(0.5rem);\n    flex-shrink: 0;\n    flex-wrap: wrap;\n\n    @include max-sm { width: 100%; }\n  }\n\n  // Image preview (if any)\n  &__image {\n    width: 100%;\n    border-radius: $radius-lg;\n    overflow: hidden;\n    aspect-ratio: 16/9;\n\n    @include sm {\n      width: 6rem;\n      flex-shrink: 0;\n      aspect-ratio: 1;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n}\n\n// ── Post Form (AddPost / EditPost) ───────────────────────────\n.post-form-page {\n  // Back button + header row\n  &__header {\n    @include flex-start(clamp(0.75rem, 2vw, 1rem));\n    margin-bottom: clamp(1.5rem, 4vw, 2rem);\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  &__title-group {\n    @include flex-start(clamp(0.75rem, 2vw, 1rem));\n  }\n\n  &__icon {\n    @include page-icon;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-size: $text-3xl;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0;\n  }\n\n  &__subtitle {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0.125rem 0 0;\n  }\n\n  // The card containing PostForm\n  &__card {\n    @include card;\n    padding: clamp(1.25rem, 4vw, 2rem);\n    max-width: 42rem;         // ~2xl\n    width: 100%;\n  }\n}\n\n// ── Post Form fields ─────────────────────────────────────────\n.post-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.375rem;\n  }\n\n  &__label {\n    font-size: $text-sm;\n    font-weight: 600;\n    color: $slate-700;\n  }\n\n  // Platform selector grid\n  &__platforms {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 120px), 1fr));\n    gap: 0.625rem;\n  }\n\n  &__platform-btn {\n    @include flex-start(0.5rem);\n    padding: 0.5rem 0.75rem;\n    border-radius: $radius-lg;\n    border: 1.5px solid $slate-200;\n    background: $white;\n    cursor: pointer;\n    font-size: $text-sm;\n    font-weight: 500;\n    color: $slate-600;\n    transition: border-color $transition-base, background $transition-base;\n    min-height: 44px;\n\n    &.selected {\n      border-color: $indigo-500;\n      background: $indigo-50;\n      color: $indigo-600;\n    }\n\n    @include hover-device {\n      &:hover:not(.selected) { background: $slate-50; border-color: $slate-300; }\n    }\n  }\n\n  // Scheduled date row\n  &__schedule-row {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    @include sm {\n      flex-direction: row;\n      align-items: center;\n    }\n  }\n\n  &__submit-row {\n    @include flex-between;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid $slate-100;\n\n    &-actions {\n      @include flex-start(0.75rem);\n      flex-wrap: wrap;\n    }\n  }\n}\n\n// ── Not Found state (EditPost) ───────────────────────────────\n.post-not-found {\n  @include card;\n  text-align: center;\n  padding: clamp(2rem, 6vw, 3.5rem);\n  max-width: 28rem;\n  margin: 0 auto;\n\n  &__title {\n    font-family: $font-heading;\n    font-size: $text-2xl;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 0.75rem;\n  }\n\n  &__desc {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0 0 1.5rem;\n  }\n}\n","// ============================================================\n// _analytics.scss — Analytics page\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Overview metric grid ─────────────────────────────────────\n.analytics-metrics-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(0.75rem, 2vw, 1.25rem);\n  margin-bottom: clamp(1.5rem, 4vw, 2rem);\n\n  @include xs  { grid-template-columns: repeat(2, 1fr); }\n  @include lg  { grid-template-columns: repeat(4, 1fr); }\n}\n\n// ── Charts grid ──────────────────────────────────────────────\n.analytics-charts-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(1rem, 3vw, 1.5rem);\n  margin-bottom: clamp(1.5rem, 4vw, 2rem);\n\n  @include lg { grid-template-columns: repeat(2, 1fr); }\n}\n\n// ── Chart card ───────────────────────────────────────────────\n.chart-card {\n  @include card;\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 1.25rem;\n    font-size: $text-lg;\n  }\n\n  &__body {\n    width: 100%;\n    min-height: 200px;\n\n    @include sm  { min-height: 240px; }\n    @include lg  { min-height: 300px; }\n  }\n\n  &__empty {\n    @include flex-center;\n    flex-direction: column;\n    gap: 0.5rem;\n    min-height: 200px;\n    color: $slate-400;\n\n    @include sm  { min-height: 240px; }\n    @include lg  { min-height: 300px; }\n  }\n}\n\n// ── Platform Breakdown ───────────────────────────────────────\n.platform-breakdown {\n  @include card;\n  margin-bottom: clamp(1.5rem, 4vw, 2rem);\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 1.25rem;\n    font-size: $text-lg;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  &__row {\n    @include flex-between;\n    padding: clamp(0.75rem, 2vw, 1rem);\n    border-radius: $radius-lg;\n    background: $slate-50;\n    transition: background $transition-base;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n\n    @include hover-device {\n      &:hover { background: $slate-100; }\n    }\n  }\n\n  &__row-left {\n    @include flex-start(clamp(0.75rem, 2vw, 1rem));\n  }\n\n  &__name {\n    font-weight: 600;\n    color: $slate-900;\n    font-size: $text-sm;\n    text-transform: capitalize;\n    margin: 0;\n  }\n\n  &__handle {\n    font-size: $text-xs;\n    color: $slate-500;\n    margin: 0.125rem 0 0;\n  }\n\n  &__stats {\n    @include flex-start(clamp(1rem, 4vw, 2rem));\n    flex-wrap: wrap;\n  }\n\n  &__stat {\n    text-align: right;\n    min-width: 4rem;\n\n    &-label {\n      font-size: $text-xs;\n      color: $slate-500;\n      margin: 0 0 0.125rem;\n    }\n\n    &-value {\n      font-weight: 700;\n      color: $slate-900;\n      font-size: $text-sm;\n      margin: 0;\n    }\n  }\n}\n\n// ── Top Posts table ──────────────────────────────────────────\n.top-posts-card {\n  @include card;\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 1.25rem;\n    font-size: $text-lg;\n  }\n\n  // Horizontal scroll wrapper\n  &__table-wrap {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    border-radius: $radius-lg;\n    margin: -0.25rem;\n    padding: 0.25rem;\n\n    @include touch-device {\n      scrollbar-width: none;\n      &::-webkit-scrollbar { display: none; }\n    }\n  }\n\n  table {\n    min-width: 640px;\n    width: 100%;\n    border-collapse: collapse;\n\n    th {\n      text-align: left;\n      padding: 0.75rem 1rem;\n      font-size: $text-xs;\n      font-weight: 600;\n      color: $slate-500;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      border-bottom: 1px solid $slate-100;\n\n      &:not(:first-child) { text-align: right; }\n    }\n\n    td {\n      padding: 0.75rem 1rem;\n      font-size: $text-sm;\n      color: $slate-700;\n      border-bottom: 1px solid $slate-100;\n      vertical-align: middle;\n\n      &:not(:first-child) { text-align: right; }\n\n      &.content-cell {\n        max-width: 200px;\n\n        @include lg { max-width: 280px; }\n\n        p { @include truncate; margin: 0; }\n      }\n    }\n\n    tr:last-child td { border-bottom: none; }\n\n    @include hover-device {\n      tr:hover td { background: $slate-50; }\n    }\n  }\n\n  &__engagement-badge {\n    display: inline-flex;\n    padding: 0.2rem 0.6rem;\n    border-radius: $radius-full;\n    background: $green-100;\n    color: $green-700;\n    font-size: $text-xs;\n    font-weight: 700;\n  }\n\n  &__empty {\n    @include flex-center;\n    flex-direction: column;\n    padding: 2.5rem;\n    color: $slate-400;\n    gap: 0.5rem;\n    font-size: $text-sm;\n  }\n}\n","// ============================================================\n// _inbox.scss — Inbox page (3-column panel layout)\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Inbox container ──────────────────────────────────────────\n// Mobile: stacked full-screen panel views (tab-controlled)\n// Tablet: 2-column (list + thread)\n// Desktop: 3-column (filters | list | thread)\n.inbox-layout {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.75rem, 2vw, 1rem);\n  height: calc(100dvh - 180px); // remaining after topbar + page header\n  min-height: 400px;\n\n  @include md {\n    flex-direction: row;\n    height: calc(100dvh - 160px);\n  }\n\n  @include lg {\n    height: calc(100dvh - 140px);\n  }\n}\n\n// ── Filters panel ────────────────────────────────────────────\n.inbox-filters {\n  @include card(1rem);\n  @include scrollable;\n  flex-shrink: 0;\n\n  // Mobile: horizontal scrolling tab strip\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  height: auto;\n\n  @include touch-device {\n    scrollbar-width: none;\n    &::-webkit-scrollbar { display: none; }\n  }\n\n  @include md {\n    flex-direction: column;\n    width: 200px;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 1rem;\n    gap: 1.25rem;\n  }\n\n  @include lg {\n    width: 220px;\n  }\n\n  &__section-title {\n    font-size: $text-xs;\n    font-weight: 600;\n    color: $slate-400;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    padding: 0 0.5rem;\n    white-space: nowrap;\n\n    // Hide labels on mobile (horizontal strip)\n    @include max-md { display: none; }\n  }\n\n  &__all-btn {\n    @include flex-between;\n    padding: 0.625rem 1rem;\n    border-radius: $radius-lg;\n    font-weight: 500;\n    font-size: $text-sm;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    transition: background $transition-base, color $transition-base;\n    min-height: 40px;\n    white-space: nowrap;\n    color: $slate-700;\n\n    &.active {\n      background: $indigo-50;\n      color: $indigo-700;\n    }\n\n    @include hover-device {\n      &:not(.active):hover { background: $slate-50; }\n    }\n  }\n\n  &__filter-btn {\n    @include flex-start(0.625rem);\n    padding: 0.5rem 0.875rem;\n    border-radius: $radius-lg;\n    font-weight: 500;\n    font-size: $text-sm;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    transition: background $transition-base, color $transition-base;\n    min-height: 40px;\n    white-space: nowrap;\n    color: $slate-600;\n\n    &.active {\n      background: $indigo-50;\n      color: $indigo-700;\n    }\n\n    @include hover-device {\n      &:not(.active):hover { background: $slate-50; }\n    }\n  }\n\n  &__unread-badge {\n    margin-left: auto;\n    padding: 0.125rem 0.5rem;\n    border-radius: $radius-full;\n    background: $red-500;\n    color: $white;\n    font-size: 0.65rem;\n    font-weight: 700;\n    min-width: 1.25rem;\n    text-align: center;\n  }\n\n  &__divider {\n    @include max-md { display: none; }\n    border: none;\n    border-top: 1px solid $slate-100;\n    margin: 0;\n  }\n}\n\n// ── Messages list panel ──────────────────────────────────────\n.inbox-list {\n  @include card(0);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n  min-height: 300px;\n\n  @include md {\n    width: 260px;\n    flex: none;\n    height: 100%;\n  }\n\n  @include lg { width: 300px; }\n\n  &__header {\n    @include flex-between;\n    padding: 0.875rem 1rem;\n    border-bottom: 1px solid $slate-100;\n    flex-shrink: 0;\n\n    &-count {\n      font-weight: 600;\n      color: $slate-700;\n      font-size: $text-sm;\n    }\n  }\n\n  &__scroll {\n    flex: 1;\n    @include scrollable;\n  }\n\n  &__empty {\n    @include flex-center;\n    flex-direction: column;\n    gap: 0.5rem;\n    height: 100%;\n    min-height: 200px;\n    color: $slate-400;\n    font-size: $text-sm;\n  }\n}\n\n// ── Message item ─────────────────────────────────────────────\n.message-item {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.875rem 1rem;\n  border-bottom: 1px solid $slate-100;\n  cursor: pointer;\n  transition: background $transition-fast;\n  position: relative;\n\n  &.unread {\n    border-left: 3px solid $blue-500;\n    padding-left: calc(1rem - 3px);\n  }\n\n  &.selected { background: $indigo-50; }\n\n  @include hover-device {\n    &:not(.selected):hover { background: $slate-50; }\n  }\n\n  &__avatar-wrap {\n    position: relative;\n    flex-shrink: 0;\n\n    img {\n      width: 2.5rem;\n      height: 2.5rem;\n      border-radius: $radius-full;\n      object-fit: cover;\n    }\n  }\n\n  &__platform-badge {\n    position: absolute;\n    bottom: -2px;\n    right: -2px;\n  }\n\n  &__content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__header-row {\n    @include flex-between;\n    margin-bottom: 0.2rem;\n  }\n\n  &__sender {\n    font-size: $text-sm;\n    font-weight: 500;\n    color: $slate-700;\n    @include truncate;\n\n    &.unread {\n      font-weight: 700;\n      color: $slate-900;\n    }\n  }\n\n  &__time {\n    font-size: $text-xs;\n    color: $slate-400;\n    white-space: nowrap;\n    margin-left: 0.5rem;\n  }\n\n  &__preview {\n    font-size: $text-sm;\n    color: $slate-500;\n    @include truncate;\n    margin-bottom: 0.25rem;\n  }\n\n  &__tags {\n    @include flex-start(0.375rem);\n  }\n\n  &__type-tag {\n    font-size: 0.65rem;\n    padding: 0.1rem 0.4rem;\n    border-radius: $radius-full;\n    background: $slate-100;\n    color: $slate-500;\n    text-transform: uppercase;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n  }\n}\n\n// ── Thread panel ─────────────────────────────────────────────\n.inbox-thread {\n  @include card(0);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n\n  @include md { height: 100%; }\n\n  // Empty state\n  &__empty {\n    @include flex-center;\n    flex-direction: column;\n    gap: 0.75rem;\n    height: 100%;\n    min-height: 200px;\n    color: $slate-400;\n\n    &-title {\n      font-size: $text-base;\n      font-weight: 600;\n    }\n  }\n\n  &__header {\n    @include flex-between;\n    padding: clamp(0.875rem, 2vw, 1.25rem);\n    border-bottom: 1px solid $slate-100;\n    gap: 0.75rem;\n    flex-shrink: 0;\n  }\n\n  &__sender {\n    @include flex-start(0.875rem);\n\n    img {\n      width: 3rem;\n      height: 3rem;\n      border-radius: $radius-full;\n      object-fit: cover;\n      flex-shrink: 0;\n    }\n  }\n\n  &__name {\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0;\n    font-size: $text-base;\n  }\n\n  &__handle {\n    font-size: $text-sm;\n    color: $slate-500;\n    margin: 0.125rem 0 0;\n  }\n\n  &__body {\n    flex: 1;\n    @include scrollable;\n    padding: clamp(1rem, 3vw, 1.5rem);\n  }\n\n  &__post-preview {\n    padding: 0.875rem 1rem;\n    border-radius: $radius-lg;\n    background: $slate-100;\n    margin-bottom: 1rem;\n\n    &-label {\n      font-size: $text-xs;\n      color: $slate-500;\n      margin: 0 0 0.25rem;\n    }\n\n    &-text {\n      font-size: $text-sm;\n      color: $slate-700;\n      margin: 0;\n    }\n  }\n\n  &__message-text {\n    color: $slate-700;\n    line-height: 1.65;\n    font-size: $text-base;\n    margin: 0 0 0.75rem;\n  }\n\n  &__time {\n    font-size: $text-sm;\n    color: $slate-400;\n  }\n\n  &__reply-sent {\n    margin-top: 1.5rem;\n    padding: 0.875rem 1rem;\n    border-radius: $radius-lg;\n    background: $green-50;\n    border: 1px solid $green-100;\n\n    &-label {\n      font-size: $text-xs;\n      color: $green-600;\n      font-weight: 600;\n      margin: 0 0 0.375rem;\n    }\n\n    &-text {\n      font-size: $text-sm;\n      color: #166534;\n      margin: 0;\n    }\n  }\n\n  // Reply composer\n  &__composer {\n    padding: clamp(0.75rem, 2vw, 1rem);\n    border-top: 1px solid $slate-100;\n    flex-shrink: 0;\n\n    textarea {\n      @include input-base;\n      height: auto;\n      min-height: 80px;\n      padding: 0.75rem 1rem;\n      border-radius: $radius-lg;\n      resize: none;\n    }\n  }\n\n  &__composer-footer {\n    @include flex-between;\n    margin-top: 0.625rem;\n\n    &-count {\n      font-size: $text-xs;\n      color: $slate-400;\n    }\n  }\n}\n\n// Mobile: show only one panel at a time with tab navigation\n.inbox-mobile-tabs {\n  display: flex;\n  gap: 0;\n  background: $slate-100;\n  border-radius: $radius-lg;\n  padding: 0.25rem;\n  margin-bottom: 0.75rem;\n\n  @include md { display: none; }\n\n  &__tab {\n    flex: 1;\n    padding: 0.5rem 0.75rem;\n    border-radius: $radius-md;\n    font-size: $text-xs;\n    font-weight: 600;\n    border: none;\n    background: transparent;\n    color: $slate-600;\n    cursor: pointer;\n    text-align: center;\n    transition: background $transition-base, color $transition-base;\n    min-height: 36px;\n\n    &.active {\n      background: $white;\n      box-shadow: $shadow-sm;\n      color: $indigo-600;\n    }\n  }\n}\n","// ============================================================\n// _scheduler.scss — Scheduler (Calendar & List views)\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Scheduler layout ─────────────────────────────────────────\n.scheduler-calendar-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(1rem, 3vw, 1.5rem);\n\n  @include lg { grid-template-columns: 2fr 1fr; }\n}\n\n// ── Calendar card ────────────────────────────────────────────\n.calendar-card {\n  @include card;\n  overflow: hidden;\n\n  // Override react-calendar styles for responsive fit\n  .react-calendar {\n    font-family: $font-body;\n    border: none;\n    width: 100%;\n    font-size: $text-sm;\n\n    &__navigation {\n      button {\n        font-size: $text-base;\n        font-weight: 600;\n        color: $slate-700;\n        border-radius: $radius-md;\n        min-height: 44px;\n\n        @include hover-device {\n          &:hover { background: $slate-100; }\n        }\n      }\n    }\n\n    &__month-view__weekdays__weekday {\n      font-size: $text-xs;\n      font-weight: 600;\n      color: $slate-400;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      text-decoration: none;\n\n      abbr { text-decoration: none; }\n    }\n\n    &__tile {\n      font-size: $text-sm;\n      border-radius: $radius-lg;\n      min-height: 44px;     // touch-friendly tap target\n      padding: 0.5rem 0.25rem;\n      transition: background $transition-base;\n      position: relative;\n\n      @include hover-device {\n        &:not(.react-calendar__tile--active):not(.react-calendar__tile--now):hover {\n          background: $slate-100;\n        }\n      }\n\n      &--now {\n        background: $indigo-50;\n        color: $indigo-700;\n        font-weight: 700;\n      }\n\n      &--active {\n        background: $indigo-500 !important;\n        color: $white !important;\n        border-radius: $radius-lg;\n      }\n    }\n  }\n}\n\n// ── Calendar tile dots ───────────────────────────────────────\n.calendar-tile-dots {\n  display: flex;\n  justify-content: center;\n  gap: 2px;\n  margin-top: 3px;\n\n  &__dot {\n    width: 6px;\n    height: 6px;\n    border-radius: $radius-full;\n\n    &--published  { background: $green-500; }\n    &--scheduled  { background: $blue-500; }\n    &--draft      { background: $amber-500; }\n  }\n\n  &__more {\n    font-size: 0.55rem;\n    color: $slate-500;\n    line-height: 1;\n    align-self: center;\n  }\n}\n\n// ── Selected date panel ──────────────────────────────────────\n.selected-date-panel {\n  @include card;\n  @include scrollable;\n  max-height: 600px;\n\n  @include lg { max-height: none; }\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    color: $slate-900;\n    margin: 0 0 1rem;\n    font-size: $text-lg;\n  }\n\n  &__empty {\n    font-size: $text-sm;\n    color: $slate-500;\n    text-align: center;\n    padding: 1.5rem 0;\n  }\n\n  &__posts {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n}\n\n// ── Scheduled post item (in selected date panel) ─────────────\n.scheduled-post-item {\n  padding: clamp(0.75rem, 2vw, 1rem);\n  border-radius: $radius-lg;\n  background: $slate-50;\n  border: 1px solid $slate-100;\n  transition: border-color $transition-base;\n\n  @include hover-device {\n    &:hover { border-color: $indigo-100; }\n  }\n\n  &__content {\n    font-size: $text-sm;\n    color: $slate-700;\n    margin: 0 0 0.625rem;\n    @include line-clamp(2);\n  }\n\n  &__footer {\n    @include flex-between;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  &__platforms {\n    @include flex-start(0.25rem);\n    flex-wrap: wrap;\n  }\n\n  &__actions {\n    @include flex-start(0.375rem);\n  }\n}\n\n// ── List view ────────────────────────────────────────────────\n.scheduler-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n\n    button {\n      @include btn-base;\n      padding: 0.4rem 0.875rem;\n      border-radius: $radius-full;\n      font-size: $text-sm;\n      font-weight: 500;\n      background: $slate-100;\n      color: $slate-600;\n      border: none;\n      min-height: 36px;\n\n      &.active {\n        background: $indigo-50;\n        color: $indigo-600;\n      }\n\n      @include hover-device {\n        &:not(.active):hover { background: $slate-200; }\n      }\n    }\n  }\n}\n\n// ── Scheduler table ──────────────────────────────────────────\n.scheduler-table-wrap {\n  @include card(0);\n  overflow: hidden;\n\n  &__scroll {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n\n    @include touch-device {\n      scrollbar-width: none;\n      &::-webkit-scrollbar { display: none; }\n    }\n  }\n\n  table {\n    min-width: 600px;\n    width: 100%;\n    border-collapse: collapse;\n\n    thead {\n      background: $slate-50;\n      border-bottom: 1px solid $slate-100;\n\n      th {\n        text-align: left;\n        padding: 1rem 1.25rem;\n        font-size: $text-sm;\n        font-weight: 600;\n        color: $slate-600;\n        white-space: nowrap;\n      }\n    }\n\n    tbody tr {\n      border-bottom: 1px solid $slate-100;\n      transition: background $transition-fast;\n\n      &:last-child { border-bottom: none; }\n\n      @include hover-device {\n        &:hover { background: $slate-50; }\n      }\n\n      td {\n        padding: 0.875rem 1.25rem;\n        font-size: $text-sm;\n        color: $slate-700;\n        vertical-align: middle;\n      }\n    }\n\n    .content-cell {\n      max-width: 220px;\n\n      @include xl { max-width: 320px; }\n\n      p { @include truncate; margin: 0; }\n    }\n\n    .platforms-cell {\n      display: flex;\n      gap: 0.25rem;\n      align-items: center;\n    }\n\n    .actions-cell {\n      display: flex;\n      gap: 0.375rem;\n      align-items: center;\n      flex-wrap: wrap;\n    }\n  }\n}\n\n// ── Empty state for list view ─────────────────────────────────\n.scheduler-empty {\n  @include card;\n  @include flex-center;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: clamp(2rem, 6vw, 4rem);\n  color: $slate-400;\n  text-align: center;\n\n  svg { opacity: 0.5; }\n\n  p {\n    font-size: $text-sm;\n    margin: 0;\n  }\n}\n","// ============================================================\n// _accounts.scss — Connected Accounts page\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Counter badge ────────────────────────────────────────────\n.accounts-counter {\n  padding: 0.375rem 1rem;\n  border-radius: $radius-full;\n  background: $indigo-50;\n  border: 1px solid $indigo-100;\n  font-size: $text-sm;\n  font-weight: 600;\n  color: $indigo-600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n// ── Platforms grid ───────────────────────────────────────────\n.accounts-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: clamp(0.75rem, 2vw, 1rem);\n\n  @include xs  { grid-template-columns: repeat(2, 1fr); }\n  @include sm  { grid-template-columns: repeat(3, 1fr); }\n  @include md  { grid-template-columns: repeat(3, 1fr); }\n  @include lg  { grid-template-columns: repeat(4, 1fr); }\n  @include xl  { grid-template-columns: repeat(5, 1fr); }\n}\n\n// ── Platform card ────────────────────────────────────────────\n.platform-connect-card {\n  @include card(clamp(1rem, 3vw, 1.25rem));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.75rem;\n  transition: transform $transition-base, box-shadow $transition-base, border-color $transition-base;\n  cursor: pointer;\n\n  @include hover-device {\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: $shadow-card-hover;\n    }\n  }\n\n  @include touch-device {\n    &:active { transform: scale(0.97); }\n  }\n\n  &.connected {\n    border-color: $green-100;\n    background: linear-gradient(135deg, $white 60%, $green-50);\n  }\n\n  &__icon-wrap {\n    @include flex-center;\n    width: clamp(3rem, 8vw, 3.5rem);\n    height: clamp(3rem, 8vw, 3.5rem);\n    border-radius: $radius-xl;\n  }\n\n  &__name {\n    font-weight: 600;\n    font-size: $text-sm;\n    color: $slate-900;\n    text-transform: capitalize;\n    margin: 0;\n  }\n\n  &__account {\n    font-size: $text-xs;\n    color: $slate-500;\n    margin: -0.375rem 0 0;\n    @include truncate;\n    max-width: 100%;\n  }\n\n  &__status {\n    font-size: $text-xs;\n  }\n\n  &__action {\n    @include btn-base;\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    border-radius: $radius-lg;\n    font-size: $text-xs;\n    font-weight: 600;\n    min-height: 38px;\n\n    &--connect {\n      background: $indigo-500;\n      color: $white;\n\n      @include hover-device {\n        &:hover { background: $indigo-600; }\n      }\n    }\n\n    &--disconnect {\n      background: $slate-100;\n      color: $slate-600;\n      border: none;\n\n      @include hover-device {\n        &:hover { background: $red-50; color: $red-600; }\n      }\n    }\n  }\n}\n\n// ── Connected indicator dot ───────────────────────────────────\n.connected-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: $radius-full;\n  background: $green-500;\n  display: inline-block;\n  flex-shrink: 0;\n\n  &--disconnected { background: $slate-300; }\n}\n","// Core Variables for a sleek, modern aesthetic\n$bg-color: #0a0a0a;\n$text-primary: #f4f4f5;\n$text-secondary: #a1a1aa;\n$brand-highlight: #ff3366; \n$font-stack: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n.memat-media-app {\n  font-family: $font-stack;\n  background-color: $bg-color;\n  color: $text-primary;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n\n  // Reusable Buttons\n  .btn-primary, .btn-secondary {\n    padding: 12px 28px;\n    font-size: 1rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-radius: 4px;\n    text-decoration: none;\n    display: inline-block;\n  }\n\n  .btn-primary {\n    background-color: $text-primary;\n    color: $bg-color;\n    border: 2px solid $text-primary;\n    \n    &:hover {\n      background-color: $brand-highlight;\n      border-color: $brand-highlight;\n      color: #fff;\n    }\n  }\n\n  .btn-secondary {\n    background-color: transparent;\n    color: $text-primary;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n\n    &:hover {\n      border-color: $text-primary;\n      background-color: rgba(255, 255, 255, 0.05);\n    }\n  }\n\n  // 1. HEADER\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px 5%;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    backdrop-filter: blur(10px);\n    position: sticky;\n    top: 0;\n    z-index: 100;\n\n    &__logo {\n      font-size: 1.5rem;\n      font-weight: 800;\n      letter-spacing: 2px;\n      text-transform: uppercase;\n    }\n\n    &__nav {\n      display: flex;\n      gap: 40px;\n      align-items: center;\n\n      a {\n        color: $text-primary;\n        text-decoration: none;\n        font-weight: 500;\n        font-size: 0.95rem;\n        transition: color 0.2s ease;\n        \n        &:not(.btn-primary):hover {\n          color: $brand-highlight;\n        }\n      }\n\n      @media (max-width: 768px) {\n        display: none; // Collapse nav on mobile for a hamburger menu later\n      }\n    }\n  }\n\n  // 2. MAIN BODY\n  .main-content {\n    flex: 1;\n  }\n\n  .hero {\n    padding: 140px 5%;\n    text-align: center;\n    max-width: 1000px;\n    margin: 0 auto;\n\n    &__title {\n      font-size: clamp(3rem, 8vw, 6rem);\n      font-weight: 900;\n      line-height: 1.05;\n      margin-bottom: 24px;\n      text-transform: uppercase;\n      letter-spacing: -1px;\n\n      .text-highlight {\n        color: $brand-highlight;\n        font-style: italic;\n        display: inline-block;\n      }\n    }\n\n    &__subtitle {\n      font-size: 1.25rem;\n      color: $text-secondary;\n      margin-bottom: 48px;\n      max-width: 600px;\n      margin-left: auto;\n      margin-right: auto;\n      line-height: 1.6;\n    }\n\n    &__actions {\n      display: flex;\n      gap: 20px;\n      justify-content: center;\n      \n      @media (max-width: 480px) {\n        flex-direction: column;\n      }\n    }\n  }\n\n  .featured-brands {\n    padding: 100px 5%;\n    background-color: #111;\n\n    .section-title {\n      font-size: 2rem;\n      margin-bottom: 56px;\n      text-align: center;\n      text-transform: uppercase;\n      letter-spacing: 1.5px;\n      font-weight: 800;\n    }\n\n    .brand-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n      gap: 32px;\n      max-width: 1200px;\n      margin: 0 auto;\n    }\n\n    .brand-card {\n      background-color: $bg-color;\n      padding: 48px 40px;\n      border: 1px solid rgba(255, 255, 255, 0.05);\n      border-radius: 8px;\n      transition: transform 0.3s ease, border-color 0.3s ease;\n\n      h3 {\n        font-size: 1.75rem;\n        margin-bottom: 16px;\n        color: $brand-highlight;\n        font-weight: 700;\n      }\n\n      p {\n        color: $text-secondary;\n        line-height: 1.7;\n        font-size: 1rem;\n      }\n\n      &:hover {\n        transform: translateY(-8px);\n        border-color: rgba(255, 255, 255, 0.2);\n      }\n    }\n  }\n\n  // 3. FOOTER\n  .footer {\n    padding: 80px 5% 40px;\n    background-color: #050505;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n\n    &__content {\n      display: flex;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      gap: 40px;\n      margin-bottom: 64px;\n      max-width: 1200px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    &__brand {\n      h2 {\n        font-size: 1.75rem;\n        font-weight: 800;\n        margin-bottom: 16px;\n        letter-spacing: 1px;\n      }\n      p {\n        color: $text-secondary;\n      }\n    }\n\n    &__links {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      a {\n        color: $text-secondary;\n        text-decoration: none;\n        transition: color 0.2s ease;\n        font-weight: 500;\n\n        &:hover {\n          color: $text-primary;\n        }\n      }\n    }\n\n    &__bottom {\n      text-align: center;\n      color: rgba(255, 255, 255, 0.4);\n      font-size: 0.875rem;\n      padding-top: 40px;\n      border-top: 1px solid rgba(255, 255, 255, 0.05);\n      max-width: 1200px;\n      margin: 0 auto;\n    }\n  }\n}","\n// ============================================================\n// _terms.scss — Shared Legal Pages (Terms & Privacy)\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Page shell ───────────────────────────────────────────────\n.legal-page {\n  background: $slate-50;\n  min-height: 100vh;\n  padding: clamp(2.5rem, 6vw, 5rem) 0 clamp(4rem, 8vw, 6rem);\n\n  &__container {\n    max-width: 46rem;\n    margin: 0 auto;\n    padding: 0 clamp(1.25rem, 4vw, 2rem);\n  }\n\n  // ── Header ─────────────────────────────────────────────────\n  &__header {\n    margin-bottom: clamp(2rem, 5vw, 3rem);\n  }\n\n  &__eyebrow {\n    font-size: $text-sm;\n    font-weight: 600;\n    color: $indigo-600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin: 0 0 0.75rem;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-size: clamp(1.75rem, 6vw, 2.75rem);\n    font-weight: 700;\n    color: $slate-900;\n    line-height: 1.15;\n    margin: 0 0 1rem;\n  }\n\n  &__intro {\n    font-size: $text-lg;\n    line-height: 1.65;\n    color: $slate-500;\n    margin: 0;\n  }\n}\n\n// ── Table of contents ────────────────────────────────────────\n.legal-toc {\n  @include card(0);\n  padding: clamp(1.25rem, 3vw, 1.75rem);\n  margin-bottom: clamp(2rem, 5vw, 3rem);\n\n  &__label {\n    font-size: $text-xs;\n    font-weight: 600;\n    color: $slate-400;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin: 0 0 0.75rem;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n\n    @include xs {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    a {\n      font-size: $text-sm;\n      font-weight: 500;\n      color: $slate-900;\n      text-decoration: none;\n      transition: color $transition-fast;\n\n      @include hover-device {\n        &:hover {\n          color: $indigo-600;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n// ── Sections ─────────────────────────────────────────────────\n.legal-sections {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.5rem, 4vw, 2rem);\n}\n\n.legal-section {\n  @include card(0);\n  padding: clamp(1.5rem, 4vw, 2.25rem);\n  scroll-margin-top: 2rem;\n\n  &__head {\n    @include flex-start(0.875rem);\n    margin-bottom: 0.875rem;\n  }\n\n  &__index {\n    @include flex-center;\n    flex-shrink: 0;\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: $radius-xl;\n    background: $indigo-50;\n    color: $indigo-600;\n    font-family: $font-heading;\n    font-weight: 700;\n    font-size: $text-sm;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    font-size: clamp(1.05rem, 3vw, 1.25rem);\n    color: $slate-900;\n    margin: 0;\n    line-height: 1.3;\n  }\n\n  &__body {\n    font-size: $text-base;\n    line-height: 1.7;\n    color: $slate-500;\n    margin: 0 0 0.5rem;\n  }\n\n  &__list-label {\n    font-weight: 600;\n    color: $slate-900;\n  }\n\n  &__list,\n  &__bullets,\n  &__contact {\n    list-style: none;\n    margin: 0.75rem 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    li {\n      font-size: $text-base;\n      line-height: 1.7;\n      color: $slate-500;\n      padding-left: 1.25rem;\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0.7em;\n        width: 0.375rem;\n        height: 0.375rem;\n        border-radius: $radius-full;\n        background: $indigo-500;\n      }\n\n      a {\n        color: $indigo-600;\n        font-weight: 500;\n        text-decoration: none;\n\n        @include hover-device {\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n  }\n\n  &__contact li::before {\n    background: $slate-400;\n  }\n}","// ============================================================\n// _terms.scss — Terms & Conditions / Privacy Policy page\n// ============================================================\n@use 'variables' as *;\n@use 'mixins'    as *;\n\n// ── Page shell ───────────────────────────────────────────────\n.legal-page {\n  background: $slate-50;\n  min-height: 100vh;\n  padding: clamp(2.5rem, 6vw, 5rem) 0 clamp(4rem, 8vw, 6rem);\n\n  &__container {\n    max-width: 46rem;\n    margin: 0 auto;\n    padding: 0 clamp(1.25rem, 4vw, 2rem);\n  }\n\n  // ── Header ─────────────────────────────────────────────────\n  &__header {\n    margin-bottom: clamp(2rem, 5vw, 3rem);\n  }\n\n  &__eyebrow {\n    font-size: $text-sm;\n    font-weight: 600;\n    color: $indigo-600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin: 0 0 0.75rem;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-size: clamp(1.75rem, 6vw, 2.75rem);\n    font-weight: 700;\n    color: $slate-900;\n    line-height: 1.15;\n    margin: 0 0 1rem;\n  }\n\n  &__intro {\n    font-size: $text-lg;\n    line-height: 1.65;\n    color: $slate-500;\n    margin: 0;\n  }\n}\n\n// ── Table of contents ────────────────────────────────────────\n.legal-toc {\n  @include card(0);\n  padding: clamp(1.25rem, 3vw, 1.75rem);\n  margin-bottom: clamp(2rem, 5vw, 3rem);\n\n  &__label {\n    font-size: $text-xs;\n    font-weight: 600;\n    color: $slate-400;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin: 0 0 0.75rem;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n\n    @include xs {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    a {\n      font-size: $text-sm;\n      font-weight: 500;\n      color: $slate-900;\n      text-decoration: none;\n      transition: color $transition-fast;\n\n      @include hover-device {\n        &:hover {\n          color: $indigo-600;\n          text-decoration: underline;\n        }\n      }\n    }\n  }\n}\n\n// ── Sections ─────────────────────────────────────────────────\n.legal-sections {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.5rem, 4vw, 2rem);\n}\n\n.legal-section {\n  @include card(0);\n  padding: clamp(1.5rem, 4vw, 2.25rem);\n  scroll-margin-top: 2rem; // Gives breathing room when anchor links jump down\n\n  &__head {\n    @include flex-start(0.875rem);\n    margin-bottom: 0.875rem;\n  }\n\n  &__index {\n    @include flex-center;\n    flex-shrink: 0;\n    width: 2.25rem;\n    height: 2.25rem;\n    border-radius: $radius-xl;\n    background: $indigo-50;\n    color: $indigo-600;\n    font-family: $font-heading;\n    font-weight: 700;\n    font-size: $text-sm;\n  }\n\n  &__title {\n    font-family: $font-heading;\n    font-weight: 700;\n    font-size: clamp(1.05rem, 3vw, 1.25rem);\n    color: $slate-900;\n    margin: 0;\n    line-height: 1.3;\n  }\n\n  &__body {\n    font-size: $text-base;\n    line-height: 1.7;\n    color: $slate-500;\n    margin: 0 0 0.5rem;\n  }\n\n  &__list-label {\n    font-weight: 600;\n    color: $slate-900;\n  }\n\n  // Styles shared across standard lists, bullets, and contacts\n  &__list,\n  &__bullets,\n  &__contact {\n    list-style: none;\n    margin: 0.75rem 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    li {\n      font-size: $text-base;\n      line-height: 1.7;\n      color: $slate-500;\n      padding-left: 1.25rem;\n      position: relative;\n\n      // Custom bullet point design\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0.7em;\n        width: 0.375rem;\n        height: 0.375rem;\n        border-radius: $radius-full;\n        background: $indigo-500;\n      }\n\n      a {\n        color: $indigo-600;\n        font-weight: 500;\n        text-decoration: none;\n\n        @include hover-device {\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n  }\n\n  // Differentiates the contact bullet points from standard bullet points\n  &__contact li::before {\n    background: $slate-400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
